import { useEffect, useMemo, useRef, useState } from "react";
import {
  AlertCircle,
  Award,
  Check,
  Database,
  Info,
  Printer,
  Upload,
  X,
} from "react-feather";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { TextArea } from "semantic-ui-react";
import {
  CalculateTaxAmountOfItem,
  taxdropdown,
  taxRate,
} from "../../api/DeductionItemApi";
import {
  checkDuplicateInspections,
  createFleetCharges,
  getDynamicTemplatesByManagementTypeAndCategory,
  getFleetChargesByHeaderId,
  getInspectionByTdhId,
  getInspectionDriverDetails,
  getReportTypeDetails,
  getVehicleModalTyreDetails,
  inactiveFleetCharges,
  saveDocumentManagement,
  saveInspection,
  updateDocumentManagement,
  updateInspection,
} from "../../api/documentManagementApi";
import {
  addAndUpload,
  deleteDocumentList,
  getDocumentByOpeAndRef,
  updateAndUpload,
} from "../../api/documentUpload";
import {
  getAllChargesWithItem,
  getChargeTaxCalculation,
  getExchangeSelectionValues,
} from "../../api/finance/addChargesApi";
import {
  downloadGeneralReportDocument,
  downloadInspectionReportDocument,
} from "../../api/inpsectionDocDownloadApi";
import {
  getBulkDropdownData,
  getDropdownData,
  getFieldValuesByTableAndId,
  getOtherRefDetails,
  getOtherRefSearchDropdown,
  getTextByValueAndKey,
} from "../../api/keyvalue";
import {
  getDynamicTemplateById,
  getItemChargeInfo,
} from "../../api/templateApi";
import { tyreDropdown } from "../../api/tyreApi";
import { FORMS, MODULES } from "../../const";
import { formatToDateOnlyFromJsonDate } from "../../dateConfig";
import useFirstAndLastAuthorizedTab from "../../hooks/useFirstAndLastAuthorizedTab";
import useNextAndPreviousAuthority from "../../hooks/useNextAndPreviousAuthority";
import useUserCompany from "../../hooks/useUserCompany";
import DocumentUpload from "../DocumentUpload";
import Grid from "../Grid";
import Button from "../input/Button";
import CheckBox from "../input/CheckBox";
import Dropdown from "../input/Dropdown";
import Input from "../input/Input";
import SearchDropdown from "../input/SearchDropdown";
import LoadingSpinner from "../LoadingSpinner";
import Modal from "../Modal";
import ButtonRenderer from "../renderer/ButtonRenderer";
import SelectRenderer from "../renderer/SelectRenderer";
import {
  DateOnlyCellRenderer,
  ResizableScrollingTextRenderer,
} from "../renderer/StyleRenderer";
import Tab from "../Tab";
import TooltipIcon from "../ToolTipIcon";
import { documentManagementValidation } from "../validations/DocumentManagementValidation";

const DynamicRow = ({
  rowNo,
  dyfId,
  dyfField,
  dyfFieldType,
  dyfRequired,
  dfyAmount,
  dfyAmountInfo,
  dfyDiscount,
  dfyDiscountInfo,
  dynamicDropdowns,
  satisfyLevelOptions,
  fieldStatusOptions,
  setDynamicFields,
  row,
  editMode,
  dynamicErrors,
  setDynamicErrors,
  isDm,
  tdhStatus,
  dfyCommonDropdown,
  tdhInspectionType,
  showSatisfyLevel,
  showFieldStatus,
  showDescription,
}) => {
  const [searchFieldReset, setSearchFieldReset] = useState(false);

  // Check if the Amount field should be displayed or not
  const isAmountFieldVisible = dfyAmountInfo !== "No";
  const isDiscountFieldVisible = dfyDiscountInfo !== "No";

  if (
    (dyfFieldType === 8 && dfyCommonDropdown === 19) ||
    dfyCommonDropdown === 22
  ) {
    return null; // Do not render this field
  }

  return (
    <div className="ui form">
      <div
        className="five fields"
        style={{ display: "flex", alignItems: "center" }}
      >
        <div style={{ display: "flex", gap: "5px", width: "200px" }}>
          {dyfRequired ? <label style={{ color: "#9f3a38" }}>*</label> : ""}
          <p style={{ lineHeight: 1.3 }}>
            {`${rowNo ?? ""}) ${dyfField ?? ""}`}
          </p>
        </div>

        {dyfFieldType === 4 ? (
          <Dropdown
            label="Select a Value "
            required={dyfRequired ? true : false}
            options={dynamicDropdowns?.map((item) => ({
              key: item.id,
              value: item.dydSeq,
              text: item.dydValue,
            }))}
            value={row.dyfFieldValue}
            onChange={(e, data) => {
              setDynamicFields((prevData) =>
                prevData?.map((item) => {
                  if (item.dyfId === dyfId) {
                    return {
                      ...item,
                      dyfFieldValue: data.value,
                    };
                  }
                  return item;
                }),
              );
            }}
            error={dynamicErrors?.[dyfField]?.dyfFieldValue}
            resetError={() =>
              setDynamicErrors((prev) => {
                const { dyfFieldValue: _, ...rest } = prev[dyfField];
                return { ...prev, [dyfField]: rest };
              })
            }
            disabled={
              (tdhStatus === 2 && editMode) ||
              (tdhStatus === 3 && editMode) ||
              isDm
            }
          />
        ) : dyfFieldType === 3 ? (
          <Input
            label="Type value here"
            required={dyfRequired ? true : false}
            type="text"
            blockPattern={/[#%]/g}
            // style={{minWidth: "150px", width: "150px" }}
            value={row.dyfFieldValue}
            onChange={(e) => {
              setDynamicFields((prevData) =>
                prevData?.map((item) => {
                  if (item.dyfId === dyfId) {
                    return {
                      ...item,
                      dyfFieldValue: e.target.value,
                    };
                  }
                  return item;
                }),
              );
            }}
            error={dynamicErrors?.[dyfField]?.dyfFieldValue}
            resetError={() =>
              setDynamicErrors((prev) => {
                const { dyfFieldValue: _, ...rest } = prev[dyfField];
                return { ...prev, [dyfField]: rest };
              })
            }
            disabled={
              (tdhStatus === 2 && editMode) ||
              (tdhStatus === 3 && editMode) ||
              isDm
            }
          />
        ) : dyfFieldType === 5 ? (
          <Input
            label="Select the date"
            required={dyfRequired ? true : false}
            type="date"
            value={row.dyfFieldValue}
            onChange={(e) => {
              setDynamicFields((prevData) =>
                prevData?.map((item) => {
                  if (item.dyfId === dyfId) {
                    return {
                      ...item,
                      dyfFieldValue: e.target.value,
                    };
                  }
                  return item;
                }),
              );
            }}
            error={dynamicErrors?.[dyfField]?.dyfFieldValue}
            resetError={() =>
              setDynamicErrors((prev) => {
                const { dyfFieldValue: _, ...rest } = prev[dyfField];
                return { ...prev, [dyfField]: rest };
              })
            }
            disabled={
              (tdhStatus === 2 && editMode) ||
              (tdhStatus === 3 && editMode) ||
              isDm
            }
          />
        ) : dyfFieldType === 6 ? (
          <CheckBox
            label="Tick True Or False"
            required={dyfRequired ? true : false}
            checked={row.dyfFieldValue}
            onChange={(e) => {
              setDynamicFields((prevData) =>
                prevData?.map((item) => {
                  if (item.dyfId === dyfId) {
                    return {
                      ...item,
                      dyfFieldValue: !item.dyfFieldValue,
                    };
                  }
                  return item;
                }),
              );
            }}
            error={dynamicErrors?.[dyfField]?.dyfFieldValue}
            resetError={() =>
              setDynamicErrors((prev) => {
                const { dyfFieldValue: _, ...rest } = prev[dyfField];
                return { ...prev, [dyfField]: rest };
              })
            }
            disabled={
              (tdhStatus === 2 && editMode) ||
              (tdhStatus === 3 && editMode) ||
              isDm
            }
          />
        ) : dyfFieldType === 7 ? (
          <Input
            label="Enter value here"
            required={dyfRequired ? true : false}
            type="number"
            value={row.dyfFieldValue}
            onChange={(e) => {
              setDynamicFields((prevData) =>
                prevData?.map((item) => {
                  if (item.dyfId === dyfId) {
                    return {
                      ...item,
                      dyfFieldValue: e.target.value,
                    };
                  }
                  return item;
                }),
              );
            }}
            error={dynamicErrors?.[dyfField]?.dyfFieldValue}
            resetError={() =>
              setDynamicErrors((prev) => {
                const { dyfFieldValue: _, ...rest } = prev[dyfField];
                return { ...prev, [dyfField]: rest };
              })
            }
            disabled={
              (tdhStatus === 2 && editMode) ||
              (tdhStatus === 3 && editMode) ||
              isDm
            }
          />
        ) : dyfFieldType === 8 ? (
          editMode ? (
            <SearchDropdown
              multiGrid={true}
              multiGridCurrentValue={row.tdfCommonDropdownValue ?? ""}
              key={1}
              required={dyfRequired ? true : false}
              label={"Select the value"}
              clearable={true}
              onClear={() =>
                setDynamicFields((prevData) =>
                  prevData?.map((item) => {
                    if (item.dyfId === dyfId) {
                      return {
                        ...item,
                        dyfFieldValue: "",
                      };
                    }
                    return item;
                  }),
                )
              }
              reset={searchFieldReset}
              setReset={setSearchFieldReset}
              onResultSelect={(data) => {
                setDynamicFields((prevData) =>
                  prevData?.map((item) => {
                    if (item.dyfId === dyfId) {
                      return {
                        ...item,
                        dyfFieldValue: data,
                      };
                    }
                    return item;
                  }),
                );
              }}
              api={getOtherRefSearchDropdown}
              apiDependency={{
                type: row.dcType,
                value: row.dcValue ? row.dcValue : "",
              }}
              error={dynamicErrors?.[dyfField]?.dyfFieldValue}
              resetError={() =>
                setDynamicErrors((prev) => {
                  const { dyfFieldValue: _, ...rest } = prev[dyfField];
                  return { ...prev, [dyfField]: rest };
                })
              }
              disabled={
                (tdhStatus === 2 && editMode) ||
                (tdhStatus === 3 && editMode) ||
                isDm
              }
            />
          ) : (
            <SearchDropdown
              key={1}
              required={dyfRequired ? true : false}
              label={"Select the value"}
              clearable={true}
              onClear={() =>
                setDynamicFields((prevData) =>
                  prevData?.map((item) => {
                    if (item.dyfId === dyfId) {
                      return {
                        ...item,
                        dyfFieldValue: "",
                      };
                    }
                    return item;
                  }),
                )
              }
              reset={searchFieldReset}
              setReset={setSearchFieldReset}
              onResultSelect={(data) => {
                setDynamicFields((prevData) =>
                  prevData?.map((item) => {
                    if (item.dyfId === dyfId) {
                      return {
                        ...item,
                        dyfFieldValue: data,
                      };
                    }
                    return item;
                  }),
                );
              }}
              api={getOtherRefSearchDropdown}
              apiDependency={{
                type: row.dcType,
                value: row.dcValue ? row.dcValue : "",
              }}
              error={dynamicErrors?.[dyfField]?.dyfFieldValue}
              resetError={() =>
                setDynamicErrors((prev) => {
                  const { dyfFieldValue: _, ...rest } = prev[dyfField];
                  return { ...prev, [dyfField]: rest };
                })
              }
              disabled={
                (tdhStatus === 2 && editMode) ||
                (tdhStatus === 3 && editMode) ||
                isDm
              }
            />
          )
        ) : (
          ""
        )}
        {showDescription ? (
          <Input
            type="text"
            label="Description"
            placeholder={"Type description"}
            blockPattern={/[#%]/g}
            value={row.dyfFieldDescription}
            onChange={(e) => {
              setDynamicFields((prevData) =>
                prevData?.map((item) => {
                  if (item.dyfId === dyfId) {
                    return {
                      ...item,
                      dyfFieldDescription: e.target.value,
                    };
                  }
                  return item;
                }),
              );
            }}
            disabled={
              (tdhStatus === 2 && editMode) ||
              (tdhStatus === 3 && editMode) ||
              isDm
            }
          />
        ) : (
          ""
        )}

        {/*<Dropdown*/}
        {/*  label="Satisfy Level"*/}
        {/*  required={dyfRequired ? true : false}*/}
        {/*  placeholder="Select satisfy level"*/}
        {/*  options={satisfyLevelOptions}*/}
        {/*  value={row.dyfSatisfyLevel}*/}
        {/*  onChange={(e, data) => {*/}
        {/*    setDynamicFields((prevData) =>*/}
        {/*      prevData?.map((item) => {*/}
        {/*        if (item.dyfId === dyfId) {*/}
        {/*          return {*/}
        {/*            ...item,*/}
        {/*            dyfSatisfyLevel: data.value,*/}
        {/*          };*/}
        {/*        }*/}
        {/*        return item;*/}
        {/*      })*/}
        {/*    );*/}
        {/*  }}*/}
        {/*  error={dynamicErrors?.[dyfField]?.dyfSatisfyLevel}*/}
        {/*  resetError={() =>*/}
        {/*    setDynamicErrors((prev) => {*/}
        {/*      const { dyfSatisfyLevel: _, ...rest } = prev[dyfField];*/}
        {/*      return { ...prev, [dyfField]: rest };*/}
        {/*    })*/}
        {/*  }*/}
        {/*  disabled={(tdhStatus === 2 && editMode) || isDm}*/}
        {/*/>*/}
        {/*<Dropdown*/}
        {/*  label="Field Status"*/}
        {/*  required={dyfRequired ? true : false}*/}
        {/*  options={fieldStatusOptions}*/}
        {/*  placeholder={"Select Field Status"}*/}
        {/*  value={row.dyfFieldStatus}*/}
        {/*  onChange={(e, data) => {*/}
        {/*    setDynamicFields((prevData) =>*/}
        {/*      prevData?.map((item) => {*/}
        {/*        if (item.dyfId === dyfId) {*/}
        {/*          return {*/}
        {/*            ...item,*/}
        {/*            dyfFieldStatus: data.value,*/}
        {/*          };*/}
        {/*        }*/}
        {/*        return item;*/}
        {/*      })*/}
        {/*    );*/}
        {/*  }}*/}
        {/*  error={dynamicErrors?.[dyfField]?.dyfFieldStatus}*/}
        {/*  resetError={() =>*/}
        {/*    setDynamicErrors((prev) => {*/}
        {/*      const { dyfFieldStatus: _, ...rest } = prev[dyfField];*/}
        {/*      return { ...prev, [dyfField]: rest };*/}
        {/*    })*/}
        {/*  }*/}
        {/*  disabled={(tdhStatus === 2 && editMode) || isDm}*/}
        {/*/>*/}
        {isAmountFieldVisible && (
          <Input
            type="number"
            label="Amount"
            placeholder={"Amount"}
            value={row.dyfAmountValue}
            onChange={(e) => {
              setDynamicFields((prevData) =>
                prevData?.map((item) => {
                  if (item.dyfId === dyfId) {
                    return {
                      ...item,
                      dyfAmountValue: e.target.value,
                    };
                  }
                  return item;
                }),
              );
            }}
            disabled={
              (tdhStatus === 2 && editMode) ||
              (tdhStatus === 3 && editMode) ||
              isDm ||
              dfyAmount === 2
            }
          />
        )}
        {isDiscountFieldVisible && (
          <Input
            type="number"
            label="Discount"
            placeholder="Disocunt"
            value={row.dyfDiscountValue}
            onChange={(e) => {
              setDynamicFields((prevData) =>
                prevData?.map((item) => {
                  if (item.dyfId === dyfId) {
                    return {
                      ...item,
                      dyfDiscountValue: e.target.value,
                    };
                  }
                  return item;
                }),
              );
            }}
            disabled={
              (tdhStatus === 2 && editMode) ||
              (tdhStatus === 3 && editMode) ||
              isDm ||
              dfyDiscount === 2
            }
          />
        )}

        {/* Conditional Rendering for Satisfy Level */}
        {showSatisfyLevel && tdhInspectionType === 1 && (
          <Dropdown
            label="Satisfy Level"
            required={dyfRequired ? true : false}
            placeholder="Select satisfy level"
            options={satisfyLevelOptions}
            value={row.dyfSatisfyLevel}
            onChange={(e, data) => {
              setDynamicFields((prevData) =>
                prevData?.map((item) => {
                  if (item.dyfId === dyfId) {
                    return {
                      ...item,
                      dyfSatisfyLevel: data.value,
                    };
                  }
                  return item;
                }),
              );
            }}
            error={dynamicErrors?.[dyfField]?.dyfSatisfyLevel}
            resetError={() =>
              setDynamicErrors((prev) => {
                const { dyfSatisfyLevel: _, ...rest } = prev[dyfField];
                return { ...prev, [dyfField]: rest };
              })
            }
            disabled={
              (tdhStatus === 2 && editMode) ||
              (tdhStatus === 3 && editMode) ||
              isDm
            }
          />
        )}

        {/* Conditional Rendering for Field Status */}
        {showFieldStatus && tdhInspectionType === 1 && (
          <Dropdown
            label="Field Status"
            required={dyfRequired ? true : false}
            options={fieldStatusOptions}
            placeholder={"Select Field Status"}
            value={row.dyfFieldStatus}
            onChange={(e, data) => {
              setDynamicFields((prevData) =>
                prevData?.map((item) => {
                  if (item.dyfId === dyfId) {
                    return {
                      ...item,
                      dyfFieldStatus: data.value,
                    };
                  }
                  return item;
                }),
              );
            }}
            error={dynamicErrors?.[dyfField]?.dyfFieldStatus}
            resetError={() =>
              setDynamicErrors((prev) => {
                const { dyfFieldStatus: _, ...rest } = prev[dyfField];
                return { ...prev, [dyfField]: rest };
              })
            }
            disabled={
              (tdhStatus === 2 && editMode) ||
              (tdhStatus === 3 && editMode) ||
              isDm
            }
          />
        )}
      </div>
    </div>
  );
};

const AddDocument = ({
  isDm,
  setEditMode,
  editMode,
  handleDrawerClose,
  dropdownOptions,
  tdhId,
  tdhCode,
}) => {
  const { firstViableTab, lastViableTab } = useFirstAndLastAuthorizedTab({
    module: MODULES.Fleet,
    section: isDm
      ? editMode
        ? FORMS.FLEET_UPDATE
        : FORMS.FLEET
      : editMode
        ? FORMS.FLEET_INSPECTION_UPDATE
        : FORMS.FLEET_INSPECTION,
  });
  const user = useSelector((state) => state.user);
  const [tab, setTab] = useState(firstViableTab);
  const userCompany = useUserCompany();
  const userCurrencyCode = userCompany ? userCompany.comCurrencyCode : null;
  const userCurrency = userCompany ? userCompany.comCurrency : null;
  const formatter = Intl.NumberFormat("en-US", {
    style: "currency",
    currency: userCurrencyCode,
  });
  const [company, setCompany] = useState(
    userCompany ? userCompany.comId : null,
  );
  const { next, prev } = useNextAndPreviousAuthority({
    sectionKey: "dynamicTemplate112",
    minTab: 1,
    maxTab: 2,
    module: MODULES.Fleet,
    section: isDm ? FORMS.FLEET : FORMS.FLEET_INSPECTION,
    currentTab: tab,
    authenticated: true,
  });

  const [isItemListMissing, setIsItemListMissing] = useState(false);
  const [isChargeListMissing, setIsChargeListMissing] = useState(false);
  const [isPrintLoading, setIsPrintLoading] = useState(false);
  const [hasItemField, setHasItemField] = useState(false);
  const [tdhCategory, setTdhCategory] = useState("");
  const [tdhInspectionType, setTdhInspectionType] = useState("");
  const [tdhTemplate, setTdhTemplate] = useState("");
  const [tdhNextValue, setTdhNextValue] = useState("");
  const [tdhNextUom, setTdhNextUom] = useState("");
  const [tdhNextUomValue, setTdhNextUomValue] = useState("");
  const [tdhActionDate, setTdhActionDate] = useState("");
  const [tdhNextDate, setTdhNextDate] = useState("");
  const [tdhActionTaken, setTdhActionTaken] = useState(2);
  const [tdhDescription, setTdhDescription] = useState("");
  const [tdhOverallStatus, setTdhOverallStatus] = useState(1);
  const [tdhOverall, setTdhOverall] = useState(0);
  const [tdhStatus, setTdhStatus] = useState(1);
  const [persistedTdhStatus, setPersistedTdhStatus] = useState("");
  const [tdhActive, setTdhActive] = useState(1);
  const [tdhUom, setTdhUom] = useState(null);
  const [tdhMilage, setTdhMilage] = useState("");
  const [tdhNextMilage, setTdhNextMilage] = useState("");
  const [nextActionKm, setNextActionKm] = useState(0);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [tdhTotal, setTdhTotal] = useState(0);
  const [tdhPercentage, setTdhPercentage] = useState(2);
  const [tdhDiscount, setTdhDiscount] = useState("");
  const [tdhValue, setTdhValue] = useState(0);
  const [tdhRefId, setTdhRefId] = useState("");
  const [tdhCashCredit, setTdhCashCredit] = useState(0);
  const [tdhSubAction, setTdhSubAction] = useState(0);
  const [tdhTransporter, setTdhTransporter] = useState("");
  const [tdhTransporterId, setTdhTransporterId] = useState("");
  const [tdhDriver, setTdhDriver] = useState("");
  const [tdhDriverTransporter, setTdhDriverTransporter] = useState("");
  const driverRef = useRef();
  const [tdhDriverId, setTdhDriverId] = useState("");
  const [tdhBaseDriverId, setTdhBaseDriverId] = useState("");
  const [thdDepreciation, setThdDepreciation] = useState(2);
  const [thdDepreciationValue, setThdDepreciationValue] = useState(null);
  const [thdDepreciationUom, setThdDepreciationUom] = useState(null);
  const [thdDepreciationDate, setThdDepreciationDate] = useState(null);
  const [tdhTyreSize, setTdhTyreSize] = useState("");
  const [tdhSupplier, setTdhSupplier] = useState("");
  const [tdhExcRate, setTdhExcRate] = useState(null);
  const [tdhExcId, setTdhExcId] = useState(null);
  const [tdhModel, setTdhModel] = useState("");
  const [tdhModelId, setTdhModelId] = useState("");
  const [tdhNumTyres, setTdhNumTyres] = useState("");

  const [tdhVehTypeSize, setTdhVehTypeSize] = useState("");
  const [tdhVehBodyType, setTdhVehBodyType] = useState("");
  const [tdhVehInspectionGroup, setTdhVehInspectionGroup] = useState("");
  const [tdhVehOperationType, setTdhVehOperationType] = useState("");
  const [tdhVehWidth, setTdhVehWidth] = useState("");
  const [tdhVehLength, setTdhVehLength] = useState("");
  const [tdhVehHeight, setTdhVehHeight] = useState("");

  const [tdhDriverNic, setTdhDriverNic] = useState("");
  const [tdhDriverMobile, setTdhDriverMobile] = useState("");
  const [tdhDriverNicImg, setTdhDriverNicImg] = useState("");
  const [tdhDriverGsImg, setTdhDriverGsImg] = useState("");
  const [tdhDriverDrImg, setTdhDriverDrImg] = useState("");
  const [tdhDriverPoliceImg, setTdhDriverPoliceImg] = useState("");

  const [isDriverVehicleDetailLoading, setIsDriverVehicleDetailLoading] =
    useState(false);
  const [rowData, setRowData] = useState(null);
  const [tdhApprovedBy, setTdhApprovedBy] = useState("");
  const [exchangeRate, setExchangeRate] = useState({});
  const [exchangeRates, setExchangeRates] = useState([]);
  const [createdBy, setCreatedBy] = useState("");

  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [selectedExchangeRate, setSelectedExchangeRate] = useState("");

  const [previewAmount, setPreviewAmount] = useState("");
  const [previewTax, setPreviewTax] = useState("");
  const [previewDiscount, setPreviewDiscount] = useState("");
  const [previewTotal, setPreviewTotal] = useState("");

  const currencyModalRef = useRef();
  const [isItemShown, setIsItemShown] = useState(false);
  const [isChargeShown, setIsChargeShown] = useState(false);
  const [activeTab, setActiveTab] = useState(() =>
    isItemShown ? 1 : isChargeShown ? 3 : 2,
  );
  const [tdhCompany, setTdhCompany] = useState(
    userCompany ? userCompany.comId : null,
  );
  const [tdhReferance, setTdhReferance] = useState("");
  const [tdhInspectedPlace, setTdhInspectedPlace] = useState("");
  const searchDropdownRef = useRef(null);
  const [documents, setDocuments] = useState([]);
  const [dynamicHeaderRefResponses, setDynamicHeaderRefResponses] = useState(
    [],
  );
  const documentRef = useRef(null);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const taxModalRef = useRef();
  const baseCurrencyModalRef = useRef();

  const [tabDataRow, setTabDataRow] = useState(null);
  const [selectedTaxData, setSelectedTaxData] = useState(null);
  const [printCurrency, setPrintCurrency] = useState(null);
  const [templateOptions, setTemplateOptions] = useState([]);
  const [chargesOptions, setChargesOptions] = useState([]);
  const [chargeItemOptions, setChargeItemOptions] = useState([]);
  const [selectedCharge, setSelectedCharge] = useState(null);
  const [selectedChargeItem, setSelectedChargeItem] = useState(null);
  const [uomOptions, setUomOptions] = useState([]);
  const [activeOpt, setActiveOpt] = useState([]);
  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
  const [fileNameOptions, setFileNameOptions] = useState([]);
  const [subActionOpt, setSubActionOpt] = useState([]);
  const [satisfyLevelOptions, setSatisfyLevelOptions] = useState([]);
  const [fieldStatusOptions, setFieldStatusOptions] = useState([]);
  const [tyreSizeOpt, setTyreSizeOpt] = useState([]);
  const [filteredGridConfig, setFilteredGridConfig] = useState([]);
  const [filteredModalGridConfig, setFilteredModalGridConfig] = useState([]);
  const [taxOptions, setTaxOptions] = useState([]);
  const [fullItemDetails, setFullItemDetails] = useState([]);
  const [taxGridData, setTaxGridData] = useState([]);

  const tdhDiscountRef = useRef(tdhDiscount);
  useEffect(() => {
    tdhDiscountRef.current = tdhDiscount;
  }, [tdhDiscount]);

  console.log("tdhDiscount", tdhDiscount);

  const normalizeTaxesForRow = (
    taxList,
    { rowKey, baseCost, tdfId = null },
  ) => {
    const cost = Number(baseCost) || 0;

    return (Array.isArray(taxList) ? taxList : [])
      .filter((tax) => {
        if (!tax) return false;
        const taxIdentifier = tax.taxId ?? tax.tdtTaxId;
        if (taxIdentifier == null) return false;

        if (tax.isTaxActive !== undefined) {
          return Boolean(tax.isTaxActive);
        }

        if (tax.tdtActive !== undefined) {
          return tax.tdtActive === 1;
        }

        return true;
      })
      .map((tax) => {
        const rate = Number(tax.taxRate ?? tax.tdtTaxRate ?? 0);
        const derivedCost = tax.tdtCost != null ? Number(tax.tdtCost) : cost;
        const resolvedRowKey =
          tax.tdtSeq != null
            ? tax.tdtSeq
            : tdfId != null
              ? null
              : rowKey ?? null;

        const resolvedTaxActive =
          tax.isTaxActive !== undefined
            ? Boolean(tax.isTaxActive)
            : tax.tdtActive !== undefined
              ? tax.tdtActive === 1
              : true;

        return {
          ...tax,
          tdtTdhId: tax.tdtTdhId ?? (editMode ? tdhId : null),
          tdtTdfId: tax.tdtTdfId ?? tdfId ?? null,
          tdtTaxId: tax.tdtTaxId ?? tax.taxId,
          tdtTaxRate: rate,
          tdtCost: derivedCost,
          tdtSeq: resolvedRowKey,
          tdtWithTax:
            tax.tdtWithTax != null
              ? Number(tax.tdtWithTax)
              : derivedCost + derivedCost * (rate / 100),
          tdtReferance: tax.tdtReferance ?? tax.taxName ?? "",
          tdtCompany: tax.tdtCompany ?? tdhCompany,
          tdtStatus: tax.tdtStatus ?? 2,
          tdtActive:
            tax.tdtActive != null ? tax.tdtActive : resolvedTaxActive ? 1 : 0,
          createdBy: tax.createdBy ?? user.username,
          taxName: tax.taxName ?? tax.tdtReferance ?? "",
          taxRate: rate,
          taxId: tax.taxId ?? tax.tdtTaxId,
          isTaxActive: resolvedTaxActive,
        };
      });
  };

  const writeTaxesForRow = ({ rowKey, tdfId = null, taxRows }) => {
    if (rowKey == null && tdfId == null) {
      return taxRows ?? [];
    }

    const identifier = String(tdfId ?? rowKey ?? "");

    setTaxGridData((prev) => {
      const remaining = prev.filter((tax) => {
        const key =
          tax.tdtTdfId != null
            ? String(tax.tdtTdfId)
            : tax.tdtSeq != null
              ? String(tax.tdtSeq)
              : "";
        return key !== identifier;
      });

      if (!taxRows || taxRows.length === 0) {
        return remaining;
      }

      return [...remaining, ...taxRows];
    });

    return taxRows ?? [];
  };

  const normalizeSingleTaxRecord = (tax, { rowKey, baseCost, tdfId } = {}) => {
    const normalizedList = normalizeTaxesForRow(
      [
        {
          ...tax,
          taxRate: tax.taxRate ?? tax.tdtTaxRate ?? 0,
          taxId: tax.taxId ?? tax.tdtTaxId,
          isTaxActive:
            tax.isTaxActive !== undefined
              ? Boolean(tax.isTaxActive)
              : tax.tdtActive !== undefined
                ? tax.tdtActive === 1
                : true,
        },
      ],
      {
        rowKey: rowKey ?? tax.tdtSeq ?? tax.tdftSeq ?? null,
        baseCost: baseCost ?? tax.tdtCost ?? tax.cost ?? 0,
        tdfId: tdfId ?? tax.tdtTdfId ?? null,
      },
    );

    return normalizedList[0];
  };

  const collectTaxRowsForSubmission = () => {
    const merged = new Map();

    const upsert = (tax) => {
      if (!tax) return;
      const normalized = normalizeSingleTaxRecord(tax);
      if (!normalized) return;

      const taxId = normalized.tdtTaxId ?? normalized.taxId;
      if (taxId == null) return;

      const idKey =
        normalized.tdtTdfId != null
          ? `id:${normalized.tdtTdfId}`
          : normalized.tdtSeq != null
            ? `seq:${normalized.tdtSeq}`
            : "row:unknown";

      const mapKey = `${idKey}|${taxId}`;
      merged.set(mapKey, normalized);
    };

    const fromRows = (rows) =>
      (Array.isArray(rows) ? rows : []).forEach((row) => {
        if (!row) return;

        const taxDetails = Array.isArray(row.taxDetails) ? row.taxDetails : [];

        if (taxDetails.length === 0) {
          return;
        }

        const rowKey = row.tdfId ?? row.tdftSeq ?? row.tdfSeq ?? row.id ?? null;
        const tdfId = row.tdfId ?? null;
        const baseCost =
          row.unitPrice ??
          row.tdfUnitPrice ??
          row.unitprice ??
          row.tdfAmount ??
          0;

        taxDetails.forEach((tax) => {
          const normalized = normalizeSingleTaxRecord(tax, {
            rowKey,
            baseCost,
            tdfId,
          });
          upsert(normalized);
        });
      });

    fromRows(gridData);
    fromRows(chargeGridData);

    if (Array.isArray(taxGridData) && taxGridData.length > 0) {
      taxGridData.forEach((tax) => {
        upsert(
          normalizeSingleTaxRecord(tax, {
            rowKey: tax.tdtSeq ?? tax.tdftSeq ?? null,
            baseCost: tax.tdtCost ?? tax.cost ?? 0,
            tdfId: tax.tdtTdfId ?? null,
          }),
        );
      });
    }

    return Array.from(merged.values());
  };

  //options for the item list
  const [brandOptions, setBrandOptions] = useState([]);
  const [tyreTypeOpt, setTyreTypeOpt] = useState([]);
  const [treadPatternOpt, setTreadPatternOpt] = useState([]);
  const [positionFixedOpt, setPositionFixedOpt] = useState([]);

  const [itemDynamicField, setItemDynamicField] = useState([]);
  const [chargeDynamicField, setChargeDynamicField] = useState([]);

  const [searchFieldReset, setSearchFieldReset] = useState(false);

  const [templateSetLoading, setTemplateSetLoading] = useState(false);
  const [dropdownValuesLoading, setDropdownValuesLoading] = useState(false);
  const [infoLoading, setInfoLoading] = useState(false);
  const [currentErrors, setCurrentErrors] = useState({});
  const [dynamicFields, setDynamicFields] = useState([]);
  const [selectedJobs, setSelectedJobs] = useState({});
  const [gridData, setGridData] = useState([]);
  const [chargeGridData, setChargeGridData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [activeAccordion1, setActiveAccordion1] = useState(true);
  const [activeAccordionJobs, setActiveAccordionJobs] = useState(false);
  const [activeAccordionHeader, setActiveAccordionHeader] = useState(true);
  const [activeAccordionAlerts, setActiveAccordionAlerts] = useState(true);
  const [activeAccordionSummary, setActiveAccordionSummary] = useState(true);
  const [activeAccordionOverall, setActiveAccordionOverall] = useState(true);
  const [dynamicFieldsLoading, setDynamicFieldsLoading] = useState(false);
  const handleAccordionClick1 = () => {
    setActiveAccordion1(!activeAccordion1);
  };
  const [isBlurred, setIsBlurred] = useState(false);
  const [searchDropdownItemListReset, setSearchDropdownItemListReset] =
    useState(false);
  const [dynamicErrors, setDynamicErrors] = useState({});
  const depreciationOptions = useRef([]);
  const [depUomOptions, setDepUomOptions] = useState([]);
  const [cashTypeOptions, setCashTypeOptions] = useState([]);
  const [fleetCharges, setFleetCharges] = useState([]);
  const [deletedList, setDeletedList] = useState([]);
  const modalRef = useRef();
  const modalRef2 = useRef();
  const modalRef3 = useRef();
  const gridRef = useRef(null);
  const dynamicGridRef = useRef(null);
  const [errorMessage, setErrorMessage] = useState("");

  const INSPECTION_FORM = FORMS.FLEET_INSPECTION;
  const DOCUMENT_FORM = FORMS.FLEET;

  const auth = useSelector((state) => state.user.permissions[MODULES.Fleet]);

  const inspectionPermissions = auth[INSPECTION_FORM];
  const documentPermissions = auth[DOCUMENT_FORM];

  // the fields
  const [tdhTaxAmount, setTdhTaxAmount] = useState(0);
  const [item, setItem] = useState(null);
  const [tdfCurrency, setTdfCurrency] = useState(userCurrency);
  const [createdDate, setCreatedDate] = useState("");
  const [insReportType, setInsReportType] = useState("");

  useEffect(() => {
    setTdhCompany(userCompany ? userCompany.comId : null);
  }, [userCompany]);

  const closeModal = () => {
    modalRef.current.close();
  };

  const openTaxModal = (data) => {
    if (!editMode || (editMode && persistedTdhStatus !== 2)) {
      setSelectedTaxData(data);
      taxModalRef.current?.showModal();
    }
  };

  const closeTaxModal = () => {
    taxModalRef.current?.close();
  };

  const openModal = () => {
    modalRef.current?.showModal();
  };

  const openModel2 = () => {
    modalRef2.current?.showModal();
  };

  const closeModal2 = () => {
    modalRef2.current.close();
  };
  const openCurrencyModal = () => {
    currencyModalRef.current?.showModal();
  };

  const closeCurrencyModal = () => {
    currencyModalRef.current?.close();
  };

  const baseCurrencyModalOpen = () => {
    baseCurrencyModalRef.current?.showModal();
  };

  const baseCurrencyModalClose = () => {
    baseCurrencyModalRef.current?.close();
  };

  useEffect(() => {
    if (!editMode) {
      setTdhRefId("");
      setSearchFieldReset(true);
    }
  }, [tdhCategory, editMode]);

  useEffect(() => {
    if (!editMode) {
      setTdhTemplate("");
    }
  }, [tdhCategory, tdhInspectionType, editMode]);

  // useEffect(() => {
  //   if (!selectedExchangeRate || isNaN(selectedExchangeRate)) return;

  //   const rate = parseFloat(selectedExchangeRate);
  //   const amount = parseFloat(tdhValue || 0);
  //   const tax = parseFloat(tdhTaxAmount || 0);
  //   const discount = parseFloat(tdhDiscount || 0);
  //   const totalDynamicDiscount = dynamicFields.reduce(
  //     (acc, dynamic) => acc + parseFloat(dynamic.dyfDiscountValue || 0),
  //     0,
  //   );
  //   console.log("discount", discount);
  //   console.log("discount rate", rate);
  //   console.log("dis total dynamic discount", totalDynamicDiscount);
  //   console.log("Tax", tax);
  //   console.log("Converted Amount", amount / rate);
  //   const convertedAmount = amount / rate;
  //   const convertedTax = tax / rate;
  //   const convertedDiscount = discount / rate + totalDynamicDiscount;
  //   const convertedTotal =
  //     (amount + tax - (discount + totalDynamicDiscount)) / rate;

  //   setPreviewAmount(convertedAmount.toFixed(2));
  //   setPreviewTax(convertedTax.toFixed(2));
  //   setPreviewDiscount(convertedDiscount.toFixed(2));
  //   setPreviewTotal(convertedTotal.toFixed(2));
  // }, [
  //   selectedExchangeRate,
  //   tdhValue,
  //   tdhTaxAmount,
  //   tdhDiscount,
  //   dynamicFields,
  // ]);

  // useEffect(() => {
  //   if (!selectedExchangeRate || isNaN(selectedExchangeRate)) return;

  //   const rate = parseFloat(selectedExchangeRate);
  //   const amount = parseFloat(tdhValue || 0);
  //   const tax = parseFloat(tdhTaxAmount || 0);
  //   const discount = parseFloat(tdhDiscountRef.current || 0); // use ref from previous fix
  //   const totalDynamicDiscount = dynamicFields.reduce(
  //     (acc, dynamic) => acc + parseFloat(dynamic.dyfDiscountValue || 0),
  //     0,
  //   );

  //   const convertedAmount = amount / rate;
  //   const convertedTax = tax / rate;
  //   const convertedDiscount = discount / rate + totalDynamicDiscount;
  //   const convertedTotal =
  //     (amount + tax - (discount + totalDynamicDiscount)) / rate;

  //   setPreviewAmount(convertedAmount.toFixed(2));
  //   setPreviewTax(convertedTax.toFixed(2));
  //   setPreviewDiscount(convertedDiscount.toFixed(2));
  //   setPreviewTotal(convertedTotal.toFixed(2));

  //   // ✅ Keep tdhTotal in sync so the correct value goes to DB
  //   setTdhTotal(convertedTotal.toFixed(2));
  //   // ✅ Keep tdhDiscount as absolute for DB
  //   setTdhDiscount(convertedDiscount.toFixed(2));
  // }, [selectedExchangeRate, tdhValue, tdhTaxAmount, dynamicFields]);

  useEffect(() => {
    const selectedChargeData = (chargesOptions || []).find(
      (c) => c.value === selectedCharge,
    );
    setChargeItemOptions(selectedChargeData?.items || []);
  }, [selectedCharge]);

  // 🚨 Fetching `tdhTemplate` dynamically
  const fetchAndFilterColumns = (dataRow) => {
    if (!dataRow || !dataRow.dynamicFields) {
      return [];
    }

    // Step 1: Find the correct dynamicField object
    const targetField = dataRow.dynamicFields.find(
      (field) =>
        (field.dyfFieldType === 8 && field.dfyCommonDropdown === 19) ||
        field.dfyCommonDropdown === 22,
    );

    if (!targetField || !targetField.dynamicColumns) {
      return [];
    }
    // Step 2: Extract `ddcField` values from dynamicColumns
    const allowedFields = targetField.dynamicColumns.map((col) => col.ddcField);
    return allowedFields;
  };

  // 🚨 Always visible column IDs
  const alwaysVisibleIds = [0, 96, 97, 98, 99, 99999]; // 0 = Item, 96-99 = Tax, Total Amount, More, Action

  // 🚀 Function to generate dynamic gridConfig based on `tdhTemplate`
  const getFilteredGridConfig = (dataRow) => {
    const allowedFields = fetchAndFilterColumns(dataRow);

    const dynamicFieldIds = [12, 13, 14, 15, 16, 17, 18, 19, 20, 21];
    const hasDynamicFields = dynamicFieldIds.some((id) =>
      allowedFields.includes(id),
    );

    return gridConfig.filter((column) => {
      if (column.id === 98 && !hasDynamicFields) {
        // Hide "More" column if none of the dynamic fields are present
        return false;
      }
      return (
        alwaysVisibleIds.includes(column.id) ||
        allowedFields.includes(column.id)
      );
    });
  };

  // 🚀 Function to generate dynamic modalGridConfig based on `tdhTemplate`
  const getFilteredModalGridConfig = (dataRow) => {
    const allowedFields = fetchAndFilterColumns(dataRow);

    return modalGridConfig.filter(
      (column) =>
        alwaysVisibleIds.includes(column.id) ||
        allowedFields.includes(column.id),
    );
  };

  useEffect(() => {
    (async () => {
      if (editMode) {
        setInfoLoading(true);

        const inspectionDetails = await getInspectionByTdhId(tdhId);
        setCreatedBy(inspectionDetails.dynamicHeaderResponseDM.createdBy);
        const itemField = inspectionDetails?.dynamicDataList?.find(
          (data) => data.tdfFieldType === 8 && data.tdfCommonDropdownId === 19,
        );

        if (itemField) {
          setIsItemShown(true);
          setIsChargeShown(false);
          setActiveTab(1); // Item list tab
          setItemDynamicField(itemField); // Set item dynamic field
        } else {
          const chargeField = inspectionDetails?.dynamicDataList?.find(
            (data) =>
              data.tdfFieldType === 8 && data.tdfCommonDropdownId === 22,
          );
          if (chargeField) {
            setChargeDynamicField(chargeField); // Set charge dynamic field
            setIsItemShown(false);
            setIsChargeShown(true);
            setActiveTab(3); // Charge tab or fallback
          }
        }

        const theDataRow = await getDynamicTemplateById(
          inspectionDetails.dynamicHeaderResponseDM.tdhTemplate,
        );
        setInsReportType(theDataRow?.dyhReportType);

        const itemFieldinDynamic = theDataRow?.dynamicFields?.find(
          (data) => data.dyfFieldType === 8 && data.dfyCommonDropdown === 19,
        );

        const chargeFieldinDynamic = theDataRow?.dynamicFields?.find(
          (data) => data.dyfFieldType === 8 && data.dfyCommonDropdown === 22,
        );

        if (itemFieldinDynamic) {
          setIsItemShown(true);
          setIsChargeShown(false);
          setActiveTab(1); // Item list tab
        } else if (chargeFieldinDynamic) {
          setIsItemShown(false);
          setIsChargeShown(true);
          setActiveTab(3); // Charge tab or fallback
        } else {
          setIsItemShown(false);
          setIsChargeShown(false);
          setActiveTab(2);
        }

        // From the header response
        const excId = inspectionDetails?.dynamicHeaderResponseDM?.tdhExcId;
        const excRate = inspectionDetails?.dynamicHeaderResponseDM?.tdhExcRate;
        const approvedBy =
          inspectionDetails.dynamicHeaderResponseDM.tdhApprovedBy;
        setTdhApprovedBy(approvedBy);

        setTdhExcId(excId);
        setTdhExcRate(excRate);

        // Match from fetched exchange rates
        const matchedExchange = exchangeRates.find(
          (rate) => JSON.parse(rate.value).excId === excId,
        );

        if (matchedExchange) {
          setSelectedCurrency(matchedExchange.value); // for dropdown
          setSelectedExchangeRate(excRate); // for calculation
        }

        const rawTaxData = Array.isArray(inspectionDetails?.dynamicTaxDataList)
          ? inspectionDetails.dynamicTaxDataList
          : [];

        const mappedTaxData = rawTaxData
          .filter((tax) => tax.tdtActive === 1)
          .map((tax) => ({
            ...tax,
            taxId: tax.tdtTaxId,
            taxRate: tax.tdtTaxRate,
            cost: tax.tdtCost,
            withTax: tax.tdtWithTax,
            taxName: tax.tdtReferance || "",
            isTaxActive: tax.tdtActive === 1,
          }));

        setTaxGridData(mappedTaxData);

        const taxByRowKey = mappedTaxData.reduce((acc, tax) => {
          const key = tax.tdtTdfId ?? tax.tdtSeq;
          if (key == null) {
            return acc;
          }

          const mapKey = String(key);
          if (!acc[mapKey]) {
            acc[mapKey] = [];
          }

          acc[mapKey].push({ ...tax });
          return acc;
        }, {});

        setTabDataRow(theDataRow);

        // Filter and store gridConfig using a new state
        setFilteredGridConfig(getFilteredGridConfig(theDataRow));
        setFilteredModalGridConfig(getFilteredModalGridConfig(theDataRow));
        setDynamicHeaderRefResponses(
          inspectionDetails.dynamicHeaderRefResponses,
        );
        setSelectedJobs(
          (inspectionDetails.dynamicHeaderRefResponses || []).reduce(
            (acc, ref) => {
              acc[ref.dyjOpeRefId] = ref.jobCode;
              return acc;
            },
            {},
          ),
        );

        setTdhReferance(inspectionDetails.dynamicHeaderResponseDM.tdhReferance);
        setTdhCategory(inspectionDetails.dynamicHeaderResponseDM.tdhCategory);
        setTdhInspectionType(
          inspectionDetails.dynamicHeaderResponseDM.tdhInspectionType,
        );
        setTdhInspectedPlace(
          inspectionDetails.dynamicHeaderResponseDM.tdhInspectedPlace,
        );
        setTdhTemplate(inspectionDetails.dynamicHeaderResponseDM.tdhTemplate);
        setTdhNextValue(inspectionDetails.dynamicHeaderResponseDM.tdhNextValue);
        setTdhSubAction(inspectionDetails.dynamicHeaderResponseDM.tdhSubAction);
        setTdhNextUom(inspectionDetails.dynamicHeaderResponseDM.tdhNextUom);

        const nextUomValue = await getTextByValueAndKey(
          "UOM",
          inspectionDetails.dynamicHeaderResponseDM.tdhNextUom,
        );

        setTdhNextUomValue(nextUomValue);

        setTdhCashCredit(
          inspectionDetails.dynamicHeaderResponseDM.tdhCashCredit,
        );
        setNextActionKm(inspectionDetails.dynamicHeaderResponseDM.tdhNextKm);

        setTdhActionDate(
          inspectionDetails.dynamicHeaderResponseDM.tdhActionDate
            ? formatToDateOnlyFromJsonDate(
                inspectionDetails.dynamicHeaderResponseDM.tdhActionDate,
              )
            : "",
        );
        setTdhNextDate(
          inspectionDetails.dynamicHeaderResponseDM.tdhNextDate
            ? formatToDateOnlyFromJsonDate(
                inspectionDetails.dynamicHeaderResponseDM.tdhNextDate,
              )
            : "",
        );
        setTdhDescription(
          inspectionDetails.dynamicHeaderResponseDM.tdhDescription,
        );
        setTdhOverallStatus(
          inspectionDetails.dynamicHeaderResponseDM.tdhOverallStatus,
        );
        setTdhCompany(inspectionDetails.dynamicHeaderResponseDM.tdhCompany);
        setTdhOverall(inspectionDetails.dynamicHeaderResponseDM.tdhOverall);
        setPersistedTdhStatus(
          inspectionDetails.dynamicHeaderResponseDM.tdhStatus,
        );
        setTdhStatus(inspectionDetails.dynamicHeaderResponseDM.tdhStatus);
        setTdhActive(inspectionDetails.dynamicHeaderResponseDM.tdhActive);
        setTdhUom(inspectionDetails.dynamicHeaderResponseDM.tdhUom);
        setTdhMilage(inspectionDetails.dynamicHeaderResponseDM.tdhMillage);
        setTdhNextMilage(
          inspectionDetails.dynamicHeaderResponseDM.tdhNextInspectionKm,
        );
        setNextActionKm(
          Number(inspectionDetails.dynamicHeaderResponseDM.tdhNextActionKm),
        );
        setTdhTotal(inspectionDetails.dynamicHeaderResponseDM.tdhTotal);
        setTdhPercentage(
          inspectionDetails.dynamicHeaderResponseDM.tdhPercentage,
        );
        setTdhActionTaken(
          inspectionDetails.dynamicHeaderResponseDM.tdhActionTaken,
        );
        setTdhDiscount(inspectionDetails.dynamicHeaderResponseDM.tdhDiscount);
        setTdhValue(inspectionDetails.dynamicHeaderResponseDM.tdhValue);
        setTdhRefId(inspectionDetails.dynamicHeaderResponseDM.tdhRefId);
        setTdhSupplier(inspectionDetails.dynamicHeaderResponseDM.tdhVendor);

        setThdDepreciation(
          inspectionDetails.dynamicHeaderResponseDM.thdDepreciation,
        );
        setThdDepreciationValue(
          inspectionDetails.dynamicHeaderResponseDM.thdDepreciationValue
            ? inspectionDetails.dynamicHeaderResponseDM.thdDepreciationValue
            : null,
        );
        setThdDepreciationUom(
          inspectionDetails.dynamicHeaderResponseDM.thdDepreciationUom
            ? inspectionDetails.dynamicHeaderResponseDM.thdDepreciationUom
            : null,
        );
        setThdDepreciationDate(
          inspectionDetails.dynamicHeaderResponseDM.thdDepreciationDate
            ? formatToDateOnlyFromJsonDate(
                inspectionDetails.dynamicHeaderResponseDM.thdDepreciationDate,
              )
            : null,
        );
        setCreatedDate(
          inspectionDetails.dynamicHeaderResponseDM.createdDate
            ? formatToDateOnlyFromJsonDate(
                inspectionDetails.dynamicHeaderResponseDM.createdDate,
              )
            : null,
        );

        setTdhDriverId(inspectionDetails?.dynamicHeaderResponseDM?.tdhDriver);
        setTdhDriver(inspectionDetails?.dynamicHeaderResponseDM?.tdhDriverName);
        // const driverObj = await getFieldValuesByTableAndId({
        //   tableName: "masterdata.tms_m_employee",
        //   primaryKey: "emp_id",
        //   fieldNames: "emp_fullname",
        //   ids: inspectionDetails?.dynamicHeaderResponseDM?.tdhDriver
        //     ? inspectionDetails?.dynamicHeaderResponseDM?.tdhDriver.toString()
        //     : "",
        // });
        //  const driverName =
        //   driverObj && driverObj.length > 0
        //     ? driverObj[0].field1
        //     : "";
        // setTdhDriver(driverName);

        setTdhNumTyres(inspectionDetails?.dynamicHeaderResponseDM?.tdhNumTyres);
        setTdhTransporterId(
          inspectionDetails?.dynamicHeaderResponseDM?.tdhTransporter,
        );
        setTdhTransporter(
          inspectionDetails?.dynamicHeaderResponseDM?.tdhTransporterName,
        );
        // const transporterObj = await getFieldValuesByTableAndId({
        //   tableName: "masterdata.tms_m_stakeholder",
        //   primaryKey: "stk_id",
        //   fieldNames: "stk_name",
        //   ids: inspectionDetails.dynamicHeaderResponseDM.tdhTransporter
        //     ? inspectionDetails.dynamicHeaderResponseDM.tdhTransporter.toString()
        //     : "",
        // });

        // const transporterName =
        //   transporterObj && transporterObj.length > 0
        //     ? transporterObj[0].field1
        //     : "";
        // setTdhTransporter(transporterName);

        setTdhModelId(inspectionDetails.dynamicHeaderResponseDM.tdhModel);
        const modelObj = await getFieldValuesByTableAndId({
          tableName: "masterdata.tms_m_model",
          primaryKey: "mod_id",
          fieldNames: "mod_model",
          ids: inspectionDetails.dynamicHeaderResponseDM.tdhModel
            ? inspectionDetails.dynamicHeaderResponseDM.tdhModel.toString()
            : "",
        });

        const modelName =
          modelObj && modelObj.length > 0 ? modelObj[0].field1 : "";
        setTdhModel(modelName);

        setTdhTyreSize(inspectionDetails?.dynamicHeaderResponseDM?.tdhTyreSize);
        setTdhVehTypeSize(
          inspectionDetails?.dynamicHeaderResponseDM?.tdhVehTypeSize,
        );
        setTdhVehBodyType(
          inspectionDetails?.dynamicHeaderResponseDM?.tdhVehBodyType,
        );
        setTdhVehInspectionGroup(
          inspectionDetails?.dynamicHeaderResponseDM?.tdhVehInspectionGroup,
        );
        setTdhVehOperationType(
          inspectionDetails?.dynamicHeaderResponseDM?.tdhVehOperationType,
        );
        setTdhVehWidth(inspectionDetails?.dynamicHeaderResponseDM?.tdhVehWidth);
        setTdhVehLength(
          inspectionDetails?.dynamicHeaderResponseDM?.tdhVehLength,
        );
        setTdhVehHeight(
          inspectionDetails?.dynamicHeaderResponseDM?.tdhVehHeight,
        );

        setTdhDriverNic(
          inspectionDetails?.dynamicHeaderResponseDM?.tdhDriverNic,
        );
        setTdhDriverMobile(
          inspectionDetails?.dynamicHeaderResponseDM?.tdhDriverMobile,
        );
        setTdhDriverNicImg(
          inspectionDetails?.dynamicHeaderResponseDM?.tdhDriverNicImg
            ? "Yes"
            : "No",
        );
        setTdhDriverGsImg(
          inspectionDetails?.dynamicHeaderResponseDM?.tdhDriverGsImg
            ? "Yes"
            : "No",
        );
        setTdhDriverDrImg(
          inspectionDetails?.dynamicHeaderResponseDM?.tdhDriverDrImg
            ? "Yes"
            : "No",
        );
        setTdhDriverPoliceImg(
          inspectionDetails?.dynamicHeaderResponseDM?.tdhDriverPoliceImg
            ? "Yes"
            : "No",
        );

        if (inspectionDetails?.dynamicDataList?.length > 0) {
          const fieldList = [];
          const itemList = [];
          const chargeList = [];
          for (let row of inspectionDetails?.dynamicDataList) {
            const matchingTemplateField = theDataRow?.dynamicFields?.find(
              (templateField) => templateField.dyfId === row.tdfField,
            );

            // getting the exchange rate TODO: please ask from indusara the real way
            let currencyDetails;
            if (row.tdfCurrency === -1) {
              currencyDetails = JSON.stringify({
                excId: -1,
                excRate: 1,
                curCode: `${userCurrencyCode}: 1.00`,
              });
            } else {
              // Fetch currency details from the database for any other tdfCurrency value
              try {
                const response = await getFieldValuesByTableAndId({
                  tableName: "finance.tms_vf_exchange_rates",
                  primaryKey: "exc_id",
                  fieldNames: "exc_currency, exc_curr_code, exc_rate",
                  ids: row.tdfCurrency ? row.tdfCurrency.toString() : "",
                });

                const formattedExchange = {
                  excId: response[0].pkId,
                  excRate: response[0].field3,
                  curCode: `${response[0].field2}.${response[0].field3}`,
                };
                currencyDetails = JSON.stringify(formattedExchange);
              } catch (error) {
                currencyDetails = null; // Handle the case where the fetch fails
              }
            }
            const parsedExchangeData = JSON.parse(currencyDetails || "{}");

            const taxKey =
              row.tdfId ?? row.tdftSeq ?? row.tdfSeq ?? row.id ?? null;
            const rowTaxDetails =
              taxKey != null ? taxByRowKey[String(taxKey)] ?? [] : [];

            if (row.tdfIsItem) {
              itemList.push({
                ...row,
                item: row.tdfCommonDropdownValue,
                itemId: row.tdfCommonDropdown,
                exchangeData: {
                  ...parsedExchangeData,
                  applied: row.exchangeData?.applied || false,
                },
                tdfYearOfManu: row.tdfYearofmanu,
                tdfDateInstalled: row.tdfDateinstalled,
                tdfExpireDate: row.tdfExpireDate,
                // tdfUnitPrice: `${userCurrencyCode}.${row.tdfUnitPrice}.00` || 0,
                tdfUnitPrice: row.tdfUnitPrice || 0,
                unitPrice: row.tdfUnitPrice || 0,
                tdfDiscount: row.tdfDiscount || 0,
                tdfTaxAmount: row.tdfTax,
                taxDetails: rowTaxDetails,
              });
            } else if (
              row.tdfFieldType === 8 &&
              row.tdfCommonDropdownId === 22
            ) {
              chargeList.push({
                ...row,
                item: row.tdfCommonDropdownValue,
                itemId: row.tdfCommonDropdown,
                exchangeData: {
                  ...parsedExchangeData,
                  applied: row.exchangeData?.applied || false,
                },
                tdfYearOfManu: row.tdfYearofmanu,
                tdfDateInstalled: row.tdfDateinstalled,
                tdfExpireDate: row.tdfExpireDate,
                tdfItemId: row.tdfItemId,
                chargeItem: row.tdfChargeItemName,
                // tdfUnitPrice: `${userCurrencyCode}.${row.tdfUnitPrice}.00` || 0,
                tdfUnitPrice: row.tdfUnitPrice || 0,
                unitPrice: row.tdfUnitPrice || 0,
                tdfDiscount: row.tdfDiscount || 0,
                tdfTaxAmount: row.tdfTax,
                taxDetails: rowTaxDetails,
              });
            } else {
              fieldList.push({
                ...row,
                dfyAmountInfo: matchingTemplateField?.dfyAmountInfo,
                dfyAmount: matchingTemplateField?.dfyAmount,
                dfyDiscount: matchingTemplateField?.dfyDiscount,
                dfyDiscountInfo: matchingTemplateField?.dfyDiscountInfo,
                dyfFieldDescription: row.tdfDescription,
                dyfSatisfyLevel: parseInt(row.tdfSatisfyLevel),
                dyfFieldStatus: parseInt(row.tdfFieldStatus),
                dyfAmountValue: row.tdfAmount
                  ? parseFloat(row.tdfAmount)
                  : null,
                dyfDiscountValue: row.tdfDiscount
                  ? parseFloat(row.tdfDiscount)
                  : null,
                dyfId: parseInt(row.tdfField),
                dyfField: row.tdfFieldValue,
                dyfFieldType: parseInt(row.tdfFieldType),
                dyfRequired: row.tdfRequired,
                dyfCalculated: row.tdfCalculated,
                showSatisfyLevel: matchingTemplateField?.dyfSatisfyLevel,
                showFieldStatus: matchingTemplateField?.dyfFieldStatus,
                showDescription: matchingTemplateField?.dyfTdfDescription,
                dynamicDropdowns: row.dynamicDropdowns,
                dyfFieldValue:
                  row.tdfFieldType === 3
                    ? row.tdfValue
                    : row.tdfFieldType === 4
                      ? row.tdfDropdown
                        ? parseInt(row.tdfDropdown)
                        : null
                      : row.tdfFieldType === 5
                        ? row.tdfValue
                          ? // ? new Date(row.tdfValue).toISOString().split("T")[0]
                            formatToDateOnlyFromJsonDate(row.tdfValue)
                          : null
                        : row.tdfFieldType === 6
                          ? row.tdfBoolean === 1
                          : row.tdfFieldType === 7
                            ? row.tdfNumber
                              ? parseFloat(row.tdfNumber)
                              : null
                            : row.tdfFieldType === 8
                              ? row.tdfCommonDropdown
                                ? row.tdfCommonDropdown
                                : null
                              : null,
              });
            }
          }
          setDynamicFields(fieldList);
          setGridData(itemList);
          setChargeGridData(chargeList);
        } else {
          if (tdhTemplate) {
            const dataRow = await getDynamicTemplateById(tdhTemplate);
            const itemFieldinDynamic = dataRow?.dynamicFields?.find(
              (data) =>
                data.dyfFieldType === 8 && data.dfyCommonDropdown === 19,
            );
            if (itemFieldinDynamic) {
              setIsItemShown(true);
              setIsChargeShown(false);
              setActiveTab(1); // Item list tab
            } else {
              setIsItemShown(false);
              setIsChargeShown(true);
              setActiveTab(3); // Charge tab or fallback
            }
            setTabDataRow(dataRow);

            //Filter and store gridConfig using a new state
            setFilteredGridConfig(getFilteredGridConfig(dataRow));
            setFilteredModalGridConfig(getFilteredModalGridConfig(dataRow));
            setDynamicFields(
              dataRow?.dynamicFields.map((row) => ({
                ...row,
                dyfFieldValue:
                  row.dyfFieldType === 3
                    ? row.dyfDefaultValue ?? null
                    : row.dyfFieldType === 4
                      ? row.dyfDefaultValue
                        ? parseInt(row.dyfDefaultValue)
                        : null
                      : row.dyfFieldType === 5
                        ? row.dyfDefaultValue
                          ? formatToDateOnlyFromJsonDate(row.dyfDefaultValue)
                          : null
                        : row.dyfFieldType === 6
                          ? !!(
                              row.dyfDefaultValue &&
                              row.dyfDefaultValue === "true"
                            )
                          : row.dyfFieldType === 7
                            ? row.dyfDefaultValue
                              ? parseFloat(row.dyfDefaultValue)
                              : null
                            : null,
                dyfAmountValue: null,
                dyfDiscountValue: null,
                dyfFieldStatus: 3,
                dyfSatisfyLevel: 2,
                tdfCommonDropdownId: row.dfyCommonDropdown,
                showFieldStatus: row.dyfFieldStatus,
                showSatisfyLevel: row.dyfSatisfyLevel,
                showDescription: row.dyfTdfDescription,
              })),
            );
          }
        }

        const fleetChargesSet = await getFleetChargesByHeaderId(tdhId);
        if (fleetChargesSet.length > 0) {
          for (let row of fleetChargesSet) {
            row.createdDate = row.createdDate
              ? formatToDateOnlyFromJsonDate(row.createdDate)
              : "N/A";
            row.fcdIntigratedDate = row.fcdIntigratedDate
              ? formatToDateOnlyFromJsonDate(row.fcdIntigratedDate)
              : "N/A";
            row.fcdDescription = row.fcdDescription
              ? row.fcdDescription
              : "N/A";
          }
        }
        setFleetCharges(fleetChargesSet);

        try {
          const response = await getVehicleModalTyreDetails(
            inspectionDetails.dynamicHeaderResponseDM.tdhRefId,
          );

          if (response) {
            setTdhBaseDriverId(response.vehBasedDriver || "");
          }
        } catch (error) {
          console.error("Error fetching vehicle details:", error);
        }

        const documents = await getDocumentByOpeAndRef(16, tdhId);
        setDocuments(documents);
        setInfoLoading(false);
        // setActiveAccordion1(true);
      }
    })();
  }, [editMode, tdhId, isDm, tdhTemplate]);

  // Add this helper near your submit handlers
  const getAbsoluteDiscount = () => {
    return parseFloat(tdhDiscount || 0).toFixed(2);
  };

  const getTotalTaxAmount = () => {
    const currentGrid = isItemShown
      ? gridData
      : isChargeShown
        ? chargeGridData
        : [];
    return currentGrid
      .reduce((sum, row) => sum + (parseFloat(row.tdfTaxAmount) || 0), 0)
      .toFixed(2);
  };

  useEffect(() => {
    let currentGrid = [];
    if (activeTab) {
      if (isItemShown) {
        currentGrid = gridData;
      } else {
        currentGrid = chargeGridData;
      }
    }
    const totalDynamicAmount = dynamicFields.reduce(
      (acc, dynamic) => acc + parseFloat(dynamic.dyfAmountValue || 0),
      0,
    );
    const totalGridAmount = currentGrid.reduce(
      (acc, grid) => acc + parseFloat(grid.tdfAmount || 0),
      0,
    );
    const totalAmount = totalDynamicAmount + totalGridAmount;
    setTdhValue(totalAmount.toFixed(2));
  }, [dynamicFields, gridData, chargeGridData, activeTab]);

  // useEffect(() => {
  //   let currentGrid = [];
  //   if (activeTab) {
  //     if (isItemShown) {
  //       currentGrid = gridData;
  //     } else {
  //       currentGrid = chargeGridData;
  //     }
  //   }
  //   const totalDynamicAmount = dynamicFields.reduce(
  //     (acc, dynamic) => acc + parseFloat(dynamic.dyfAmountValue || 0),
  //     0,
  //   );
  //   const totalGridAmount = currentGrid.reduce(
  //     (acc, grid) => acc + parseFloat(grid.tdfAmount || 0),
  //     0,
  //   );

  //   // const totalDynamicDiscount = dynamicFields.reduce(
  //   //   (acc, dynamic) => acc + parseFloat(dynamic.dyfDiscountValue || 0),
  //   //   0,
  //   // );

  //   // const totalDiscountAmount = totalDynamicAmount - totalDynamicDiscount;

  //   const totalAmount = totalDynamicAmount + totalGridAmount;

  //   setTdhValue(totalAmount.toFixed(2));
  // }, [dynamicFields, gridData, chargeGridData, activeTab]);

  useEffect(() => {
    if (!isDm) {
      let count = 0;
      let totalRows = 0;

      dynamicFields?.forEach((row) => {
        if (
          !(
            (row.dyfFieldType === 8 && row.dfyCommonDropdown === 19) ||
            row.dfyCommonDropdown === 22
          )
        ) {
          // Exclude specific items
          totalRows++;
          if (row.dyfSatisfyLevel === 2) {
            count++;
          }
        }
      });

      let percentage = totalRows > 0 ? (count * 100) / totalRows : 0;
      setTdhOverall(percentage);
    }

    if (isDm) {
      setActiveAccordion1(false);
    }
  }, [dynamicFields, isDm]);

  useEffect(() => {
    if (!tdhTemplate) {
      setTdhNextUom("");
      setTdhNextValue("");
    }
  }, [tdhTemplate]);

  useEffect(() => {
    (async () => {
      if (!editMode) {
        if (tdhTemplate) {
          setDynamicFieldsLoading(true);
          const dataRow = await getDynamicTemplateById(tdhTemplate);
          setTabDataRow(dataRow);
          setInsReportType(dataRow?.dyhReportType);
          setTdhInspectionType(dataRow?.dyhInspectionType);
          setTdhCategory(dataRow?.dyhCategory);
          // ✅ Filter and store gridConfig using a new state
          setFilteredGridConfig(getFilteredGridConfig(dataRow));
          setFilteredModalGridConfig(getFilteredModalGridConfig(dataRow));
          setTdhNextUom(dataRow?.dyhNextUom);

          const nextUomValue = await getTextByValueAndKey(
            "UOM",
            dataRow?.dyhNextUom,
          );

          setTdhNextUomValue(nextUomValue);

          setTdhNextValue(dataRow?.dyhNextInspection);
          setNextActionKm(
            dataRow?.dyhNextKm ? dataRow.dyhNextKm.toString() : null,
          );
          const dynamicFieldList = [];
          let dynamicRateField;
          let dynamicChargeField;

          for (let row of dataRow?.dynamicFields) {
            if (row.dyfFieldType === 8 && row.dfyCommonDropdown === 19) {
              setActiveTab(1);
              setIsItemShown(true);
              setIsChargeShown(false);
              dynamicRateField = row;
            }

            if (row.dyfFieldType === 8 && row.dfyCommonDropdown === 22) {
              setIsItemShown(false);
              setIsChargeShown(true);
              setActiveTab(3);
              dynamicChargeField = row;
            }
            dynamicFieldList.push({
              ...row,
              dyfFieldValue:
                row.dyfFieldType === 3
                  ? row.dyfDefaultValue ?? null
                  : row.dyfFieldType === 4
                    ? row.dyfDefaultValue
                      ? parseInt(row.dyfDefaultValue)
                      : null
                    : row.dyfFieldType === 5
                      ? row.dyfDefaultValue
                        ? formatToDateOnlyFromJsonDate(row.dyfDefaultValue)
                        : null
                      : row.dyfFieldType === 6
                        ? row.dyfDefaultValue && row.dyfDefaultValue === "true"
                          ? true
                          : false
                        : row.dyfFieldType === 7
                          ? row.dyfDefaultValue
                            ? parseFloat(row.dyfDefaultValue)
                            : null
                          : null,
              dyfAmountValue: null,
              dyfDiscountValue: null,
              dyfFieldStatus: 3,
              dyfSatisfyLevel: 2,
              showFieldStatus: row.dyfFieldStatus,
              showSatisfyLevel: row.dyfSatisfyLevel,
              showDescription: row.dyfTdfDescription,
            });
          }

          setDynamicFields(dynamicFieldList);

          setItemDynamicField(dynamicRateField);
          setChargeDynamicField(dynamicChargeField);
          setDynamicFieldsLoading(false);
          // setActiveAccordion1(true);
        }
      }
    })();
  }, [tdhTemplate, editMode]);

  useEffect(() => {
    (async () => {
      setDropdownValuesLoading(true);

      const {
        "uom#time2": uomOpt,
        "uom#dep": depUomOpt,
        active: activeOptions,
        sub_action: subActOptions,
        cash_type: CashTypeOptions,
        doc_type: docTypeData,
        "file_name#15": fileNameData,
        satisfy_level: satisfyOpt,
        accident_status: fieldStatusOpt,
        brand: theBrandOptions,
        tyre_type: theTyreType,
        tread_pattern: TheTreadPattern,
        position_fixed: thePositionFix,
      } = await getBulkDropdownData([
        { key: "uom", group: "time2" },
        { key: "uom", group: "dep" },
        { key: "active" },
        { key: "sub_action" },
        { key: "cash_type" },
        { key: "doc_type" },
        { key: "file_name", group: "15" },
        { key: "satisfy_level" },
        { key: "accident_status" },
        { key: "yesno" },
        { key: "brand" },
        { key: "tyre_type" },
        { key: "tread_pattern" },
        { key: "position_fixed" },
      ]);

      setUomOptions(uomOpt);
      setDepUomOptions(depUomOpt);
      setActiveOpt(activeOptions);
      setSubActionOpt(subActOptions);
      setCashTypeOptions(CashTypeOptions);
      setDocumentTypeOptions(docTypeData);
      setFileNameOptions(fileNameData);
      setSatisfyLevelOptions(satisfyOpt);
      setFieldStatusOptions(fieldStatusOpt);
      setBrandOptions(theBrandOptions);
      setTyreTypeOpt(theTyreType);
      setTreadPatternOpt(TheTreadPattern);
      setPositionFixedOpt(thePositionFix);

      // const chargeDetailOptions = await getAllCharges();
      const chargeDetailOptions = await getAllChargesWithItem();
      setChargesOptions(chargeDetailOptions);

      const tyreData = await tyreDropdown();
      setTyreSizeOpt(tyreData);

      const taxDrop = await taxdropdown();
      setTaxOptions(taxDrop);

      const depreciationOpt = await getDropdownData("yesno");
      depreciationOptions.current = depreciationOpt;

      const exchangeSelection = await getExchangeSelectionValues({
        baseCurrency: tdfCurrency,
        headerId: -1, // editMode ? jobInfo?.jobChargeHeader?.chhId : -1
        currency: null,
        bank: null,
        branch: null,
        user: user.username,
        company: company,
      });
      setExchangeRates(exchangeSelection);

      const baseCurrency = {
        excId: -1,
        excRate: 1,
        curCode: `${userCurrencyCode}: 1.00`,
      };

      setSelectedCurrency(JSON.stringify(baseCurrency));
      setSelectedExchangeRate(baseCurrency.excRate);

      setDropdownValuesLoading(false);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (!tdhCategory || !tdhInspectionType) return;
      setTemplateSetLoading(true);
      const templateSet = await getDynamicTemplatesByManagementTypeAndCategory(
        tdhInspectionType,
        tdhCategory,
      );

      const templateSetOptions = templateSet?.map((template) => ({
        key: template.dyhId,
        value: template.dyhId,
        text: template.dyhTemplate,
      }));
      setTemplateOptions(templateSetOptions);
      setTemplateSetLoading(false);
    })();
  }, [tdhCategory, tdhInspectionType]);

  useEffect(() => {
    if (tabDataRow) {
      // ✅ Set active tab based on dataRow BEFORE filtering
      if (
        tabDataRow.dynamicFields.some(
          (field) => field.dyfFieldType === 8 && field.dfyCommonDropdown === 19,
        )
      ) {
        setIsItemShown(true);
        setIsChargeShown(false);
        // setActiveTab(1);
      } else if (
        tabDataRow.dynamicFields.some(
          (field) => field.dyfFieldType === 8 && field.dfyCommonDropdown === 22,
        )
      ) {
        setIsItemShown(false);
        setIsChargeShown(true);
        // setActiveTab(3);
      }
      setFilteredGridConfig(getFilteredGridConfig(tabDataRow));
      setFilteredModalGridConfig(getFilteredModalGridConfig(tabDataRow));
    }
  }, [tabDataRow, activeTab]);

  useEffect(() => {
    if (tdhTransporterId) {
      searchDropdownRef.current?.refreshResults?.();
    }
  }, [tdhTransporterId]);

  const nextButtonHandler = () => {
    if (tab === 1) {
      let documentManagementErrors = {};
      if (!isDm) {
        let isError = false;
        if (thdDepreciation === 1) {
          documentManagementErrors = documentManagementValidation({
            tdhCategory,
            tdhInspectionType,
            tdhTemplate,
            tdhRefId,
            tdhDriverId,
            // tdhActionDate,
            tdhOverall,
            tdhOverallStatus,
            // tdhMillage: tdhMilage,
            tdhTotal: tdhTotal,
            tdhValue: tdhValue,
            tdhStatus,
            tdhActive,
            thdDepreciation,
            thdDepreciationValue,
            thdDepreciationUom,
            thdDepreciationDate,
          });
        } else {
          documentManagementErrors = documentManagementValidation({
            tdhCategory,
            tdhInspectionType,
            tdhTemplate,
            tdhRefId,
            tdhDriverId,
            // tdhNextValue,
            // tdhNextUom,
            // tdhActionDate,
            tdhOverall,
            tdhOverallStatus,
            // tdhNextDate,
            // tdhMillage: tdhMilage,
            tdhTotal: tdhTotal,
            tdhValue: tdhValue,
            tdhStatus,
            tdhActive,
            thdDepreciation,
          });
        }

        if (Object.entries(documentManagementErrors).length > 0) {
          isError = true;
        }

        if (
          documentManagementErrors.tdhRefId ||
          documentManagementErrors.tdhDriverId
        ) {
          setActiveAccordionHeader(true);
        }
        // if (
        //   documentManagementErrors.tdhActionDate ||
        //   documentManagementErrors.tdhMillage
        // ) {
        //   setActiveAccordionAlerts(true);
        // }

        let dynamicFieldErrors = {};
        dynamicFields?.forEach((row) => {
          // ✅ Check if the field is an Item List
          const isItemList =
            parseInt(row.dyfFieldType) === 8 &&
            parseInt(row.dfyCommonDropdown) === 19;
          const isChargeList =
            parseInt(row.dyfFieldType) === 8 &&
            parseInt(row.dfyCommonDropdown) === 22;

          let currentGrid = [];
          if (isItemShown) {
            currentGrid = gridData;
          } else if (isChargeShown) {
            currentGrid = chargeGridData;
          }
          if (row.dyfRequired) {
            if (isItemList || isChargeList) {
              if (!currentGrid || currentGrid.length === 0) {
                dynamicFieldErrors = {
                  ...dynamicFieldErrors,
                  [row.dyfField]: {
                    ...dynamicFieldErrors[row.dyfField],
                    dyfFieldValue: "At least one item is required",
                  },
                };
                isError = true;
                if (isItemList) setIsItemListMissing(true);
                if (isChargeList) setIsChargeListMissing(true);
              }
            } else {
              // ✅ Only run this for normal fields now
              if (
                !row.dyfFieldValue ||
                row.dyfFieldValue === null ||
                row.dyfFieldValue === ""
              ) {
                dynamicFieldErrors = {
                  ...dynamicFieldErrors,
                  [row.dyfField]: {
                    ...dynamicFieldErrors[row.dyfField],
                    dyfFieldValue: "Value is required",
                  },
                };
                isError = true;
              }
            }

            // ✅ Validate Satisfy Level
            if (!row.dyfSatisfyLevel || row.dyfSatisfyLevel === null) {
              dynamicFieldErrors = {
                ...dynamicFieldErrors,
                [row.dyfField]: {
                  ...dynamicFieldErrors[row.dyfField],
                  dyfSatisfyLevel: "Satisfy level is required",
                },
              };
              isError = true;
            }

            // ✅ Validate Field Status
            if (!row.dyfFieldStatus || row.dyfFieldStatus === null) {
              dynamicFieldErrors = {
                ...dynamicFieldErrors,
                [row.dyfField]: {
                  ...dynamicFieldErrors[row.dyfField],
                  dyfFieldStatus: "Field status is required",
                },
              };
              isError = true;
            }
          }
        });

        if (isError) {
          toast.error("Fill all required fields in this tab", {
            autoClose: 5000,
            containerId: "Main",
          });
          setDynamicErrors(dynamicFieldErrors);
          setCurrentErrors(documentManagementErrors);
          setActiveAccordion1(true);
          return;
        } else {
          setTab(2);
          setDynamicErrors({});
          setCurrentErrors({});
        }
      } else {
        documentManagementErrors = documentManagementValidation({
          tdhCategory,
          tdhInspectionType,
          tdhTemplate,
          tdhRefId,
          tdhDriverId,
          tdhNextValue,
          tdhNextUom,
          // tdhActionDate,
          // tdhOverall,
          // tdhOverallStatus,
          // tdhNextDate,
          // tdhMillage: tdhMilage,
          tdhValue: tdhValue,
          // tdhStatus,
          // tdhActive,
        });

        if (Object.entries(documentManagementErrors).length > 0) {
          toast.error("Fill all required fields in this tab", {
            autoClose: 5000,
            containerId: "Main",
          });
          setCurrentErrors(documentManagementErrors);

          if (
            documentManagementErrors.tdhRefId ||
            documentManagementErrors.tdhDriverId
          ) {
            setActiveAccordionHeader(true);
          }
          // if (
          //   documentManagementErrors.tdhActionDate ||
          //   documentManagementErrors.tdhMillage
          // ) {
          //   setActiveAccordionAlerts(true);
          // }
          return;
        } else {
          setCurrentErrors({});
          setTab(2);
        }
      }
    } else if (tab === 2) {
      setTab(next());
    }
  };

  const resetForm = () => {
    setTdhCategory("");
    setTdhInspectionType("");
    setTdhTemplate("");
    setTdhNextValue("");
    setTdhNextUom("");
    setTdhActionDate("");
    setTdhNextDate("");
    setTdhDescription("");
    setTdhOverallStatus("");
    setSelectedJobs({});
    setTdhOverall(0);
    setTdhStatus(2);
    setPersistedTdhStatus("");
    setTdhActive(1);
    setTdhUom(null);
    setTdhMilage("");
    setTdhValue("");
    setTdhRefId("");
    setTdhTotal("");
    setTdhPercentage(2);
    setTdhDiscount("");

    setThdDepreciation(2);
    setThdDepreciationValue(null);
    setThdDepreciationUom(null);
    setThdDepreciationDate(null);

    setTdhCashCredit(0);
    setTdhSubAction(0);
    setTdhExcRate(null);
    setTdhExcId(null);
    setTdhTransporter("");
    setTdhTransporterId("");

    setTdhSupplier("");
    setTdhModelId("");
    setTdhModel("");
    setTdhNumTyres("");
    setTdhDriverId("");
    driverRef.current.reset();
    setTdhVehTypeSize("");
    setTdhVehBodyType("");
    setTdhVehInspectionGroup("");
    setTdhVehOperationType("");
    setTdhVehWidth("");
    setTdhVehLength("");
    setTdhVehHeight("");

    setTdhApprovedBy("");
    setCreatedBy("");

    setTdhDriverNic("");
    setTdhDriverMobile("");
    setTdhDriverNicImg("");
    setTdhDriverGsImg("");
    setTdhDriverDrImg("");
    setTdhDriverPoliceImg("");

    setDynamicFields([]);
    setDocuments([]);
    setDeletedList([]);
    setFleetCharges([]);
  };

  const documentCreationHandler = async () => {
    closeModal();
    setIsSubmitLoading(true);
    setIsBlurred(true);

    const documentManagementErrors = documentManagementValidation({
      tdhCategory,
      tdhInspectionType,
      tdhTemplate,
      tdhRefId,
      tdhNextValue,
      tdhNextUom,
      // tdhActionDate,
      tdhDriverId,
      // tdhMillage: tdhMilage,
      tdhTotal: tdhTotal,
      tdhValue: tdhValue,
    });

    if (Object.entries(documentManagementErrors).length > 0) {
      toast.error("Fill all required fields", {
        autoClose: 5000,
        containerId: "Main",
      });
      setCurrentErrors(documentManagementErrors);
      if (
        documentManagementErrors.tdhRefId ||
        documentManagementErrors.tdhDriverId
      ) {
        setActiveAccordionHeader(true);
      }

      // if (
      //   documentManagementErrors.tdhActionDate ||
      //   documentManagementErrors.tdhMillage
      // ) {
      //   setActiveAccordionAlerts(true);
      // }
      setIsSubmitLoading(false);
      setIsBlurred(false);
      return;
    }

    if (!editMode) {
      const documents = documentRef.current.getData();
      // Check for document presence
      if (documents.length === 0) {
        toast.warning("Submitted without any documents.", {
          autoClose: 5000,
          containerId: "Main",
        });
        setIsSubmitLoading(false);
        setIsBlurred(false);
      }
      if (tdhStatus === 1) {
        try {
          const parsedCurrency =
            typeof selectedCurrency === "string"
              ? JSON.parse(selectedCurrency)
              : selectedCurrency;
          const data = {
            dynamicHeaderRequestDM: {
              tdhReferance,
              tdhCompany,
              tdhCategory,
              tdhInspectionType,
              tdhTemplate,
              tdhRefId,
              tdhNextValue,
              tdhSubAction,
              tdhNextUom,
              tdhTransporter: tdhTransporterId,
              tdhModel: tdhModelId,
              tdhDriver: tdhDriverId,
              tdhSupplier,
              tdhNumTyres,
              tdhTyreSize,
              tdhCashCredit,
              tdhActionDate,
              tdhActionTaken,
              tdhDescription,
              tdhOverall,
              tdhOverallStatus,
              tdhUom,
              tdhNextDate,
              tdhMillage: tdhMilage,
              tdhNextInspectionKm: tdhNextMilage,
              tdhNextActionKm: nextActionKm ? nextActionKm.toString() : "0",
              tdhTotal: tdhTotal,
              tdhPercentage: tdhPercentage,
              tdhDiscount: getAbsoluteDiscount(),
              // tdhDiscount: tdhDiscount,
              tdhValue: tdhValue,
              tdhStatus,
              tdhActive,
              thdDepreciation,
              thdDepreciationValue,
              thdDepreciationUom,
              thdDepreciationDate,
              tdhExcId: parsedCurrency.excId,
              tdhExcRate: parsedCurrency.excRate,
              createdBy: user.username,
              tdhInspectedPlace: tdhInspectedPlace,
              tdhVehTypeSize,
              tdhVehBodyType,
              tdhVehInspectionGroup,
              tdhVehOperationType,
              tdhVehWidth,
              tdhVehLength,
              tdhVehHeight,
              tdhDriverNic,
              tdhDriverMobile,
              tdhDriverNicImg:
                tdhDriverNicImg === "Yes" || tdhDriverNicImg === "yes"
                  ? true
                  : false,
              tdhDriverGsImg:
                tdhDriverGsImg === "Yes" || tdhDriverGsImg === "yes"
                  ? true
                  : false,
              tdhDriverDrImg:
                tdhDriverDrImg === "Yes" || tdhDriverDrImg === "yes"
                  ? true
                  : false,
              tdhDriverPoliceImg:
                tdhDriverPoliceImg === "Yes" || tdhDriverPoliceImg === "yes"
                  ? true
                  : false,
            },
            dynamicHeaderRefRequestList: Object.keys(selectedJobs).map(
              (jobKey) => ({
                dyjId: null,
                dyjCode: null,
                dyjReferance: null,
                dyjCompany: 1,
                dyjDyhId: null,
                dyjOpeType: 1,
                dyjOpeRefId: parseInt(jobKey, 10),
                dyjStatus: 2,
                dyjActive: 1,
                createdBy: user.username,
                lastModifiedBy: null,
              }),
            ),
          };

          const response = await saveDocumentManagement(data);

          if (response?.status === 200) {
            const documents = documentRef.current.getData();
            let hasUploadErrors = false;
            if (documents.length > 0) {
              for (let doc of documents) {
                const { file, ...rest } = doc;
                const formData = new FormData();
                formData.append("multipartFile", doc.file);
                formData.append(
                  "documentRequest",
                  JSON.stringify({
                    ...rest,
                    docReference: response.data.tdhId,
                  }),
                );
                formData.append("isImage", rest.docCategory === 1);
                const res = await addAndUpload(formData);
                if (res && res?.responseCode === "2040") {
                  toast.success(res?.message, {
                    autoClose: 5000,
                    containerId: "Main",
                  });
                } else {
                  hasUploadErrors = true;
                  documentRef.current.markUploadFailed(doc.id ?? doc.fileName);
                  toast.error(
                    res?.message || `Error adding document ${doc.docName}`,
                    {
                      autoClose: 5000,
                      containerId: "Main",
                    },
                  );
                }
              }
            }

            toast.success(response.data.tdhCode + " Created Successfully..", {
              autoClose: 5000,
              containerId: "Main",
            });

            if (hasUploadErrors) {
              setIsSubmitLoading(false);
              setIsBlurred(false);
              return;
            }

            resetForm();
            handleDrawerClose();
            setEditMode(false);
            setDynamicFields([]);
            // setUpdateNeeded(true);
          } else {
            toast.error("Failed to create", {
              autoClose: 5000,
              containerId: "Main",
            });
          }
        } catch (e) {
          console.error(e);
        }
      } else {
        openModal();
      }
    } else {
      try {
        const data = {
          dynamicHeaderRequestDM: {
            tdhReferance,
            tdhCompany,
            tdhCategory,
            tdhInspectionType,
            tdhTemplate,
            tdhRefId,
            tdhSubAction,
            tdhCashCredit,
            tdhNextValue,
            tdhNextUom,
            tdhActionDate,
            tdhTransporter: tdhTransporterId,
            tdhModel: tdhModelId,
            tdhDriver: tdhDriverId,
            tdhSupplier,
            tdhNumTyres,
            tdhTyreSize,
            tdhActionTaken,
            tdhDescription,
            tdhOverall,
            tdhOverallStatus,
            tdhUom,
            tdhNextDate,
            tdhMillage: tdhMilage,
            tdhNextInspectionKm: tdhNextMilage,
            tdhNextActionKm: nextActionKm ? nextActionKm.toString() : "0",
            tdhTotal: tdhTotal,
            tdhPercentage: tdhPercentage,
            tdhDiscount: getAbsoluteDiscount(),
            // tdhDiscount: tdhDiscount,
            tdhValue: tdhValue,
            tdhStatus,
            tdhActive,
            thdDepreciation,
            thdDepreciationValue,
            thdDepreciationUom,
            thdDepreciationDate,
            createdBy: user.username,
            tdhInspectedPlace: tdhInspectedPlace,
            tdhVehTypeSize,
            tdhVehBodyType,
            tdhVehInspectionGroup,
            tdhVehOperationType,
            tdhVehWidth,
            tdhVehLength,
            tdhVehHeight,
            tdhDriverNic,
            tdhDriverMobile,
            tdhDriverNicImg:
              tdhDriverNicImg === "Yes" || tdhDriverNicImg === "yes"
                ? true
                : false,
            tdhDriverGsImg:
              tdhDriverGsImg === "Yes" || tdhDriverGsImg === "yes"
                ? true
                : false,
            tdhDriverDrImg:
              tdhDriverDrImg === "Yes" || tdhDriverDrImg === "yes"
                ? true
                : false,
            tdhDriverPoliceImg:
              tdhDriverPoliceImg === "Yes" || tdhDriverPoliceImg === "yes"
                ? true
                : false,
          },
          dynamicHeaderRefRequestList: Object.keys(selectedJobs).map(
            (jobKey) => {
              const existing = dynamicHeaderRefResponses.find(
                (ref) => ref.dyjOpeRefId === parseInt(jobKey, 10),
              );
              return {
                dyjId: existing ? existing.dyjId : null,
                dyjCode: existing ? existing.dyjCode : null,
                dyjReferance: existing ? existing.dyjReferance : null,
                dyjCompany: 1,
                dyjDyhId: existing ? existing.dyjDyhId : null,
                dyjOpeType: 1,
                dyjOpeRefId: parseInt(jobKey, 10),
                dyjStatus: 2,
                dyjActive: 1,
                createdBy: user.username,
                lastModifiedBy: existing ? existing.lastModifiedBy : null,
              };
            },
          ),
        };

        const response = await updateDocumentManagement(tdhId, data);

        if (response?.status === 200) {
          const documents = documentRef.current.getData();
          let hasUploadErrors = false;
          for (let doc of documents.created) {
            const { file, ...rest } = doc;
            const formData = new FormData();
            formData.append("multipartFile", doc.file);
            formData.append("documentRequest", JSON.stringify(rest));
            formData.append("isImage", rest.docCategory === 1);
            const res = await addAndUpload(formData);
            if (res && res?.responseCode === "2040") {
              toast.success(res?.message, {
                autoClose: 5000,
                containerId: "Main",
              });
            } else {
              hasUploadErrors = true;
              documentRef.current.markUploadFailed(doc.id ?? doc.fileName);
              toast.error(
                res?.message || `Error adding document ${doc.docName}`,
                {
                  autoClose: 5000,
                  containerId: "Main",
                },
              );
            }
          }

          for (let doc of documents.modified) {
            const { file, ...rest } = doc;
            const formData = new FormData();
            formData.append("multipartFile", doc.file);
            formData.append("documentRequest", JSON.stringify(rest));
            formData.append("isImage", rest.docCategory === 1);
            const res = await updateAndUpload(formData);
            if (res && res?.responseCode === "2040") {
              toast.success(res?.message, {
                autoClose: 5000,
                containerId: "Main",
              });
            } else {
              hasUploadErrors = true;
              toast.error(
                res?.message || `Error updating document ${doc.docName}`,
                {
                  autoClose: 5000,
                  containerId: "Main",
                },
              );
            }
          }

          if (documents?.deleted.length > 0) {
            await deleteDocumentList({
              docIdList: documents?.deleted,
            });
            toast.success("Documents deleted successfully!", {
              autoClose: 5000,
              containerId: "Main",
            });
          }

          toast.success(tdhCode + " Updated Successfully..", {
            autoClose: 5000,
            containerId: "Main",
          });

          if (hasUploadErrors) {
            setIsSubmitLoading(false);
            setIsBlurred(false);
            return;
          }

          resetForm();
          handleDrawerClose();
          setEditMode(false);
          setDynamicFields([]);
          // setUpdateNeeded(true);
        }
      } catch (e) {
        toast.error("Failed to update", {
          autoClose: 5000,
          containerId: "Main",
        });
        console.error(e);
      }
    }

    setIsBlurred(false);
    setIsSubmitLoading(false);
  };

  const combinedDataList = [];

  dynamicFields.forEach((field) => {
    let baseRecord = {
      tdfId: null,
      tdfReferance: null,
      tdfCompany: 1,
      tdfField: field.dyfId,
      tdfValue:
        field.dyfFieldType === 3
          ? field.dyfFieldValue
          : field.dyfFieldType === 5
            ? new Date(field.dyfFieldValue)
            : null,
      tdfNumber:
        field.dyfFieldType === 7
          ? parseFloat(field.dyfFieldValue) || null
          : null,
      tdfDropdown:
        field.dyfFieldType === 4 ? parseInt(field.dyfFieldValue) || null : null,
      tdfCommonDropdownId: field.dfyCommonDropdown || null,
      tdfCommonDropdown:
        field.dyfFieldType === 8 ? parseInt(field.dyfFieldValue) || null : null,
      tdfCommonValue:
        field.dyfFieldType === 8 ? parseInt(field.dyfFieldValue) || null : null,
      tdfBoolean:
        field.dyfFieldType === 6 ? (field.dyfFieldValue ? 1 : 0) : null,
      tdfSatisfyLevel: field.dyfSatisfyLevel,
      tdfFieldStatus: field.dyfFieldStatus,
      tdfAmount: field.dyfAmountValue || 0,
      tdfDiscount: field.dyfDiscountValue || 0,
      tdfUom: field.dyfUom || null,
      tdfDescription: field.dyfFieldDescription,
      tdfRequired: field.dyfRequired,
      tdfSeq: field.dyfSeq,
      tdfPercentage: null,
      tdfStatus: field.dyfStatus,
      tdfActive: field.dyfActive,
      tdfCalculated: field.dyfCalculated,
    };

    if (field.dyfFieldType === 8 && field.dfyCommonDropdown === 19) {
      //This is an Item List entry, merge with gridData
      const relatedItems = gridData.filter((item) => item.itemId);
      if (relatedItems.length > 0) {
        relatedItems.forEach((item) => {
          combinedDataList.push({
            ...baseRecord,
            tdfCommonDropdownId:
              field.dfyCommonDropdown || item.tdfCommonDropdownId,
            tdfCommonDropdown: item.itemId, // Links to itemId
            tdfFieldType: field.dyfFieldType || item.tdfFieldType,
            tdfQty: parseFloat(item.tdfQty) || null,
            tdfUnitPrice: item.unitPrice || null,
            tdfCurrency: item.tdfCurrency || null,
            tdfAmount: parseFloat(item.tdfAmount),
            tdfDiscount: parseFloat(item.tdfDiscount) || field.tdfDiscount,
            tdfExpire: item.tdfExpire || null,
            tdfExpireDate: item.tdfExpireDate || null,
            tdfBrand: parseInt(item.tdfBrand) || null,
            tdfYearOfManu: item.tdfYearOfManu || null,
            tdfDateInstalled: item.tdfDateInstalled || null,
            tdfPercentage: item.tdfPercentage || null,
            tdftSeq: item.tdftSeq || null,
            tdfSerial: item.tdfSerial || null,
            tdfTyreType: item.tdfTyreType ? parseInt(item.tdfTyreType) : null, // 🔥 Ensure it's a Long
            tdfTreadPattern: item.tdfTreadPattern
              ? parseInt(item.tdfTreadPattern)
              : null, // 🔥 Ensure it's a Long
            tdfMillageUsed: item.tdfMillageUsed || null,
            tdfPositionFixed: parseInt(item.tdfPositionFixed) || null,
            tdfTax: parseFloat(item.tdfTaxAmount) || null,
            tdfTotalAmount: parseFloat(item.tdfTotalAmount) || null,
          });
        });
      } else {
        // No gridData, add ItemList field separately
        combinedDataList.push(baseRecord);
      }
    } else if (field.dyfFieldType === 8 && field.dfyCommonDropdown === 22) {
      // This is an Item List entry, merge with gridData
      const relatedItems = chargeGridData.filter((item) => item.itemId);
      if (relatedItems.length > 0) {
        relatedItems.forEach((item) => {
          combinedDataList.push({
            ...baseRecord,
            tdfCommonDropdownId:
              field.dfyCommonDropdown || item.tdfCommonDropdownId,
            tdfCommonDropdown: item.itemId, // Links to itemId
            tdfItemId: item.tdfItemId || null,
            tdfFieldType: field.dyfFieldType || item.tdfFieldType,
            tdfQty: parseFloat(item.tdfQty) || null,
            tdfUnitPrice: item.unitPrice || null,
            tdfCurrency: item.tdfCurrency || null,
            tdfAmount: parseFloat(item.tdfAmount),
            tdfDiscount: parseFloat(item.tdfDiscount) || field.tdfDiscount,
            tdfExpire: item.tdfExpire || null,
            tdfExpireDate: item.tdfExpireDate || null,
            tdfBrand: parseInt(item.tdfBrand) || null,
            tdfYearOfManu: item.tdfYearOfManu || null,
            tdfDateInstalled: item.tdfDateInstalled || null,
            tdfPercentage: item.tdfPercentage || null,
            tdfSerial: item.tdfSerial || null,
            tdfTyreType: item.tdfTyreType ? parseInt(item.tdfTyreType) : null, // 🔥 Ensure it's a Long
            tdfTreadPattern: item.tdfTreadPattern
              ? parseInt(item.tdfTreadPattern)
              : null, // 🔥 Ensure it's a Long
            tdfMillageUsed: item.tdfMillageUsed || null,
            tdfPositionFixed: parseInt(item.tdfPositionFixed) || null,
            tdfTax: parseFloat(item.tdfTaxAmount) || null,
            tdfTotalAmount: parseFloat(item.tdfTotalAmount) || null,
          });
        });
      } else {
        // No gridData, add ItemList field separately
        combinedDataList.push(baseRecord);
      }
    } else {
      // Normal Field Entry
      combinedDataList.push(baseRecord);
    }
  });

  // Use combined list in payload
  const dynamicDataRequestDMList = combinedDataList;

  const createUpdateInspectionDataList = () => {
    let currentGrid = [];
    if (isItemShown) {
      currentGrid = gridData;
    } else if (isChargeShown) {
      currentGrid = chargeGridData;
    }
    const combinedDataList = [];

    // Process dynamic fields (Excluding `dyfFieldType === 8 && dyfCommonDropdown === 19`)
    const filteredDynamicFields = dynamicFields.filter(
      (field) =>
        !(
          parseInt(field.dyfFieldType) === 8 &&
          parseInt(field.dfyCommonDropdown) === 19
        ),
    );

    filteredDynamicFields.forEach((field, index) => {
      let baseRecord = {
        tdfId: field.tdfId,
        tdfCode: field.tdfCode,
        tdfTdhId: tdhId,
        tdfReferance: field.tdfReferance || "",
        tdfCompany: 1,
        tdfField: field.dyfId,
        tdfValue:
          field.dyfFieldType === 3
            ? field.dyfFieldValue
            : field.dyfFieldType === 5
              ? new Date(field.dyfFieldValue)
              : null,
        tdfAmount: field.dyfAmountValue || 0,
        tdfDiscount: field.dyfDiscountValue || 0,
        tdfNumber:
          field.dyfFieldType === 7
            ? parseFloat(field.dyfFieldValue) || null
            : null,
        tdfDropdown:
          field.dyfFieldType === 4
            ? parseInt(field.dyfFieldValue) || null
            : null,
        tdfCommonDropdownId: field.dfyCommonDropdown || null,
        tdfCommonDropdown:
          field.dyfFieldType === 8
            ? parseInt(field.dyfFieldValue) || null
            : null,
        tdfCommonValue:
          field.dyfFieldType === 8
            ? parseInt(field.dyfFieldValue) || null
            : null,
        tdfBoolean:
          field.dyfFieldType === 6 ? (field.dyfFieldValue ? 1 : 0) : null,
        tdfSatisfyLevel: field.dyfSatisfyLevel,
        tdfFieldStatus: field.dyfFieldStatus,
        tdfUom: field.dyfUom || null,
        tdfDescription: field.dyfFieldDescription,
        tdfRequired: field.dyfRequired,
        tdfCalculated: field.dyfCalculated,
        tdfSeq: field.dyfSeq,
        tdftSeq: field.tdftSeq || null,
        tdfPercentage: null,
        tdfStatus: field.dyfStatus,
        tdfActive: field.dyfActive,
      };

      // 🔥 Handle Item List Entries (dyfFieldType === 8 && dyfCommonDropdown === 19)
      if (
        parseInt(field.dyfFieldType) === 8 &&
        parseInt(field.dyfCommonDropdown) === 19
      ) {
        const relatedItems = gridData.filter((item) => item.itemId);

        if (relatedItems.length > 0) {
          relatedItems.forEach((item, itemIndex) => {
            let newRecord = {
              ...baseRecord,
              tdfCommonDropdownId:
                field.dyfCommonDropdown || item.tdfCommonDropdownId, // Link field to itemId
              tdfCommonDropdown: item.itemId,
              tdfQty: item.tdfQty || null,
              tdfFieldType: field.dyfFieldType || item.tdfFieldType,
              tdfUnitPrice: parseFloat(item.unitPrice) || null,
              tdfCurrency: item.tdfCurrency || null,
              tdfAmount:
                item.tdfAmount !== undefined && item.tdfAmount !== null
                  ? parseFloat(item.tdfAmount)
                  : parseFloat(field.dyfAmountValue) || 0,
              tdfDiscount: item.tdfDiscount || field.tdfDiscount,
              tdfExpire: item.tdfExpire || null,
              tdfExpireDate: item.tdfExpireDate || null,
              tdfBrand: parseInt(item.tdfBrand) || null,
              tdfYearOfManu: item.tdfYearOfManu || null,
              tdfDateInstalled: item.tdfDateInstalled || null,
              tdfSerial: item.tdfSerial || null,
              tdfTyreType: item.tdfTyreType ? parseInt(item.tdfTyreType) : null,
              tdfTreadPattern: item.tdfTreadPattern
                ? parseInt(item.tdfTreadPattern)
                : null,
              tdfMillageUsed: item.tdfMillageUsed || null,
              tdfPositionFixed: parseInt(item.tdfPositionFixed) || null,
              tdfTax: parseFloat(item.tdfTaxAmount) || null,
              tdfTotalAmount: item.tdfTotalAmount || null,
              tdfStatus: item.dyfStatus,
              tdfActive: item.dyfActive,
            };
            combinedDataList.push(newRecord);
          });
        } else {
          combinedDataList.push(baseRecord);
        }
      } else if (
        parseInt(field.dyfFieldType) === 8 &&
        parseInt(field.dyfCommonDropdown) === 22
      ) {
        const relatedItems = chargeGridData.filter((item) => item.itemId);

        if (relatedItems.length > 0) {
          relatedItems.forEach((item, itemIndex) => {
            let newRecord = {
              ...baseRecord,
              tdfCommonDropdownId:
                field.dyfCommonDropdown || item.tdfCommonDropdownId, // Link field to itemId
              tdfCommonDropdown: item.itemId,
              tdfQty: item.tdfQty || null,
              tdfFieldType: field.dyfFieldType || item.tdfFieldType,
              tdfUnitPrice: parseFloat(item.unitPrice) || null,
              tdfCurrency: item.tdfCurrency || null,
              tdfAmount:
                item.tdfAmount !== undefined && item.tdfAmount !== null
                  ? parseFloat(item.tdfAmount)
                  : parseFloat(field.dyfAmountValue) || 0,
              tdfDiscount: item.tdfDiscount || field.tdfDiscount,
              tdfExpire: item.tdfExpire || null,
              tdfExpireDate: item.tdfExpireDate || null,
              tdfBrand: parseInt(item.tdfBrand) || null,
              tdfYearOfManu: item.tdfYearOfManu || null,
              tdfDateInstalled: item.tdfDateInstalled || null,
              tdfSerial: item.tdfSerial || null,
              tdfTyreType: item.tdfTyreType ? parseInt(item.tdfTyreType) : null,
              tdfTreadPattern: item.tdfTreadPattern
                ? parseInt(item.tdfTreadPattern)
                : null,
              tdfMillageUsed: item.tdfMillageUsed || null,
              tdfPositionFixed: parseInt(item.tdfPositionFixed) || null,
              tdfTax: parseFloat(item.tdfTaxAmount) || null,
              tdfTotalAmount: item.tdfTotalAmount || null,
              tdfStatus: item.dyfStatus,
              tdfActive: item.dyfActive,
            };
            combinedDataList.push(newRecord);
          });
        } else {
          combinedDataList.push(baseRecord);
        }
      } else {
        combinedDataList.push(baseRecord);
      }
    });

    // ✅ Process item list (gridData)
    currentGrid.forEach((item, index) => {
      let itemRecord = {
        tdfId: item.tdfId || null,
        tdfReferance: item.tdfReferance || null,
        tdfCompany: 1,
        tdfItemId: item.tdfItemId || null,
        tdfField: item.dyfField || null,
        tdfValue: item.tdfValue || null,
        tdfAmount: item.tdfAmount || null,
        tdfNumber: item.tdfNumber || null,
        tdfDropdown: item.tdfDropdown || null,
        tdfCurrency: item.tdfCurrency || null,
        tdfCommonDropdownId: item.tdfCommonDropdownId || null,
        tdfCommonDropdown: item.itemId || null,
        tdfCommonValue: item.tdfCommonValue || null,
        tdfBoolean: item.tdfBoolean || null,
        tdfSatisfyLevel: item.tdfSatisfyLevel || null,
        tdfFieldStatus: item.tdfFieldStatus || null,
        tdfUom: item.tdfUom || null,
        tdfDescription: item.tdfDescription || null,
        tdfRequired: item.tdfRequired || 0,
        tdfCalculated: item.tdfCalculated || 1,
        tdfPercentage: item.tdfPercentage || null,
        tdfUnitPrice: parseFloat(item.unitPrice) || null,
        tdfDiscount: parseFloat(item.tdfDiscount) || 0,
        exchangeData: item.exchangeData || {},
        tdfQty: parseFloat(item.tdfQty) || null,
        tdfExpire: item.tdfExpire || null,
        tdfExpireDate: item.tdfExpireDate || null,
        tdfBrand: parseInt(item.tdfBrand) || null,
        tdftSeq: item.tdftSeq || null,
        tdfYearOfManu: item.tdfYearOfManu || null,
        tdfDateInstalled: item.tdfDateInstalled || null,
        tdfSerial: item.tdfSerial || null,
        tdfTyreType: item.tdfTyreType ? parseInt(item.tdfTyreType) : null,
        tdfTreadPattern: item.tdfTreadPattern
          ? parseInt(item.tdfTreadPattern)
          : null,
        tdfMillageUsed: item.tdfMillageUsed || null,
        tdfPositionFixed: parseInt(item.tdfPositionFixed) || null,
        tdfTax: parseFloat(item.tdfTaxAmount) || null,
        tdfTotalAmount: parseFloat(item.tdfTotalAmount) || null,
        tdfStatus: item.tdfStatus,
        tdfActive: item.tdfActive,
      };
      combinedDataList.push(itemRecord);
    });
    return combinedDataList;
  };

  // ✅ Usage
  const updateCombinedDataList = createUpdateInspectionDataList();

  const inspectionCreationHandler = async (pass = false) => {
    closeModal();
    closeModal2();
    setIsSubmitLoading(true);
    setIsBlurred(true);

    let isError = false;
    let documentManagementErrors = {};
    if (thdDepreciation === 1) {
      documentManagementErrors = documentManagementValidation({
        tdhCategory,
        tdhInspectionType,
        tdhTemplate,
        tdhRefId,
        tdhDriverId,
        // tdhNextValue,
        // tdhNextUom,
        // tdhActionDate,
        tdhOverall,
        tdhOverallStatus,
        // tdhNextDate,
        // tdhMillage: tdhMilage,
        tdhTotal: tdhTotal,
        tdhValue: tdhValue,
        tdhStatus,
        tdhActive,
        thdDepreciation,
        thdDepreciationValue,
        thdDepreciationUom,
        thdDepreciationDate,
      });
    } else {
      documentManagementErrors = documentManagementValidation({
        tdhCategory,
        tdhInspectionType,
        tdhTemplate,
        tdhRefId,
        tdhDriverId,
        // tdhNextValue,
        // tdhNextUom,
        // tdhActionDate,
        tdhOverall,
        tdhOverallStatus,
        // tdhNextDate,
        // tdhMillage: tdhMilage,
        tdhTotal: tdhTotal,
        tdhValue: tdhValue,
        tdhStatus,
        tdhActive,
        thdDepreciation,
      });
    }
    if (Object.entries(documentManagementErrors).length > 0) {
      isError = true;
    }

    if (
      documentManagementErrors.tdhRefId ||
      documentManagementErrors.tdhDriverId
    ) {
      setActiveAccordionHeader(true);
    }

    // if (
    //   documentManagementErrors.tdhActionDate ||
    //   documentManagementErrors.tdhMillage
    // ) {
    //   setActiveAccordionAlerts(true);
    // }

    let dynamicFieldErrors = {};
    dynamicFields?.forEach((row) => {
      // ✅ Check if the field is an Item List
      const isItemList =
        parseInt(row.dyfFieldType) === 8 &&
        parseInt(row.dfyCommonDropdown) === 19;
      const isChargeList =
        parseInt(row.dyfFieldType) === 8 &&
        parseInt(row.dfyCommonDropdown) === 22;

      let currentGrid = [];
      if (isItemShown) {
        currentGrid = gridData;
      } else if (isChargeShown) {
        currentGrid = chargeGridData;
      }

      if (row.dyfRequired) {
        if (isItemList) {
          // ✅ If it's an Item List, validate using `gridData`
          if (!currentGrid || currentGrid.length === 0) {
            dynamicFieldErrors = {
              ...dynamicFieldErrors,
              [row.dyfField]: {
                ...dynamicFieldErrors[row.dyfField],
                dyfFieldValue: "At least one item is required",
              },
            };
            isError = true;
            setIsItemListMissing(true);
          }
        } else if (isChargeList) {
          // ✅ If it's an Item List, validate using `gridData`
          if (!currentGrid || currentGrid.length === 0) {
            dynamicFieldErrors = {
              ...dynamicFieldErrors,
              [row.dyfField]: {
                ...dynamicFieldErrors[row.dyfField],
                dyfFieldValue: "At least one item is required",
              },
            };
            isError = true;
            setIsChargeListMissing(true);
          }
        } else {
          // ✅ Normal field validation
          if (
            !row.dyfFieldValue ||
            row.dyfFieldValue === null ||
            row.dyfFieldValue === ""
          ) {
            dynamicFieldErrors = {
              ...dynamicFieldErrors,
              [row.dyfField]: {
                ...dynamicFieldErrors[row.dyfField],
                dyfFieldValue: "Value is required",
              },
            };
            isError = true;
          }
        }

        // ✅ Validate Satisfy Level
        if (!row.dyfSatisfyLevel || row.dyfSatisfyLevel === null) {
          dynamicFieldErrors = {
            ...dynamicFieldErrors,
            [row.dyfField]: {
              ...dynamicFieldErrors[row.dyfField],
              dyfSatisfyLevel: "Satisfy level is required",
            },
          };
          isError = true;
        }

        // ✅ Validate Field Status
        if (!row.dyfFieldStatus || row.dyfFieldStatus === null) {
          dynamicFieldErrors = {
            ...dynamicFieldErrors,
            [row.dyfField]: {
              ...dynamicFieldErrors[row.dyfField], // Preserve existing errors
              dyfFieldStatus: "Field status is required",
            },
          };
          isError = true;
        }
      }
    });

    if (isError) {
      toast.error("Fill all required fields", {
        autoClose: 5000,
        containerId: "Main",
      });
      setActiveAccordion1(true);
      setCurrentErrors(documentManagementErrors);
      setDynamicErrors(dynamicFieldErrors);
      setIsBlurred(false);
      setIsSubmitLoading(false);
      return;
    } else {
      setCurrentErrors({});
      setDynamicErrors({});
    }

    if (!editMode) {
      const documents = documentRef.current.getData();

      const duplicateExist = await checkDuplicateInspections({
        category: tdhCategory,
        template: tdhTemplate,
        vehTrdnId: tdhRefId,
        actionDate: tdhActionDate,
        nextDate: tdhNextDate,
        reference: tdhReferance,
        user: user.username,
        company: tdhCompany,
      });
      const filteredDynamicDataRequestDMList = dynamicDataRequestDMList.filter(
        (field) => {
          // ✅ If it's a Common Dropdown with Item Type (19) but no itemId, exclude it
          if (field.tdfCommonDropdownId === 19 && !field.tdfCommonDropdown) {
            return false;
          }
          return true;
        },
      );

      if (
        pass ||
        (duplicateExist?.length > 0 && duplicateExist[0]?.retId < 0)
      ) {
        try {
          const parsedCurrency =
            typeof selectedCurrency === "string"
              ? JSON.parse(selectedCurrency)
              : selectedCurrency;
          const data = {
            dynamicHeaderRequestDM: {
              tdhReferance,
              tdhCompany,
              tdhCategory,
              tdhInspectionType,
              tdhTemplate,
              tdhRefId,
              tdhNextValue,
              tdhCashCredit,
              tdhNextUom,
              tdhActionDate,
              tdhSubAction,
              tdhActionTaken,
              tdhVendor: tdhSupplier,
              tdhTransporter: tdhTransporterId,
              tdhDriver: tdhDriverId,
              tdhTaxAmount: parseFloat(getTotalTaxAmount()) || null,
              tdhDescription,
              tdhOverall: tdhOverall,
              tdhOverallStatus,
              tdhUom,
              tdhNextDate,
              tdhMillage: tdhMilage,
              tdhNextInspectionKm: tdhNextMilage,
              tdhNextActionKm: nextActionKm,
              tdhTotal: tdhTotal,
              tdhTotalAmount: tdhValue,
              tdhPercentage: tdhPercentage,
              tdhDiscount: getAbsoluteDiscount(),
              // tdhDiscount: tdhDiscount,
              tdhValue: tdhValue,
              tdhStatus,
              tdhActive,
              thdDepreciation,
              thdDepreciationValue,
              thdDepreciationUom,
              thdDepreciationDate,
              tdhSupplier,
              tdhModel: tdhModelId,
              tdhTyreSize,
              tdhNumTyres,
              tdhExcId: parsedCurrency.excId,
              tdhExcRate: parsedCurrency.excRate, //TODO need to confirm whether i need to send the rate and then calculate and show in the editMode or else the convertedTotal should be stored
              createdBy: user.username,
              tdhInspectedPlace: tdhInspectedPlace,
              tdhVehTypeSize,
              tdhVehBodyType,
              tdhVehInspectionGroup,
              tdhVehOperationType,
              tdhVehWidth,
              tdhVehLength,
              tdhVehHeight,
              tdhDriverNic,
              tdhDriverMobile,
              tdhDriverNicImg:
                tdhDriverNicImg === "Yes" || tdhDriverNicImg === "yes"
                  ? true
                  : false,
              tdhDriverGsImg:
                tdhDriverGsImg === "Yes" || tdhDriverGsImg === "yes"
                  ? true
                  : false,
              tdhDriverDrImg:
                tdhDriverDrImg === "Yes" || tdhDriverDrImg === "yes"
                  ? true
                  : false,
              tdhDriverPoliceImg:
                tdhDriverPoliceImg === "Yes" || tdhDriverPoliceImg === "yes"
                  ? true
                  : false,
            },
            dynamicDataRequestDMList: filteredDynamicDataRequestDMList,
            dynamicTaxDataList: collectTaxRowsForSubmission(),
            dynamicHeaderRefRequestList: Object.keys(selectedJobs).map(
              (jobKey) => ({
                dyjId: null,
                dyjCode: null,
                dyjReferance: null,
                dyjCompany: 1,
                dyjDyhId: null,
                dyjOpeType: 1,
                dyjOpeRefId: parseInt(jobKey, 10),
                dyjStatus: 2,
                dyjActive: 1,
                createdBy: user.username,
                lastModifiedBy: null,
              }),
            ),
            author: user.username,
          };

          const response = await saveInspection(data);

          if (response?.status === 200) {
            const documents = documentRef.current.getData();
            let hasUploadErrors = false;
            if (documents.length > 0) {
              for (let doc of documents) {
                const { file, ...rest } = doc;
                const formData = new FormData();
                formData.append("multipartFile", doc.file);
                formData.append(
                  "documentRequest",
                  JSON.stringify({
                    ...rest,
                    docReference: response.data.dynamicHeaderResponseDM.tdhId,
                  }),
                );
                formData.append("isImage", rest.docCategory === 1);
                const res = await addAndUpload(formData);
                if (res && res?.responseCode === "2040") {
                  toast.success(res?.message, {
                    autoClose: 5000,
                    containerId: "Main",
                  });
                } else {
                  hasUploadErrors = true;
                  documentRef.current.markUploadFailed(doc.id ?? doc.fileName);
                  toast.error(
                    res?.message || `Error adding document ${doc.docName}`,
                    {
                      autoClose: 5000,
                      containerId: "Main",
                    },
                  );
                }
              }
            }

            if (tdhStatus === 2) {
              const result = await createFleetCharges({
                tdhId: response.data.dynamicHeaderResponseDM.tdhId,
                fcdDescription: "",
                user: user.username,
                company: tdhCompany,
              });
            }

            toast.success(
              response.data.dynamicHeaderResponseDM.tdhCode +
                " inspection Created Successfully..",
              { autoClose: 5000, containerId: "Main" },
            );
            if (hasUploadErrors) {
              setIsSubmitLoading(false);
              setIsBlurred(false);
              return;
            }

            resetForm();
            handleDrawerClose();
            setDynamicFields([]);
            setEditMode(false);
            // setUpdateNeeded(true);
          }
        } catch (e) {
          console.error(e);
        }
      } else {
        setErrorMessage(duplicateExist[0]?.retNo + " Record already exists");
        openModel2();
      }
      // Check for document presence
      if (documents.length === 0) {
        toast.warning("Submitted without any documents.", {
          autoClose: 5000,
          containerId: "Main",
        });
        setIsSubmitLoading(false);
        setIsBlurred(false);
      }
    } else {
      // Sum tax per item from taxGridData
      const taxPerItem = {};
      taxGridData.forEach((tax) => {
        const itemId = tax.tdtTdfId;
        const taxAmount =
          parseFloat(tax.tdtCost) * (parseFloat(tax.tdtTaxRate) / 100);
        taxPerItem[itemId] = (taxPerItem[itemId] || 0) + taxAmount;
      });

      // Inject calculated tdfTax values into data list
      const mergedDataList = [...gridData, ...chargeGridData];

      // Inject tdfTax into each line in mergedDataList
      const updatedDataList = updateCombinedDataList.map((item) => {
        const updated = mergedDataList.find((u) => u.tdfId === item.tdfId);
        if (updated) {
          return {
            ...item,
            tdfTax: Number((taxPerItem[item.tdfId] || 0).toFixed(2)),
          };
        }
        return item;
      });

      // Now calculate tdhTaxAmount from updatedDataList
      const calculatedTaxAmount = updatedDataList.reduce((sum, item) => {
        return sum + (parseFloat(item.tdfTax) || 0);
      }, 0);

      try {
        const data = {
          dynamicHeaderRequestDM: {
            tdhReferance,
            tdhCompany,
            tdhCategory,
            tdhInspectionType,
            tdhTemplate,
            tdhRefId,
            tdhSubAction,
            tdhNextValue,
            tdhNextUom,
            tdhActionDate,
            tdhVendor: tdhSupplier,
            tdhCashCredit,
            tdhTransporter: tdhTransporterId,
            tdhDriver: tdhDriverId,
            tdhDescription,
            tdhTaxAmount: parseFloat(getTotalTaxAmount()) || null,
            tdhOverall: tdhOverall,
            tdhOverallStatus,
            tdhUom,
            tdhNextDate,
            tdhActionTaken,
            tdhMillage: tdhMilage,
            tdhNextInspectionKm: tdhNextMilage,
            tdhNextActionKm: nextActionKm,
            tdhTotal: tdhTotal,
            tdhPercentage: tdhPercentage,
            tdhDiscount: getAbsoluteDiscount(),
            // tdhDiscount: tdhDiscount,
            tdhValue: tdhValue,
            tdhStatus,
            tdhModel: tdhModelId,
            tdhNumTyres,
            tdhActive,
            thdDepreciation,
            thdDepreciationValue,
            thdDepreciationUom,
            thdDepreciationDate,
            // tdhExcId: parsedCurrency.excId,
            // tdhExcRate: parsedCurrency.excRate,
            createdBy: user.username,
            tdhInspectedPlace: tdhInspectedPlace,
            tdhVehTypeSize,
            tdhVehBodyType,
            tdhVehInspectionGroup,
            tdhVehOperationType,
            tdhVehWidth,
            tdhVehLength,
            tdhVehHeight,
            tdhDriverNic,
            tdhDriverMobile,
            tdhDriverNicImg:
              tdhDriverNicImg === "Yes" || tdhDriverNicImg === "yes"
                ? true
                : false,
            tdhDriverGsImg:
              tdhDriverGsImg === "Yes" || tdhDriverGsImg === "yes"
                ? true
                : false,
            tdhDriverDrImg:
              tdhDriverDrImg === "Yes" || tdhDriverDrImg === "yes"
                ? true
                : false,
            tdhDriverPoliceImg:
              tdhDriverPoliceImg === "Yes" || tdhDriverPoliceImg === "yes"
                ? true
                : false,
          },
          dynamicDataRequestDMList: updatedDataList,
          dynamicTaxDataList: collectTaxRowsForSubmission(),
          // dynamicDataRequestDMList,
          dynamicHeaderRefRequestList: Object.keys(selectedJobs).map(
            (jobKey) => {
              const existing = dynamicHeaderRefResponses.find(
                (ref) => ref.dyjOpeRefId === parseInt(jobKey, 10),
              );
              return {
                dyjId: existing ? existing.dyjId : null,
                dyjCode: existing ? existing.dyjCode : null,
                dyjReferance: existing ? existing.dyjReferance : null,
                dyjCompany: 1,
                dyjDyhId: existing ? existing.dyjDyhId : null,
                dyjOpeType: 1,
                dyjOpeRefId: parseInt(jobKey, 10),
                dyjStatus: 2,
                dyjActive: 1,
                createdBy: user.username,
                lastModifiedBy: existing ? existing.lastModifiedBy : null,
              };
            },
          ),
          author: user.username,
        };

        const response = await updateInspection(tdhId, data);

        if (response?.status === 200) {
          const documents = documentRef.current.getData();
          let hasUploadErrors = false;
          for (let doc of documents.created) {
            const { file, ...rest } = doc;
            const formData = new FormData();
            formData.append("multipartFile", doc.file);
            formData.append("documentRequest", JSON.stringify(rest));
            formData.append("isImage", rest.docCategory === 1);
            const res = await addAndUpload(formData);
            if (res && res?.responseCode === "2040") {
              toast.success(res?.message, {
                autoClose: 5000,
                containerId: "Main",
              });
            } else {
              hasUploadErrors = true;
              documentRef.current.markUploadFailed(doc.id ?? doc.fileName);
              toast.error(
                res?.message || `Error adding document ${doc.docName}`,
                {
                  autoClose: 5000,
                  containerId: "Main",
                },
              );
            }
          }

          for (let doc of documents.modified) {
            const { file, ...rest } = doc;
            const formData = new FormData();
            formData.append("multipartFile", doc.file);
            formData.append("documentRequest", JSON.stringify(rest));
            formData.append("isImage", rest.docCategory === 1);
            const res = await updateAndUpload(formData);
            if (res && res?.responseCode === "2040") {
              toast.success(res?.message, {
                autoClose: 5000,
                containerId: "Main",
              });
            } else {
              hasUploadErrors = true;
              documentRef.current.markUploadFailed(doc.id ?? doc.fileName);
              toast.error(
                res?.message || `Error updating document ${doc.docName}`,
                {
                  autoClose: 5000,
                  containerId: "Main",
                },
              );
            }
          }

          if (documents?.deleted.length > 0) {
            await deleteDocumentList({
              docIdList: documents?.deleted,
            });
            toast.success("Documents deleted successfully!", {
              autoClose: 5000,
              containerId: "Main",
            });
          }

          if (persistedTdhStatus !== 2 && tdhStatus === 2) {
            const result = await createFleetCharges({
              tdhId: response.data.dynamicHeaderResponseDM.tdhId,
              fcdDescription: "",
              user: user.username,
              company: tdhCompany,
            });

            // if (result[0]?.retId < 0) {
            //   toast.error(result[0]?.retStatus, {
            //     autoClose: 8000,
            //   });
            // } else {
            //   toast.success(result[0]?.retStatus, {
            //     autoClose: 8000,
            //   });
            // }
          }

          if (deletedList.length > 0) {
            await inactiveFleetCharges(deletedList);
          }

          toast.success(tdhCode + " Updated Successfully..", {
            autoClose: 5000,
            containerId: "Main",
          });
          if (hasUploadErrors) {
            setIsSubmitLoading(false);
            setIsBlurred(false);
            return;
          }
          resetForm();
          handleDrawerClose();
          setEditMode(false);
          setDynamicFields([]);
          // setUpdateNeeded(true);
        }
      } catch (e) {
        console.error(e);
      }
    }

    setIsBlurred(false);
    setIsSubmitLoading(false);
  };

  useEffect(() => {
    if (!thdDepreciation || thdDepreciation === 2) {
      setThdDepreciationValue(null);
      setThdDepreciationUom(null);
      setThdDepreciationDate(null);
    }
  }, [thdDepreciation, tdhSupplier, tdhRefId]);

  const calculateNextActionDate = (actionDate, value, type) => {
    if (!actionDate || !value || !type) {
      console.error("Invalid input values provided");
      return;
    }

    // Parse the actionDate string in the format YYYY-MM-DD
    const [year, month, day] = actionDate
      .split("-")
      .map((val) => parseInt(val, 10));
    const date = new Date(year, month - 1, day); // JavaScript months are 0-indexed

    // Check if the parsed date is valid
    if (isNaN(date.getTime())) {
      console.error("Invalid date format");
      return;
    }

    switch (type) {
      case 6: // Hour
        if (value >= 24) {
          const daysToAdd = Math.floor(value / 24);
          date.setDate(date.getDate() + daysToAdd);
          console.log(`Added ${daysToAdd} days to compensate for hours.`);
        } else {
          console.log("Value is less than 24 hours, returning original date.");
          return actionDate; // Return the original date unchanged
        }
        break;

      case 12: // Day
        date.setDate(date.getDate() + parseInt(value, 10));
        console.log("Updated date after adding days:", date);
        break;

      case 19: // Month
        date.setMonth(date.getMonth() + parseInt(value, 10));
        console.log("Updated date after adding months:", date);
        break;

      default:
        console.error("Invalid type provided");
        return;
    }

    // Format the date to YYYY-MM-DD for the output
    const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

    return formattedDate;
  };

  useEffect(() => {
    // if (!editMode) {
    if (tdhActionDate && tdhNextValue && tdhNextUom) {
      const nextActionDate = calculateNextActionDate(
        tdhActionDate,
        tdhNextValue,
        tdhNextUom,
      );

      if (!nextActionDate || nextActionDate === null) {
        setTdhNextDate("");
      } else {
        setTdhNextDate(nextActionDate);
      }
    } else {
      setTdhNextDate("");
    }
    // }
  }, [tdhActionDate, tdhNextValue, tdhNextUom]);

  useEffect(() => {
    if (tdhMilage) {
      const nextMilage = Number(tdhMilage) + Number(nextActionKm ?? 0);
      setTdhNextMilage(nextMilage ? nextMilage.toString() : "");
    } else if (nextActionKm === 0 || null) {
      setTdhNextMilage(tdhMilage ? tdhMilage.toString() : "");
    } else {
      setTdhNextMilage("");
    }
  }, [tdhMilage, nextActionKm]);

  useEffect(() => {
    // Check if an item field (dyfFieldType === 8 && dfyCommonDropdown === 19) exists
    const itemFieldExists = dynamicFields.some(
      (field) => field.dyfFieldType === 8 && field.dfyCommonDropdown === 19,
    );
    setHasItemField(itemFieldExists);
  }, [dynamicFields]); // Runs whenever `dynamicFields` changes

  const notApprovedContent = (
    <div style={{ padding: "20px" }}>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <h3 style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <AlertCircle color="red" size="25" />
          <p>Warning</p>{" "}
        </h3>
        <h3>
          The cost will not be recorded until the status changes to 'Approval'.
          <br /> Are you sure you want to proceed with it remaining in 'Pending'
          status?
        </h3>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingTop: "5px",
            paddingBottom: "5px",
            gap: "5px",
          }}
        >
          <Button Icon={X} label={"Cancel"} onClick={closeModal} color="red" />
          <Button
            Icon={Check}
            label={"Proceed"}
            onClick={() => inspectionCreationHandler(false)}
          />
        </div>
      </div>
    </div>
  );

  const approvedContent = (
    <div style={{ padding: "20px" }}>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <h3 style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <AlertCircle color="red" size="25" />
          <p>Warning</p>{" "}
        </h3>
        <h3>
          Once the status changes to 'Approval,' the record will become
          read-only.
          <br />
          Please verify. Are you sure you want to proceed?
        </h3>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingTop: "5px",
            paddingBottom: "5px",
            gap: "5px",
          }}
        >
          <Button Icon={X} label={"Cancel"} onClick={closeModal} color="red" />
          <Button
            Icon={Check}
            label={"Proceed"}
            onClick={() => inspectionCreationHandler(false)}
          />
        </div>
      </div>
    </div>
  );

  const dmPendingContent = (
    <div style={{ padding: "20px" }}>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <h3 style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <AlertCircle color="red" size="25" />
          <p>Warning</p>{" "}
        </h3>
        <h3>Status should be Pending.</h3>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingTop: "5px",
            paddingBottom: "5px",
            gap: "5px",
          }}
        >
          <Button Icon={X} label={"Ok"} onClick={closeModal} color="red" />
        </div>
      </div>
    </div>
  );

  const handlePrintGeneralReport = async (inspectionData) => {
    setIsPrintLoading(true);
    if (!inspectionData) {
      console.error("No inspection data provided for printing.");
      return;
    }

    if (!printCurrency) {
      toast.error("Please select a currency before printing");
      return;
    }

    const parsedCurrency = JSON.parse(printCurrency);
    const printExchangeRate = parseFloat(parsedCurrency.excRate) || 1;
    const currencyCode = parsedCurrency.curCode?.split(":")[0] || "LKR"; // Get only 'USD' from 'USD:12.0000'

    try {
      const managementTypeOpt = await getDropdownData("inspection_type");
      const foundManagement = managementTypeOpt.find(
        (m) => m.value === inspectionData.tdhInspectionType,
      );
      const foundTemplate = templateOptions.find(
        (t) => t.value === inspectionData.tdhTemplate,
      );

      let vehicleOrTransporter = "";
      if (inspectionData.tdhCategory === 1) {
        const vehicleData = await getFieldValuesByTableAndId({
          tableName: "masterdata.tms_m_vehicle_details",
          primaryKey: "veh_id",
          fieldNames: "veh_vehicleno",
          ids: inspectionData.tdhRefId,
        });
        vehicleOrTransporter = vehicleData?.[0]?.field1 || "Unknown Vehicle";
      } else if (inspectionData.tdhCategory === 2) {
        const transporterData = await getFieldValuesByTableAndId({
          tableName: "masterdata.tms_m_stakeholder",
          primaryKey: "stk_id",
          fieldNames: "stk_name",
          ids: inspectionData.tdhRefId,
        });
        vehicleOrTransporter =
          transporterData?.[0]?.field1 || "Unknown Transporter";
      }

      const statusMapping = { 1: "Pending", 2: "Completed", 3: "Verified" };
      const satisfyLevelMapping = {
        1: "Flag",
        2: "Satisfied",
        3: "Unsatisfied",
      };
      const overallStatus =
        statusMapping[inspectionData.tdhOverallStatus] || "N/A";

      let currentGrid = isItemShown ? gridData : chargeGridData;

      // ✅ Format numbers with currency
      const formatCurrency = (amount) => {
        const value = parseFloat(amount || 0) / printExchangeRate;
        return `${currencyCode}.${value.toFixed(2)}`;
      };

      const fields = [
        ...inspectionData.dynamicFields.map((field) => {
          const amount = parseFloat(field.tdfAmount || 0);
          const tax = parseFloat(field.tdfTax || 0);
          const discount = parseFloat(field.tdfDiscount || 0);
          const total = amount + tax - discount;

          return {
            name: field.tdfFieldValue,
            value:
              field.dyfFieldType === 4
                ? field.dynamicDropdowns?.find(
                    (i) => i.dydSeq === field.tdfDropdown,
                  )?.dydValue || "N/A"
                : field.dyfFieldType === 3
                  ? field.dyfFieldValue || "N/A"
                  : field.dyfFieldType === 5
                    ? field.dyfFieldValue
                      ? new Date(field.dyfFieldValue).toLocaleDateString()
                      : "N/A"
                    : field.dyfFieldType === 6
                      ? field.tdfBoolean
                        ? "Yes"
                        : "No"
                      : field.dyfFieldType === 7
                        ? field.dyfFieldValue || "N/A"
                        : field.dyfFieldType === 8
                          ? field.tdfCommonDropdownValue || "N/A"
                          : "N/A",
            description: field.tdfDescription || "No Description",
            amount: formatCurrency(amount),
            taxAmount: formatCurrency(tax),
            discount: formatCurrency(discount),
            total: formatCurrency(total),
            currencyCode,
            isPercentage: field.tdfPercentage || 2,
            satisfyLevel: satisfyLevelMapping[field.tdfSatisfyLevel] || "N/A",
          };
        }),
        ...(currentGrid || [])
          .filter((grid) => grid.item)
          .map((grid) => {
            const amount = parseFloat(grid.tdfAmount || 0);
            const tax = parseFloat(grid.tdfTax || 0);
            const discount = parseFloat(grid.tdfDiscountAmount || 0);
            const total = amount + tax - discount;

            return {
              name: grid.item,
              value: "N/A",
              description: grid.tdfDescription || "No Description",
              amount: formatCurrency(amount),
              taxAmount: formatCurrency(tax),
              discount: formatCurrency(discount),
              total: formatCurrency(total),
              currencyCode,
              isPercentage: grid.tdfPercentage || 2,
              satisfyLevel: "N/A",
            };
          }),
      ];

      // ✅ Compute main total fields correctly
      const amount = parseFloat(inspectionData.tdhValue || 0);
      const total = parseFloat(inspectionData.tdhTotal || 0);
      const discountRaw = parseFloat(inspectionData.tdhDiscount || 0);

      const payload = {
        code: inspectionData.tdhCode,
        category: inspectionData.tdhCategory === 1 ? "Vehicle" : "Transporter",
        managementType: foundManagement?.text || "N/A",
        actionDate: inspectionData.tdhActionDate,
        mileage: `${tdhMilage || 0}Km`,
        depreciationEnabled: inspectionData.thdDepreciation === 1,
        template: foundTemplate?.text || "N/A",
        vehicleTransporter: vehicleOrTransporter,
        nextInspectionValue: inspectionData.tdhNextValue,
        nextActionDate: inspectionData.tdhNextDate,
        nextActionMileage: `${tdhNextMilage || 0}Km`,
        isActionTaken: tdhActionTaken === 1 ? "Yes" : "No",
        isPercentage: inspectionData.tdhPercentage,
        amount: formatCurrency(amount),
        total: formatCurrency(total),
        discount:
          inspectionData.tdhPercentage === 1
            ? `${discountRaw}%`
            : formatCurrency(discountRaw),
        fields,
        overallStatus: {
          description: inspectionData.tdhDescription || "No Description",
          percent: inspectionData.tdhOverall || "0",
          status: overallStatus,
          active: inspectionData.tdhActive === 1 ? "Yes" : "No",
        },
        createdBy: editMode ? createdBy : user.username,
        approvedBy: tdhApprovedBy ? tdhApprovedBy : "",
      };

      const reportTypeDetails = await getReportTypeDetails(insReportType);
      if (!reportTypeDetails) {
        toast.error("Report type  not found");
        baseCurrencyModalClose();
        setIsPrintLoading(false);
        return;
      }
      const pathUrl = reportTypeDetails?.dyrUrl;
      const reportName = reportTypeDetails?.dyrReport;

      const blob = await downloadGeneralReportDocument(
        payload,
        "pdf",
        reportName,
        pathUrl,
      );
      // const blob = await downloadInspectionDocument(payload);
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${inspectionData.tdhCode}-inspection.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // await addAuditRecord({
      //   company: company ? company.tdhCompany : null,
      //   action: "Inspection General Report Download",
      //   params: "",
      //   type: 6,
      //   module: 5,
      //   user: user.username,
      // });

      baseCurrencyModalClose();
      setIsPrintLoading(false);
    } catch (error) {
      console.error("Error handling print:", error);
      toast.error("Failed to generate the document. Please try again.");
      baseCurrencyModalClose();
      setIsPrintLoading(false);
    }
  };

  const handlePrintInspectionReport = async () => {
    setIsPrintLoading(true);
    try {
      const blob = await downloadInspectionReportDocument(tdhId);
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Inspection Report.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setIsPrintLoading(false);
    } catch (e) {
      toast.error("Error Occurred.Please try again", {
        autoClose: 5000,
        containerId: "Main",
      });
      console.error("Error handling print:", e);
      setIsPrintLoading(false);
    }
    setIsPrintLoading(false);
  };

  const onPrintClick = () => {
    if (!insReportType || insReportType === "") {
      toast.error("Cannot print without report type of the template", {
        autoClose: 5000,
        containerId: "Main",
      });
      return;
    }
    switch (insReportType) {
      case 1: {
        baseCurrencyModalOpen();
        break;
      }
      case 2: {
        handlePrintInspectionReport();
        break;
      }
      default:
    }
  };

  useEffect(() => {
    const currentGrid = isItemShown
      ? gridData
      : isChargeShown
        ? chargeGridData
        : [];

    let totalTaxAmount = 0;
    let totalDiscountAmount = 0;

    currentGrid.forEach((row) => {
      totalTaxAmount += parseFloat(row.tdfTaxAmount) || 0;

      const rowAmount = parseFloat(row.tdfAmount) || 0;
      const discountValue = parseFloat(row.tdfDiscount) || 0;

      // ✅ Use each row's own tdfPercentage to decide % or $
      // tdfPercentage === 1 means %, tdfPercentage === 2 means $
      const rowDiscount =
        row.tdfPercentage === 1
          ? (rowAmount * discountValue) / 100
          : discountValue;

      totalDiscountAmount += rowDiscount;
    });

    // Add dynamic field discounts (always absolute)
    const dynamicDiscount = dynamicFields.reduce(
      (acc, f) => acc + (parseFloat(f.dyfDiscountValue) || 0),
      0,
    );
    totalDiscountAmount += dynamicDiscount;

    const baseAmount = parseFloat(tdhValue) || 0;
    const finalTotal = Math.max(
      baseAmount + totalTaxAmount - totalDiscountAmount,
      0,
    );

    setTdhTaxAmount(totalTaxAmount.toFixed(2));
    setTdhDiscount(totalDiscountAmount.toFixed(2));
    setTdhTotal(finalTotal.toFixed(2));

    const rate = parseFloat(selectedExchangeRate) || 1;
    setPreviewAmount((baseAmount / rate).toFixed(2));
    setPreviewTax((totalTaxAmount / rate).toFixed(2));
    setPreviewDiscount((totalDiscountAmount / rate).toFixed(2));
    setPreviewTotal((finalTotal / rate).toFixed(2));
  }, [
    isItemShown,
    isChargeShown,
    gridData,
    chargeGridData,
    dynamicFields,
    tdhValue,
    selectedExchangeRate,
    // tdhPercentage removed — discount type is per-row via row.tdfPercentage
  ]);

  // useEffect(() => {
  //   let totalTaxAmount = 0;
  //   let totalDiscountAmount = 0;
  //   let totalDiscountPercentage = 0;

  //   let currentGrid = [];

  //   if (isItemShown) {
  //     // currentGrid = gridData;
  //     // ✅ Sum tax and discount from gridData
  //     gridData.forEach((row) => {
  //       totalTaxAmount += parseFloat(row.tdfTaxAmount) || 0;
  //       totalDiscountAmount += parseFloat(row.tdfDiscountAmount) || 0;
  //       totalDiscountPercentage += parseFloat(row.tdfDiscountPercentage) || 0;
  //     });

  //     // ✅ Base amount is `tdhValue`, which includes both gridData & Field List amounts
  //     let baseAmount = parseFloat(tdhValue) || 0;
  //     let calculatedDiscount = totalDiscountAmount; // Default to absolute ($)
  //     let displayedDiscount = totalDiscountAmount; // Default to show in $

  //     if (tdhPercentage === 1) {
  //       // ✅ Convert absolute discount to percentage
  //       displayedDiscount = (calculatedDiscount / baseAmount) * 100;
  //     }

  //     setTdhDiscount(displayedDiscount.toFixed(2)); // ✅ Show percentage OR amount correctly
  //     setTdhTaxAmount(totalTaxAmount.toFixed(2));

  //     // ✅ Correct Final Total Calculation
  //     const finalTotal =
  //       parseFloat(baseAmount) +
  //       parseFloat(totalTaxAmount) -
  //       parseFloat(calculatedDiscount);
  //     // setTdhTotal(parseFloat(finalTotal.toFixed(2)))
  //     setTdhTotal(finalTotal.toFixed(2));
  //   } else if (isChargeShown) {
  //     // currentGrid = chargeGridData;
  //     // ✅ Sum tax and discount from gridData
  //     chargeGridData.forEach((row) => {
  //       totalTaxAmount += parseFloat(row.tdfTaxAmount) || 0;
  //       totalDiscountAmount += parseFloat(row.tdfDiscountAmount) || 0;
  //       totalDiscountPercentage += parseFloat(row.tdfDiscountPercentage) || 0;
  //     });

  //     // ✅ Base amount is `tdhValue`, which includes both gridData & Field List amounts
  //     let baseAmount = parseFloat(tdhValue) || 0;
  //     let calculatedDiscount = totalDiscountAmount; // Default to absolute ($)
  //     let displayedDiscount = totalDiscountAmount; // Default to show in $

  //     if (tdhPercentage === 1) {
  //       // ✅ Convert absolute discount to percentage
  //       displayedDiscount = (calculatedDiscount / baseAmount) * 100;
  //     }

  //     setTdhDiscount(displayedDiscount.toFixed(2)); // ✅ Show percentage OR amount correctly
  //     setTdhTaxAmount(totalTaxAmount.toFixed(2));

  //     // ✅ Correct Final Total Calculation
  //     const finalTotal =
  //       parseFloat(baseAmount) +
  //       parseFloat(totalTaxAmount) -
  //       parseFloat(calculatedDiscount);
  //     // setTdhTotal(parseFloat(finalTotal.toFixed(2)))
  //     setTdhTotal(finalTotal.toFixed(2));
  //   }
  // }, [tdhPercentage, gridData, chargeGridData, dynamicFields, tdhValue]);

  // Extract dynamic columns from dynamicFields
  const extractedColumns = dynamicFields?.flatMap(
    (field) => field.dynamicColumns || [],
  );

  const handleMoreClick = (params) => {
    setSelectedRow(params.data); // Store selected row
    modalRef3.current?.showModal(); // Open the modal using ref
  };

  // useEffect(() => {
  //   let currentGrid = [];
  //   if (isItemShown) {
  //     currentGrid = gridData;
  //   } else if (isChargeShown) {
  //     currentGrid = chargeGridData;
  //   }

  //   const updatedData = currentGrid.map((item) => {
  //     const quantity = parseFloat(item.tdfQty) || 1;
  //     const discountValue = parseFloat(item.tdfDiscount) || 0;
  //     const taxAmount = parseFloat(item.tdfTaxAmount) || 0;
  //     const itemAmount = parseFloat(item.tdfAmount) || 0; // ✅ Use updated `tdfAmount`
  //     const isPercentage = item.tdfPercentage === 1; // Check if discount is %

  //     // ✅ Always Calculate Both Discount Types Correctly
  //     const discountAmount = isPercentage
  //       ? (itemAmount * discountValue) / 100 // ✅ Use `tdfAmount` instead of `unitPrice * quantity`
  //       : discountValue; // Fixed $ discount remains the same

  //     const discountPercentage = isPercentage
  //       ? discountValue // ✅ If already %, keep it
  //       : itemAmount > 0
  //         ? (discountValue / itemAmount) * 100 // ✅ Convert $ to %
  //         : 0; // Prevent division by zero

  //     // ✅ Store both values in `gridData`
  //     return {
  //       ...item,
  //       tdfDiscountAmount: discountAmount, // ✅ Correct discount calculation
  //       tdfDiscountPercentage: discountPercentage, // ✅ Ensure correct %
  //       tdfTotalAmount: Math.max(itemAmount + taxAmount - discountAmount, 0), // ✅ Apply correct discount to total
  //     };
  //   });

  //   // ✅ Prevent unnecessary state updates
  //   if (JSON.stringify(currentGrid) !== JSON.stringify(updatedData)) {
  //     if (isItemShown) {
  //       setGridData(updatedData);
  //     } else if (isChargeShown) {
  //       setChargeGridData(updatedData);
  //     }
  //   }
  // }, [gridData, chargeGridData]);

  const gridConfig = useMemo(() => [
    {
      id: 0,
      headerName: activeTab === 1 ? "Item" : activeTab === 3 ? "Charges" : "",
      field: "item",
    },
    {
      id: 99999,
      headerName: "Charge Item",
      field: "chargeItem",
      hide: isItemShown,
    },
    {
      id: 3,
      headerName: "Description",
      field: "tdfDescription",
      editable: !((tdhStatus === 2 && editMode) || isDm),
    },
    {
      id: 9,
      headerName: "Qty",
      field: "tdfQty",
      cellEditor: "agNumberCellEditor",
      editable: !((tdhStatus === 2 && editMode) || isDm),
      width: 100,
      minWidth: 100,
      cellEditorParams: {
        min: 0.1,
        precision: 3,
        step: 0.0001,
      },
      valueFormatter: (params) => {
        return params.value ? parseFloat(params.value).toFixed(3) : "0.000";
      },
    },
    {
      id: 10,
      headerName: "UnitPrice",
      field: "tdfUnitPrice",
      cellEditor: "agNumberCellEditor",
      editable: !((tdhStatus === 2 && editMode) || isDm),
      minWidth: 130,
      valueFormatter: (params) => {
        return params.value ? parseFloat(params.value).toFixed(2) : "0.00";
      },
    },
    {
      id: 11,
      headerName: "Curr.",
      field: "exchangeData.curCode",
      cellRenderer: ResizableScrollingTextRenderer,
      minWidth: 115,
      tooltipValueGetter: (params) => {
        return "Double click to set the currency";
      },
      cellClassRules: {
        "ag-grid-hello-cell-disabled": (params) =>
          (tdhStatus === 2 && editMode) || isDm,
      },
    },
    {
      id: 6,
      headerName: "Amount",
      field: "tdfAmount",
      editable: false,
      minWidth: 150,
      valueFormatter: (params) => {
        return params.value ? parseFloat(params.value).toFixed(2) : "0.00";
      },
    },
    {
      id: 8,
      headerName: "Dis.",
      field: "tdfDiscount",
      editable: !((tdhStatus === 2 && editMode) || isDm),
      minWidth: 100,
      autoSizeStrategy: {
        type: "fitCellContents",
      },
      type: "numericColumn",

      valueFormatter: (params) => {
        return params.value ? parseFloat(params.value).toFixed(2) : "0.00";
      },
      cellEditorParams: {
        suppressKeyboardEvent: (params) => params.event.key === "-",
      },

      valueSetter: (params) => {
        let value = Number(params.newValue);
        if (isNaN(value) || value < 0) {
          params.data.tdfDiscount = 0;
          return true;
        }
        params.data.tdfDiscount = value;
        return true;
      },
    },

    // {
    //   id: 7,
    //   headerName: "Type",
    //   field: "tdfPercentage",
    //   minWidth: 80,
    //   cellRenderer: SelectRenderer,
    //   cellRendererParams: (params) => ({
    //     onChangeHandler: (data) => {
    //       if (isItemShown) {
    //         setGridData((prev) =>
    //           prev.map((row) => {
    //             const key = editMode ? "tdfId" : "id";
    //             return row[key] === params.data[key]
    //               ? { ...row, tdfPercentage: Number(data) }
    //               : row;
    //           }),
    //         );
    //       } else if (isChargeShown) {
    //         setChargeGridData((prev) =>
    //           prev.map((row) => {
    //             const key = editMode ? "tdfId" : "id";
    //             return row[key] === params.data[key]
    //               ? { ...row, tdfPercentage: Number(data) }
    //               : row;
    //           }),
    //         );
    //       }
    //       setSelectedRow((prevRow) => ({
    //         ...prevRow,
    //         tdfPercentage: data,
    //       }));
    //     },
    //     options: (depreciationOptions.current || [])?.map((option) => ({
    //       key: option.key,
    //       value: option.value,
    //       text: option.value === 1 ? "%" : "$",
    //     })),
    //     placeholder: "% or $",
    //     value: params.data.tdfPercentage,
    //     disabled: (tdhStatus === 2 && editMode) || isDm,
    //   }),
    //   editable: false,
    //   width: 50,
    // },

    {
      id: 7,
      headerName: "Type",
      field: "tdfPercentage",
      minWidth: 80,
      cellRenderer: SelectRenderer,
      cellRendererParams: (params) => ({
        onChangeHandler: (data) => {
          const newPercentage = Number(data);

          const updateRow = (row, keyField) => {
            if (row[keyField] !== params.data[keyField]) return row;

            const rowAmount = parseFloat(row.tdfAmount) || 0;
            const discountValue = parseFloat(row.tdfDiscount) || 0;
            const taxAmount = parseFloat(row.tdfTaxAmount) || 0;

            // ✅ Recalculate discount based on new type
            const discountAmount =
              newPercentage === 1
                ? (rowAmount * discountValue) / 100
                : discountValue;

            const newTotal = Math.max(
              rowAmount + taxAmount - discountAmount,
              0,
            );

            return {
              ...row,
              tdfPercentage: newPercentage,
              tdfTotalAmount: newTotal,
            };
          };

          if (isItemShown) {
            const key = editMode ? "tdfId" : "id";
            setGridData((prev) => prev.map((row) => updateRow(row, key)));
          } else if (isChargeShown) {
            const key = editMode ? "tdfId" : "id";
            setChargeGridData((prev) => prev.map((row) => updateRow(row, key)));
          }

          setSelectedRow((prevRow) => ({
            ...prevRow,
            tdfPercentage: data,
          }));
        },
        options: (depreciationOptions.current || [])?.map((option) => ({
          key: option.key,
          value: option.value,
          text: option.value === 1 ? "%" : "$",
        })),
        placeholder: "% or $",
        value: params.data.tdfPercentage,
        disabled: (tdhStatus === 2 && editMode) || isDm,
      }),
      editable: false,
      width: 50,
    },

    {
      id: 96,
      headerName: "Tax",
      field: "tdfTaxAmount",
      minWidth: 150,
      editable: false,
      tooltipValueGetter: (params) => {
        return "Double click to set the currency";
      },
      valueFormatter: (params) => {
        return params.value ? parseFloat(params.value).toFixed(2) : "0.00";
      },
    },
    {
      id: 97,
      headerName: "Total Amount",
      field: "tdfTotalAmount",
      minWidth: 150,
      editable: false,
      valueFormatter: (params) => {
        return params.value ? parseFloat(params.value).toFixed(2) : "0.00";
      },
    },
    {
      id: 98,
      headerName: "More",
      editable: false,
      hide: isChargeShown,
      cellRenderer: ButtonRenderer,
      cellRendererParams: (params) => ({
        clickHandler: () => handleMoreClick(params),
        label: "More",
        disabled: activeTab === 3,
      }),
      width: 150,
      minWidth: 150,
    },
    {
      id: 99,
      headerName: "Action",
      editable: false,
      cellRenderer: ButtonRenderer,
      cellRendererParams: (params) => ({
        clickHandler: () => {
          handleDeleteRow(params.data);
        },
        label: "Delete",
        className: "ui red button",
        disabled: (tdhStatus === 2 && editMode) || isDm,
      }),
      width: 150,
      minWidth: 150,
    },
  ]);

  const modalGridConfig = [
    {
      id: 14,
      headerName: "Brand",
      field: "tdfBrand",
      cellRenderer: SelectRenderer,
      cellRendererParams: (params) => ({
        style: {
          width: "160px",
        },
        onChangeHandler: (data) => {
          const parsedData = JSON.parse(data);
          if (isItemShown) {
            setGridData((prevData) =>
              prevData.map((item) =>
                item.id === params.data.id
                  ? {
                      ...item,
                      tdfBrandId: parsedData?.dcmId,
                      tdfBrand: parsedData,
                    }
                  : item,
              ),
            );
          } else if (isChargeShown) {
            setChargeGridData((prevData) =>
              prevData.map((item) =>
                item.id === params.data.id
                  ? {
                      ...item,
                      tdfBrandId: parsedData?.dcmId,
                      tdfBrand: parsedData,
                    }
                  : item,
              ),
            );
          }
          setSelectedRow((prevRow) => ({
            ...prevRow,
            tdfBrand: data,
          }));
        },
        options: brandOptions,
        placeholder: "Select Brand",
        value: params.data.tdfBrand,
        disabled: (tdhStatus === 2 && editMode) || isDm,
      }),
      editable: false,
    },
    {
      id: 15,
      headerName: "YOM",
      field: "tdfYearOfManu",
      cellEditor: "agNumberCellEditor",
      editable: !((tdhStatus === 2 && editMode) || isDm),
      minWidth: 100,
    },
    {
      id: 16,
      headerName: "Date Installed",
      field: "tdfDateInstalled",
      cellRenderer: DateOnlyCellRenderer,
      cellEditor: "agDateCellEditor",
      editable: !((tdhStatus === 2 && editMode) || isDm),
    },
    {
      id: 17,
      headerName: "Serial Number",
      field: "tdfSerial",
      editable: !((tdhStatus === 2 && editMode) || isDm),
    },
    {
      id: 18,
      headerName: "Tyre Type",
      field: "tdfTyreType",
      cellRenderer: SelectRenderer,
      cellRendererParams: (params) => ({
        style: {
          width: "160px",
        },
        onChangeHandler: (data) => {
          if (isItemShown) {
            setGridData((prevData) =>
              prevData.map((item) =>
                item.id === params.data.id
                  ? { ...item, tdfTyreType: data }
                  : item,
              ),
            );
          } else if (isChargeShown) {
            setChargeGridData((prevData) =>
              prevData.map((item) =>
                item.id === params.data.id
                  ? { ...item, tdfTyreType: data }
                  : item,
              ),
            );
          }
          setSelectedRow((prevRow) => ({
            ...prevRow,
            tdfTyreType: data,
          }));
        },
        options: tyreTypeOpt,
        placeholder: "Select Tyre Type",
        value: params.data.tdfTyreType,
        disabled: (tdhStatus === 2 && editMode) || isDm,
      }),
      editable: false,
    },
    {
      id: 19,
      headerName: "Tread Pattern",
      field: "tdfTreadPattern",
      cellRenderer: SelectRenderer,
      cellRendererParams: (params) => ({
        style: {
          width: "160px",
        },
        onChangeHandler: (data) => {
          if (isItemShown) {
            setGridData((prevData) =>
              prevData.map((item) =>
                item.id === params.data.id
                  ? { ...item, tdfTreadPattern: data }
                  : item,
              ),
            );
          } else if (isChargeShown) {
            setChargeGridData((prevData) =>
              prevData.map((item) =>
                item.id === params.data.id
                  ? { ...item, tdfTreadPattern: data }
                  : item,
              ),
            );
          }
          setSelectedRow((prevRow) => ({
            ...prevRow,
            tdfTreadPattern: data,
          }));
        },
        options: treadPatternOpt,
        placeholder: "Select Tread Pattern",
        value: params.data.tdfTreadPattern,
        disabled: (tdhStatus === 2 && editMode) || isDm,
      }),
      editable: false,
    },
    {
      id: 20,
      headerName: "Millage Used",
      field: "tdfMillageUsed",
      cellEditor: "agNumberCellEditor",
      editable: !((tdhStatus === 2 && editMode) || isDm),
      minWidth: 150,
    },
    {
      id: 21,
      headerName: "Position Fixed",
      field: "tdfPositionFixed",
      cellRenderer: SelectRenderer,
      cellRendererParams: (params) => ({
        style: {
          width: "160px",
        },
        onChangeHandler: (data) => {
          if (isItemShown) {
            setGridData((prevData) =>
              prevData.map((item) =>
                item.id === params.data.id
                  ? { ...item, tdfPositionFixed: data }
                  : item,
              ),
            );
          } else if (isChargeShown) {
            setChargeGridData((prevData) =>
              prevData.map((item) =>
                item.id === params.data.id
                  ? { ...item, tdfPositionFixed: data }
                  : item,
              ),
            );
          }
          setSelectedRow((prevRow) => ({
            ...prevRow,
            tdfPositionFixed: data,
          }));
        },
        options: positionFixedOpt,
        placeholder: "Select Position",
        value: params.data.tdfPositionFixed,
        disabled: (tdhStatus === 2 && editMode) || isDm,
      }),
      editable: false,
    },
    {
      id: 12,
      headerName: "Exp. Km",
      field: "tdfExpire",
      cellEditor: "agNumberCellEditor",
      editable: !((tdhStatus === 2 && editMode) || isDm),
      minWidth: 150,
    },
    {
      id: 13,
      headerName: "Exp. Date",
      field: "tdfExpireDate",
      cellEditor: "agDateCellEditor",
      cellRenderer: DateOnlyCellRenderer,
      editable: !((tdhStatus === 2 && editMode) || isDm),
    },
  ];

  const handleDeleteRow = (rowToDelete) => {
    const targetTdfId = rowToDelete?.tdfId ?? null;
    const targetSeq =
      rowToDelete?.tdftSeq ?? rowToDelete?.tdfSeq ?? rowToDelete?.id ?? null;

    if (editMode) {
      // Check item vs charge grid
      if (isItemShown) {
        setGridData((prev) =>
          prev.filter(
            (row) =>
              (row.tdfId ?? row.id) !== (rowToDelete.tdfId ?? rowToDelete.id),
          ),
        );
      } else if (isChargeShown) {
        setChargeGridData((prev) =>
          prev.filter(
            (row) =>
              (row.tdfId ?? row.id) !== (rowToDelete.tdfId ?? rowToDelete.id),
          ),
        );
      }
      // Track deleted row
      setDeletedList((prev) => [...prev, rowToDelete]);
    } else {
      // In create mode (not edit), handle deletion by itemId or index
      if (isItemShown) {
        setGridData((prev) => prev.filter((row) => row.id !== rowToDelete.id));
      } else if (isChargeShown) {
        setChargeGridData((prev) =>
          prev.filter((row) => row.id !== rowToDelete.id),
        );
      }
    }

    writeTaxesForRow({
      rowKey: targetTdfId == null ? targetSeq : null,
      tdfId: targetTdfId,
      taxRows: [],
    });
  };

  const chargeItemAddNewRowToGrid = async (selectedCharge, item) => {
    if (!selectedCharge) {
      console.error("No Charge Selected");
      return;
    }
    const itemId =
      typeof item === "number" ? item : item.id || item.value || item.key;

    if (!itemId) {
      console.error("Error: selectedChargeItem does not contain a valid ID.");
      return;
    }

    let templateFieldId;
    const dataRow = await getDynamicTemplateById(tdhTemplate);
    setTabDataRow(dataRow);
    const theDynamicFields = dataRow.dynamicFields;
    // ✅ Filter and store gridConfig using a new state
    setFilteredGridConfig(getFilteredGridConfig(dataRow));
    setFilteredModalGridConfig(getFilteredModalGridConfig(dataRow));
    for (let dynamic of theDynamicFields) {
      if (dynamic.dyfFieldType === 8 && dynamic.dfyCommonDropdown === 19) {
        templateFieldId = dynamic.dyfId;
      } else if (
        dynamic.dyfFieldType === 8 &&
        dynamic.dfyCommonDropdown === 22
      ) {
        templateFieldId = dynamic.dyfId;
      }
    }

    try {
      const chargeData = await getFieldValuesByTableAndId({
        tableName: "finance.tms_vf_charges",
        primaryKey: "chp_charge",
        fieldNames: "cht_charge",
        ids: selectedCharge ? selectedCharge.toString() : "",
      });

      // Extract item details
      const chargeName = chargeData?.[0]?.field1 || "Unknown Item";

      // Generate a unique row ID
      let newRowId = chargeGridData.length + 1;

      // Ensure a template is selected
      if (!chargeDynamicField) {
        toast.error("Select a Template first");
        return;
      }

      const unitPrice = item?.rawItem?.tem_price ?? 0;

      // **Default Quantity**
      const defaultQty = 1;

      // ✅ 1. Fetch Tax Amount using your helper
      const itemDetails = await getItemChargeInfo(107, itemId);
      const data = itemDetails?.[0];
      setFullItemDetails(data);

      if (!data) {
        toast.error("Item info could not be fetched.");
        return;
      }

      const {
        itemName,
        itemPrice,
        taxAmount,
        totalWithTax,
        dyfId: templateFieldId,
        taxName,
        taxRate,
        taxId,
        isTaxActive,
      } = data;

      if (!templateFieldId) {
        toast.error("Template field ID is missing.");
        return;
      }

      const taxRow = {
        taxName,
        taxRate,
        taxId,
        isTaxActive,
      };

      // Wrap in array for consistency with multi-tax usage
      const chargeTaxDetail = isTaxActive ? [taxRow] : [];

      const normalizedTaxes = normalizeTaxesForRow(chargeTaxDetail, {
        rowKey: newRowId,
        baseCost: unitPrice,
      });
      // Now fetch tax amount using the helper
      const taxAmountResult = await fetchTaxAmount(
        selectedCharge,
        unitPrice,
        normalizedTaxes,
      );

      // ✅ 2. Calculate totals using your helper
      const { baseAmount, totalAmount } = calculateTotalAmount(
        defaultQty,
        unitPrice,
        exchangeRate,
        taxAmountResult,
        0,
      );

      // Create new row with calculated values
      const newRow = {
        id: newRowId,
        tdfSeq: newRowId,
        tdftSeq: newRowId,
        itemId: selectedCharge,
        item: chargeName,
        chargeItem: item.rawItem.tem_name,
        tdfItemId: item.value,
        tdfTaxAmount: taxAmountResult,
        initialTaxAmount: taxAmountResult,
        tdfQty: defaultQty,
        tdfAmount: baseAmount,
        tdfDiscount: 0,
        tdfTotalAmount: baseAmount + taxAmountResult,
        // tdfTotalAmount: totalAmount,
        tdfUnitPrice: item.rawItem.tem_price,
        unitPrice: item.rawItem.tem_price,
        dyfField: chargeDynamicField.dyfField || templateFieldId,
        tdfPercentage: 2, // Default to $ discount
        tdfCommonDropdownId: 22,
        tdfFieldStatus: 3,
        tdfSatisfyLevel: 2,
        tdfStatus: 2,
        tdfActive: 1,
        tdfFieldType: 8,
        exchangeData: {
          excId: -1,
          excRate: 1,
          curCode: `${userCurrencyCode}: 1.00`,
        },
        tdfCurrency: -1,
        taxDetails: normalizedTaxes,
      };

      // Initialize other dynamic fields with default values
      extractedColumns.forEach((column) => {
        newRow[column.field] = ""; // Default empty value
      });
      // Append new row and update total tax
      setChargeGridData((prev) => {
        const updatedGrid = [...prev, newRow];

        // ✅ Update total tax amount
        const totalTaxAmount = updatedGrid.reduce(
          (sum, row) => sum + (parseFloat(row.tdfTaxAmount) || 0),
          0,
        );
        setTdhTaxAmount(totalTaxAmount.toFixed(2));

        return updatedGrid;
      });

      // Reset selected item
      setSelectedCharge(null);
      setIsChargeListMissing(false);

      writeTaxesForRow({
        rowKey: newRowId,
        taxRows: normalizedTaxes,
      });
    } catch (e) {
      console.error(e);
    }
  };

  const chargeAddNewRowToGrid = async (selectedCharge) => {
    if (!selectedCharge) {
      console.error("No Charge Selected");
      return;
    }
    const chargeId =
      typeof selectedCharge === "number"
        ? selectedCharge
        : selectedCharge.id || selectedCharge.value || selectedCharge.key;

    if (!chargeId) {
      console.error("Error: selectedCharge does not contain a valid ID.");
      return;
    }

    let templateFieldId;
    const dataRow = await getDynamicTemplateById(tdhTemplate);
    setTabDataRow(dataRow);
    const theDynamicFields = dataRow.dynamicFields;
    // ✅ Filter and store gridConfig using a new state
    setFilteredGridConfig(getFilteredGridConfig(dataRow));
    setFilteredModalGridConfig(getFilteredModalGridConfig(dataRow));
    for (let dynamic of theDynamicFields) {
      if (dynamic.dyfFieldType === 8 && dynamic.dfyCommonDropdown === 19) {
        templateFieldId = dynamic.dyfId;
      } else if (
        dynamic.dyfFieldType === 8 &&
        dynamic.dfyCommonDropdown === 22
      ) {
        templateFieldId = dynamic.dyfId;
      }
    }

    try {
      const chargeData = await getFieldValuesByTableAndId({
        tableName: "finance.tms_vf_charges",
        primaryKey: "chp_charge",
        fieldNames: "cht_charge",
        ids: chargeId ? chargeId.toString() : "",
      });
      // Extract item details
      const chargeName =
        chargeData?.[0]?.field1 ||
        selectedCharge.rawCharge.chtCharge ||
        "Unknown Item";

      // Generate a unique row ID
      let newRowId = chargeGridData.length + 1;

      // Ensure a template is selected
      if (!chargeDynamicField) {
        toast.error("Select a Template first");
        return;
      }

      // **Default Quantity**
      const defaultQty = 1;

      // Create new row with calculated values
      const newRow = {
        id: newRowId,
        tdfSeq: newRowId,
        tdftSeq: newRowId,
        itemId: chargeId,
        chargeItem: "N/A",
        item: chargeName,
        tdfQty: defaultQty,
        dyfField: chargeDynamicField.dyfField || templateFieldId,
        tdfPercentage: 2, // Default to $ discount
        tdfCommonDropdownId: 22,
        tdfFieldStatus: 3,
        tdfSatisfyLevel: 2,
        tdfStatus: 2,
        tdfActive: 1,
        tdfFieldType: 8,
        exchangeData: {
          excId: -1,
          excRate: 1,
          curCode: `${userCurrencyCode}: 1.00`,
        },
        tdfCurrency: -1,
      };

      // Initialize other dynamic fields with default values
      extractedColumns.forEach((column) => {
        newRow[column.field] = ""; // Default empty value
      });
      // Append new row and update total tax
      setChargeGridData((prev) => {
        const updatedGrid = [...prev, newRow];

        // ✅ Update total tax amount
        const totalTaxAmount = updatedGrid.reduce(
          (sum, row) => sum + (parseFloat(row.tdfTaxAmount) || 0),
          0,
        );
        setTdhTaxAmount(totalTaxAmount.toFixed(2));

        return updatedGrid;
      });
      // Reset selected item
      setSelectedCharge(null);
      setIsChargeListMissing(false);
    } catch (error) {
      console.error("error", error);
    }
  };

  const addNewRowToGrid = async (selectedItem) => {
    if (!selectedItem) {
      console.error("No item selected!");
      return;
    }

    const itemId =
      typeof selectedItem === "number"
        ? selectedItem
        : selectedItem.id || selectedItem.value || selectedItem.key;

    if (!itemId) {
      console.error("Error: selectedItem does not contain a valid ID.");
      return;
    }

    try {
      const itemDetails = await getItemChargeInfo(tdhTemplate, itemId);
      const data = itemDetails?.[0];
      setFullItemDetails(data);

      if (!data) {
        toast.error("Item info could not be fetched.");
        return;
      }

      const {
        itemName,
        itemPrice,
        taxAmount,
        totalWithTax,
        dyfId: templateFieldId,
      } = data;

      if (!templateFieldId) {
        toast.error("Template field ID is missing.");
        return;
      }

      const newRowId = gridData.length + 1;

      const taxRow = {
        taxName: data.taxName,
        taxRate: data.taxRate,
        taxId: data.taxId,
        isTaxActive: data.isTaxActive,
      };

      // Just wrap in array to make it consistent with multi-tax usage
      const taxGridRowArray = data?.isTaxActive ? [taxRow] : [];
      const normalizedTaxes = normalizeTaxesForRow(taxGridRowArray, {
        rowKey: newRowId,
        baseCost: parseFloat(itemPrice) || 0,
      });

      const newRow = {
        id: newRowId,
        tdfSeq: newRowId,
        tdftSeq: newRowId,
        itemId,
        item: itemName || "Unknown Item",
        tdfUnitPrice: parseFloat(itemPrice) || 0,
        unitPrice: parseFloat(itemPrice) || 0,
        tdfTaxAmount: parseFloat(taxAmount) || 0,
        initialTaxAmount: parseFloat(taxAmount) || 0,
        tdfQty: 1,
        tdfAmount: parseFloat(itemPrice) || 0,
        tdfTotalAmount: parseFloat(itemPrice) + parseFloat(taxAmount || 0),
        // tdfTotalAmount: parseFloat(totalWithTax) || 0,
        dyfField: templateFieldId,
        tdfPercentage: 2, // Default to $ discount
        tdfDiscount: 0,
        tdfCommonDropdownId: 19,
        tdfFieldStatus: 3,
        tdfSatisfyLevel: 2,
        tdfStatus: 2,
        tdfActive: 1,
        tdfFieldType: 8,
        exchangeData: {
          excId: -1,
          excRate: 1,
          curCode: `${userCurrencyCode}: 1.00`,
        },
        tdfCurrency: -1,
        taxDetails: normalizedTaxes,
      };

      extractedColumns.forEach((column) => {
        newRow[column.field] = "";
      });

      setGridData((prev) => {
        const updatedGrid = [...prev, newRow];
        const totalTaxAmount = updatedGrid.reduce(
          (sum, row) => sum + (parseFloat(row.tdfTaxAmount) || 0),
          0,
        );
        setTdhTaxAmount(totalTaxAmount.toFixed(2));
        return updatedGrid;
      });

      setItem(null);
      setSearchDropdownItemListReset(true);
      setIsItemListMissing(false);

      writeTaxesForRow({
        rowKey: newRowId,
        taxRows: normalizedTaxes,
      });
    } catch (error) {
      console.error("Error fetching item and tax info:", error);
      toast.error("Failed to add item. Please try again.");
    }
  };

  const recalculateTotal = () => {
    let totalDiscount = 0;
    let totalAmount = 0;

    if (isItemShown) {
      setGridData((prevData) => {
        return prevData.map((item) => {
          const { baseAmount, totalAmount: newTotalAmount } =
            calculateTotalAmount(
              item.tdfQty,
              item.unitPrice,
              item.exchangeData?.excRate || 1, // ✅ Use the latest exchange rate
              item.tdfTaxAmount,
              item.tdfDiscount,
            );

          totalDiscount += parseFloat(item.tdfDiscount) || 0;
          totalAmount += newTotalAmount;

          return {
            ...item,
            tdfAmount: baseAmount,
            tdfTotalAmount: newTotalAmount,
          };
        });
      });

      setTdhDiscount(totalDiscount);
    } else if (isChargeShown) {
      setChargeGridData((prevData) => {
        return prevData.map((item, idx) => {
          const { baseAmount, totalAmount: newTotalAmount } =
            calculateTotalAmount(
              item.tdfQty,
              item.unitPrice,
              item.exchangeData?.excRate || 1, // ✅ Use the latest exchange rate
              item.tdfTaxAmount,
              item.tdfDiscount,
            );

          totalDiscount += parseFloat(item.tdfDiscount) || 0;
          totalAmount += newTotalAmount;

          return {
            ...item,
            tdfAmount: baseAmount,
            tdfTotalAmount: newTotalAmount,
          };
        });
      });

      setTdhDiscount(totalDiscount);
    }
  };

  const onCurrencyHandler = async (data, rowIndex) => {
    const parsedData = data.value ? JSON.parse(data.value) : {};
    const newExcRate = parsedData.excRate || 1; // Ensure excRate is valid
    const isReset = parsedData.excId === -1; // Detect reverting action

    // Process each row asynchronously
    const processRow = async (prev) => {
      const updatedData = [...prev];

      if (rowIndex >= 0 && rowIndex < updatedData.length) {
        const item = { ...updatedData[rowIndex] };

        const prevExcRate = item.exchangeData?.excRate || 1;
        const quantity = parseFloat(item.tdfQty) || 1; // Ensure quantity is valid

        let updatedDiscount = parseFloat(item.tdfDiscount) || 0;
        let updatedTotalAmount = parseFloat(item.tdfTotalAmount) || 0;
        let updatedAmount = parseFloat(item.tdfAmount) || 0;
        let unitPrice = parseFloat(item.unitPrice) || 0;

        // ✅ FIX: Get tax amount from API in edit mode if original tax amount is not already stored
        let originalTaxAmount;
        if (item.originalTaxAmount === undefined) {
          try {
            if (isItemShown) {
              const taxResponse = await CalculateTaxAmountOfItem({
                itemId: item.itemId || item.tdfCommonDropdown,
                chargeAmount: unitPrice,
                amountType: 1,
              });
              originalTaxAmount = parseFloat(taxResponse.data?.[0]) || 0;
            } else if (isChargeShown) {
              const taxResponse = await getChargeTaxCalculation({
                chId: item.itemId,
                chAmount: unitPrice,
                amtType: 1,
                amtTaxId: null,
                amtTaxPercentage: null,
              });
              originalTaxAmount = parseFloat(taxResponse) || 0;
            }
          } catch (error) {
            console.error("Error fetching initial tax amount:", error);
            originalTaxAmount = parseFloat(item.tdfTaxAmount) || 0;
          }

          item.originalTaxAmount = originalTaxAmount;
        } else {
          originalTaxAmount = item.originalTaxAmount;
        }

        let discountAmount =
          item.tdfPercentage === 1
            ? (updatedAmount * updatedDiscount) / 100
            : null;

        // ✅ Apply Exchange Rate Changes to Discount
        if (item.tdfPercentage === 2) {
          // Fixed amount discount
          updatedDiscount = isReset
            ? updatedDiscount / prevExcRate
            : updatedDiscount * newExcRate;
        } else if (item.tdfPercentage === 1) {
          // Percentage discount - keep percentage unchanged
          updatedDiscount = item.tdfDiscount;
        }

        // ✅ FIX: Correct Tax Amount Calculation - Consider Exchange Rate & Quantity
        let updatedTax;
        if (isReset) {
          updatedTax = originalTaxAmount * quantity; // When resetting to base currency, only multiply by quantity
        } else {
          updatedTax = originalTaxAmount * newExcRate * quantity; // Apply both exchange rate and quantity
        }

        // ✅ FIX: Ensure `tdfAmount` is properly converted
        if (isReset) {
          updatedAmount = (updatedAmount / prevExcRate) * quantity; // Consider quantity
        } else {
          updatedAmount = updatedAmount * (newExcRate / prevExcRate) * quantity; // Consider quantity
        }

        // ✅ Calculate actual discount amount based on percentage or fixed amount
        let actualDiscount;
        if (item.tdfPercentage === 1) {
          // Percentage discount
          actualDiscount = (updatedAmount * updatedDiscount) / 100;
        } else {
          // Fixed amount discount
          actualDiscount = updatedDiscount;
        }

        // ✅ Update Total Amount Calculation
        updatedTotalAmount = updatedAmount + updatedTax - actualDiscount;

        // Update the row data
        updatedData[rowIndex] = {
          ...item,
          exchangeData: {
            excId: parsedData.excId,
            excRate: newExcRate,
            curCode: parsedData.curCode,
          },
          tdfCurrency: parsedData.excId,

          // ✅ Corrected tax and amount handling
          tdfTaxAmount: parseFloat(updatedTax.toFixed(2)),
          tdfDiscount: updatedDiscount,
          tdfDiscountAmount: actualDiscount, // Store the calculated discount amount
          tdfAmount: updatedAmount,
          tdfTotalAmount: updatedTotalAmount.toFixed(2),
          originalTaxAmount: originalTaxAmount, // Preserve the original tax amount
        };
      }

      return updatedData;
    };

    let currentGrid = [];
    if (isItemShown) {
      currentGrid = gridData;
    } else if (isChargeShown) {
      currentGrid = chargeGridData;
    }
    // Process the data with the async function
    const updatedGridData = await processRow(currentGrid);
    if (isItemShown) {
      setGridData(updatedGridData);
    } else if (isChargeShown) {
      setChargeGridData(updatedGridData);
    }

    // ✅ Trigger a Full Recalculation to Update `tdhDiscount`
    recalculateTotal();

    setExchangeRate({});
    setRowData({});
    closeCurrencyModal();
  };

  const calculateTotalAmount = (
    qty,
    unitPrice,
    excRate,
    taxAmount = 0,
    discount = 0,
  ) => {
    qty = parseFloat(qty) || 0;
    unitPrice = parseFloat(unitPrice) || 0;
    excRate = parseFloat(excRate) || 1;
    taxAmount = parseFloat(taxAmount) || 0;
    discount = parseFloat(discount) || 0;

    const baseAmount = qty * unitPrice * excRate;
    const totalAmount = baseAmount + taxAmount - discount;

    return {
      baseAmount, // Amount before tax and discount
      totalAmount, // Final total after discount
    };
  };

  const fetchTaxAmount = async (itemId, chargeAmount, taxDetails) => {
    if (!Array.isArray(taxDetails) || taxDetails.length === 0) return 0;
    const amount = parseFloat(chargeAmount) || 0;
    let totalTax = 0;
    taxDetails.forEach((tax) => {
      if (tax.isTaxActive && tax.taxRate) {
        const rate = parseFloat(tax.taxRate);
        const taxValue = (amount * rate) / 100;
        totalTax += taxValue;
      }
    });

    return totalTax;
  };

  const updateGridRow = (rowIndex, updatedValues) => {
    if (isChargeShown) {
      setChargeGridData((prevData) =>
        prevData.map((row, index) =>
          index === rowIndex ? { ...row, ...updatedValues } : row,
        ),
      );
    } else if (isItemShown) {
      setGridData((prevData) =>
        prevData.map((row, index) =>
          index === rowIndex ? { ...row, ...updatedValues } : row,
        ),
      );
    }
    recalculateTotal();
  };

  const finalizeRowUpdate = (params) => {
    recalculateTotal();
    setRowData(params.data);
    setTimeout(() => {
      params.api.refreshCells({ rowNodes: [params.node], force: true });
    }, 10);
  };

  const onDynamicCellEditingStopped = async (params) => {
    if (!params.valueChanged) return;

    const isChargeTab = isChargeShown === true;
    const currentGridData = isChargeTab ? chargeGridData : gridData;
    const rowToUpdate = currentGridData[params.rowIndex];
    if (!rowToUpdate) return;

    const updatedRow = { ...rowToUpdate };
    const field = params.colDef.field;
    let newValue = params.value;

    switch (field) {
      case "tdfDiscount":
        let discountInput = parseFloat(params.value);
        if (isNaN(discountInput)) discountInput = 0;
        const excRate = parseFloat(updatedRow.exchangeData?.excRate) || 1;
        const prevExcRate =
          parseFloat(updatedRow.exchangeData?.prevExcRate) || 1;
        if (
          discountInput !== 0 &&
          updatedRow.tdfPercentage === 2 &&
          prevExcRate !== excRate
        ) {
          discountInput = (discountInput * excRate) / prevExcRate;
        }
        updatedRow.tdfDiscount = discountInput;
        break;

      case "tdfQty":
        newValue = parseFloat(newValue) || 0;
        if (newValue === 0) {
          toast.warning("Quantity cannot be 0. Resetting to 1.", {
            autoClose: 3000,
            containerId: "Main",
          });
          newValue = 1;
        }
        updatedRow.tdfQty = newValue;
        updatedRow.unitPrice =
          updatedRow.tdfUnitPrice || updatedRow.unitPrice || 0;
        break;

      case "tdfUnitPrice":
        newValue = parseFloat(newValue) || 0;
        if (newValue < 0) {
          toast.warning("Unit price cannot be negative. Resetting to 0.", {
            autoClose: 3000,
            containerId: "Main",
          });
          newValue = 0;
        }
        updatedRow.unitPrice = newValue;
        updatedRow.tdfUnitPrice = newValue;
        break;

      case "tdfDescription":
        updatedRow.tdfDescription = newValue ? String(newValue) : "";
        updateGridRow(params.rowIndex, updatedRow, isChargeTab);
        finalizeRowUpdate(params);
        return;

      default:
        return;
    }

    // ✅ Everything below is after the switch block
    const qty = parseFloat(updatedRow.tdfQty) || 0;
    const unitPrice = parseFloat(updatedRow.tdfUnitPrice) || 0;
    const discount = parseFloat(updatedRow.tdfDiscount) || 0;
    const excRate = parseFloat(updatedRow.exchangeData?.excRate) || 1;

    console.log(
      "tdfPercentage on discount edit:",
      updatedRow.tdfPercentage,
      "discount:",
      discount,
    );

    const taxAmountPerUnit = await fetchTaxAmount(
      updatedRow.itemId,
      unitPrice,
      updatedRow.taxDetails,
    );
    const totalTaxAmount = taxAmountPerUnit * qty * excRate;

    const rowKey = updatedRow.tdfId ?? updatedRow.tdftSeq ?? updatedRow.id;
    const updatedTaxDetails = (updatedRow.taxDetails || []).map((tax) => ({
      ...tax,
      tdtCost: unitPrice,
      tdtWithTax: unitPrice + unitPrice * (parseFloat(tax.taxRate) / 100),
    }));
    writeTaxesForRow({
      rowKey: updatedRow.tdfId == null ? rowKey : null,
      tdfId: updatedRow.tdfId ?? null,
      taxRows: normalizeTaxesForRow(updatedTaxDetails, {
        rowKey,
        baseCost: unitPrice,
        tdfId: updatedRow.tdfId ?? null,
      }),
    });

    const { baseAmount } = calculateTotalAmount(
      qty,
      unitPrice,
      excRate,
      totalTaxAmount,
      0,
    );

    const discountAmount =
      updatedRow.tdfPercentage === 1 ? (baseAmount * discount) / 100 : discount;

    console.log("baseAmount:", baseAmount, "discountAmount:", discountAmount);

    updatedRow.tdfAmount = baseAmount.toFixed(2);
    updatedRow.tdfTaxAmount = totalTaxAmount.toFixed(2);
    updatedRow.tdfTotalAmount = Math.max(
      baseAmount + totalTaxAmount - discountAmount,
      0,
    ).toFixed(2);

    updateGridRow(params.rowIndex, updatedRow, isChargeTab);
    finalizeRowUpdate(params);
  };

  // const onDynamicCellEditingStopped = async (params) => {
  //   if (!params.valueChanged) return;

  //   const isChargeTab = isChargeShown === true;
  //   const currentGridData = isChargeTab ? chargeGridData : gridData;
  //   const rowToUpdate = currentGridData[params.rowIndex];
  //   if (!rowToUpdate) return;

  //   const updatedRow = { ...rowToUpdate };
  //   const field = params.colDef.field;
  //   let newValue = params.value;

  //   switch (field) {
  //     case "tdfDiscount":
  //       let discountInput = parseFloat(params.value);
  //       if (isNaN(discountInput)) discountInput = 0;

  //       const excRate = parseFloat(updatedRow.exchangeData?.excRate) || 1;
  //       const prevExcRate =
  //         parseFloat(updatedRow.exchangeData?.prevExcRate) || 1;

  //       if (
  //         discountInput !== 0 &&
  //         updatedRow.tdfPercentage === 2 &&
  //         prevExcRate !== excRate
  //       ) {
  //         discountInput = (discountInput * excRate) / prevExcRate;
  //       }

  //       updatedRow.tdfDiscount = discountInput;

  //       // Your tax fetch + update logic here...
  //       break;

  //     case "tdfQty":
  //       newValue = parseFloat(newValue) || 0;
  //       if (newValue === 0) {
  //         toast.warning("Quantity cannot be 0. Resetting to 1.", {
  //           autoClose: 3000,
  //           containerId: "Main",
  //         });
  //         newValue = 1;
  //       }
  //       updatedRow.tdfQty = newValue;
  //       updatedRow.unitPrice =
  //         updatedRow.tdfUnitPrice || updatedRow.unitPrice || 0;
  //       break;

  //     case "tdfUnitPrice":
  //       newValue = parseFloat(newValue) || 0;
  //       if (newValue < 0) {
  //         toast.warning("Unit price cannot be negative. Resetting to 0.", {
  //           autoClose: 3000,
  //           containerId: "Main",
  //         });
  //         newValue = 0;
  //       }
  //       updatedRow.unitPrice = newValue;
  //       updatedRow.tdfUnitPrice = newValue;
  //       break;

  //     case "tdfDescription":
  //       updatedRow.tdfDescription = newValue ? String(newValue) : "";
  //       updateGridRow(params.rowIndex, updatedRow, isChargeTab);
  //       finalizeRowUpdate(params);
  //       return;

  //     default:
  //       return;
  //   }

  //   const qty = parseFloat(updatedRow.tdfQty) || 0;
  //   const unitPrice = parseFloat(updatedRow.tdfUnitPrice) || 0;
  //   const discount = parseFloat(updatedRow.tdfDiscount) || 0;
  //   const excRate = parseFloat(updatedRow.exchangeData?.excRate) || 1;

  //   const taxAmountPerUnit = await fetchTaxAmount(
  //     updatedRow.itemId,
  //     unitPrice,
  //     updatedRow.taxDetails,
  //   );
  //   const totalTaxAmount = taxAmountPerUnit * qty * excRate;

  //   const { baseAmount, totalAmount } = calculateTotalAmount(
  //     qty,
  //     unitPrice,
  //     excRate,
  //     totalTaxAmount,
  //     discount,
  //   );

  //   updatedRow.tdfAmount = baseAmount.toFixed(2);
  //   updatedRow.tdfTaxAmount = totalTaxAmount.toFixed(2);
  //   updatedRow.tdfTotalAmount = totalAmount.toFixed(2);

  //   updateGridRow(params.rowIndex, updatedRow, isChargeTab);
  //   finalizeRowUpdate(params);
  // };

  const cellDoubleClickHandler = (params) => {
    console.log("params", params);
    switch (params.colDef.headerName) {
      case "Curr.": {
        setSelectedRowIndex(params.rowIndex);

        setRowData((prev) => ({
          ...params.data,
          theRowId: params.rowIndex === 0 ? 0 : params.rowIndex || null,
        }));

        setExchangeRate({
          key: params.data.exchangeData?.excId,
          text: params.data.exchangeData?.curCode,
          value: JSON.stringify(params.data.exchangeData),
        });

        openCurrencyModal();
        break;
      }
      case "Tax": {
        setSelectedRowIndex(params.rowIndex);

        const currentRow = {
          ...params.data,
          theRowId: params.rowIndex,
        };
        setRowData(currentRow);

        if (!editMode) {
          // Convert existing tax details (if any) to DTO format
          const formattedTaxes = (params.data.taxDetails || []).map((tax) => {
            const cost = Number(currentRow?.unitPrice || 0);
            const taxRate = Number(tax.taxRate || 0);
            const withTax = cost + (cost * taxRate) / 100;

            return {
              ...tax,
              tdtTdhId: editMode ? tdhId : null,
              tdtTdfId: currentRow?.tdfId || null,
              tdtTaxId: tax.taxId,
              tdtTaxRate: taxRate,
              tdtCost: cost,
              tdtSeq: params.data.tdftSeq,
              tdtWithTax: withTax,
              tdtReferance: tax.taxName || "",
              tdtCompany: tdhCompany,
              tdtStatus: 2,
              tdtActive: 1,
              createdBy: user.username,
            };
          });
          setTaxGridData((prev) => {
            const itemKey = params.data.tdfId ?? params.data.tdftSeq; // saved vs. new row
            const isSaved = params.data.tdfId != null;

            const others = prev.filter((tax) =>
              isSaved ? tax.tdtTdfId !== itemKey : tax.tdtSeq !== itemKey,
            );

            return [...others, ...formattedTaxes]; // merge instead of replace
          });
        } else {
          console.log("Editing the tax row data in edit mode", taxGridData);
        }

        openTaxModal(); // Show modal
        break;
      }
      default:
        break;
    }
  };

  const filteredTaxGridData = taxGridData.filter((tax) => {
    if (rowData?.tdfId != null) {
      // Existing (saved) item → match by persisted id
      return tax.tdtTdfId === rowData.tdfId;
    }

    // New (unsaved) item → match by its temporary sequence
    const seq = rowData?.tdftSeq ?? selectedRowIndex; // pick ONE key
    return tax.tdtSeq === seq; // no extra “||”
  });

  const handleAddTax = async (selected) => {
    if (!selected || !selected.taxId || !selected.taxName) return;

    const isSavedItem = rowData?.tdfId != null;
    const itemTaxKey = isSavedItem ? rowData.tdfId : rowData?.tdftSeq;

    if (!itemTaxKey) {
      console.warn("Item key missing — cannot assign tax properly");
      return;
    }

    // ✅ Prevent duplicate tax per item, not globally
    const alreadyExists = taxGridData.some(
      (tax) =>
        tax.tdtTaxId === selected.taxId &&
        (isSavedItem
          ? tax.tdtTdfId === itemTaxKey // match by tdfId for saved items
          : tax.tdtSeq === itemTaxKey), // match by tdftSeq for new items
    );

    if (alreadyExists) return;

    try {
      const rate = await taxRate(selected.taxId);
      if (rate == null || isNaN(rate)) {
        console.error("Invalid tax rate received from API:", rate);
        return;
      }

      const cost = Number(rowData?.unitPrice || 0);
      const withTax = cost + (cost * rate) / 100;

      const newTax = {
        isTaxActive: true,
        tdtTdhId: editMode ? tdhId : null,
        tdtTdfId: rowData?.tdfId || null,
        tdtTaxId: selected.taxId,
        tdtTaxRate: rate,
        tdtCost: cost,
        tdtSeq: rowData?.tdftSeq ?? null,
        tdtWithTax: withTax,
        tdtReferance: selected.taxName || "",
        tdtCompany: tdhCompany,
        tdtStatus: 2,
        tdtActive: 1,
        createdBy: user.username,
        taxName: selected.taxName,
        taxRate: rate,
        taxId: selected.taxId,
      };

      const updatedTaxes = [...taxGridData, newTax];
      setTaxGridData(updatedTaxes);

      const totalTax = calculateTaxAmount(
        cost,
        updatedTaxes.filter((t) =>
          isSavedItem ? t.tdtTdfId === itemTaxKey : t.tdtSeq === itemTaxKey,
        ),
      );

      updateGridRowTax(rowData?.itemId, totalTax, updatedTaxes);
    } catch (err) {
      console.error("Failed to add tax:", err);
    }
  };

  const handleDeleteTax = (params) => {
    const targetTaxId = params?.data?.tdtTaxId || params?.data?.taxId;
    const targetTdfId = params?.data?.tdtTdfId;
    const targetSeq = params?.data?.tdtSeq;

    if (!targetTaxId) return;

    // Remove the tax row
    const updated = taxGridData.filter((tax) => {
      const id = tax.tdtTaxId || tax.taxId;
      return id !== targetTaxId;
    });

    setTaxGridData(updated);

    // Find all taxes for the same item (by tdtTdfId or tdtSeq)
    const relatedTaxes = updated.filter((tax) => {
      if (targetTdfId != null) {
        return tax.tdtTdfId === targetTdfId;
      } else {
        return tax.tdtSeq === targetSeq;
      }
    });

    const totalTax = calculateTaxAmount(rowData?.unitPrice, relatedTaxes);
    updateGridRowTax(rowData?.itemId, totalTax, updated);
  };

  const calculateTaxAmount = (baseAmount, taxList = []) => {
    let totalTax = 0;

    taxList.forEach((tax) => {
      const rate = parseFloat(tax.taxRate || 0);
      totalTax += baseAmount * (rate / 100);
    });

    return totalTax;
  };

  // const updateGridRowTax = (itemId, newTaxAmount, taxDetails = []) => {
  //   if (isChargeShown) {
  //     setChargeGridData((prev) =>
  //       prev.map((row) =>
  //         row.itemId === itemId
  //           ? {
  //               ...row,
  //               tdfTax: newTaxAmount,
  //               tdfTaxAmount: newTaxAmount,
  //               tdfTotalAmount: (row.tdfAmount || 0) + newTaxAmount,
  //               taxDetails,
  //             }
  //           : row,
  //       ),
  //     );
  //   } else {
  //     setGridData((prev) =>
  //       prev.map((row) =>
  //         row.itemId === itemId
  //           ? {
  //               ...row,
  //               tdfTax: newTaxAmount,
  //               tdfTaxAmount: newTaxAmount,
  //               tdfTotalAmount: (row.tdfAmount || 0) + newTaxAmount,
  //               taxDetails,
  //             }
  //           : row,
  //       ),
  //     );
  //   }
  // };

  const updateGridRowTax = (itemId, newTaxAmount, taxDetails = []) => {
    const updateRow = (row) => {
      if (row.itemId !== itemId) return row;
      const discount = parseFloat(row.tdfDiscountAmount) || 0;
      return {
        ...row,
        tdfTax: newTaxAmount,
        tdfTaxAmount: newTaxAmount,
        tdfTotalAmount: Math.max(
          (parseFloat(row.tdfAmount) || 0) + newTaxAmount - discount,
          0,
        ),
        taxDetails,
      };
    };

    if (isChargeShown) {
      setChargeGridData((prev) => prev.map(updateRow));
    } else {
      setGridData((prev) => prev.map(updateRow));
    }
  };

  const handleModalGridEdit = (params) => {
    if (isItemShown) {
      setGridData((prevData) =>
        prevData.map((row) =>
          row.id === selectedRow.id
            ? { ...row, [params.colDef.field]: params.value }
            : row,
        ),
      );
    } else if (isChargeShown) {
      setChargeGridData((prevData) =>
        prevData.map((row) =>
          row.id === selectedRow.id
            ? { ...row, [params.colDef.field]: params.value }
            : row,
        ),
      );
    }

    setSelectedRow((prevRow) => ({
      ...prevRow,
      [params.colDef.field]: params.value, // Only update the edited field
    }));
  };

  console.log("TdhDriverId", tdhDriverId);
  console.log("TdhDriver", tdhDriver);

  const handleSelectVehicleId = async (data) => {
    try {
      setIsDriverVehicleDetailLoading(true);
      const response = await getVehicleModalTyreDetails(data);
      console.log("The response: ", response);

      if (response) {
        // Set Model
        setTdhModel(response.modelName || "");
        setTdhModelId(response.vehModelId || "");
        //set Transporter
        setTdhTransporter(response.transporterName || "");
        setTdhTransporterId(response.vehTransporter || "");
        //Set Base Driver
        // setTdhDriver(response.driverName);
        setTdhDriver(response.driverName || "");
        // if (tdhDriverId === tdhBaseDriverId) {
        setTdhDriverId(response.vehBasedDriver);
        if (response.vehBasedDriver) {
          const driverDetails = await getInspectionDriverDetails(
            response.vehBasedDriver,
          );
          if (driverDetails) {
            setTdhDriver(driverDetails?.driverName || "");
            setTdhDriverNic(driverDetails?.driverNic || "");
            setTdhDriverMobile(driverDetails?.driverMobile || "");
            setTdhDriverNicImg(driverDetails?.driverNicImg || "");
            setTdhDriverGsImg(driverDetails?.driverGsImg || "");
            setTdhDriverDrImg(driverDetails?.driverDrImg || "");
            setTdhDriverPoliceImg(driverDetails?.driverPoliceImg || "");
          }
        }
        // }
        setTdhBaseDriverId(response.vehBasedDriver || "");
        // Set Num Tyres
        setTdhNumTyres(response.noOfTyres || "");

        // Set Tyre Size
        setTdhTyreSize(response.vehTyreSizeId || "");
        setTdhVehTypeSize(response.vehTypeSize || "");
        setTdhVehBodyType(response.vehBodyType || "");
        setTdhVehInspectionGroup(response.vehInspectionGroup || "");
        setTdhVehOperationType(response.vehOperationType || "");
        setTdhVehWidth(response.vehWidth || "");
        setTdhVehLength(response.vehLength || "");
        setTdhVehHeight(response.vehHeight || "");
      }

      setIsDriverVehicleDetailLoading(false);
    } catch (error) {
      console.error("Error fetching vehicle details:", error);
    }
  };

  const handleSelectDriverId = async (data) => {
    try {
      setIsDriverVehicleDetailLoading(true);

      if (data) {
        const driverDetails = await getInspectionDriverDetails(data);
        if (driverDetails) {
          setTdhDriver(driverDetails?.driverName || "");
          setTdhDriverNic(driverDetails?.driverNic || "");
          setTdhDriverMobile(driverDetails?.driverMobile || "");
          setTdhDriverNicImg(driverDetails?.driverNicImg || "");
          setTdhDriverGsImg(driverDetails?.driverGsImg || "");
          setTdhDriverDrImg(driverDetails?.driverDrImg || "");
          setTdhDriverPoliceImg(driverDetails?.driverPoliceImg || "");
          setTdhTransporterId(
              driverDetails?.driverTransporter
                  ? driverDetails.driverTransporter.toString()
                  : "",
          ); // ✅ drives the vehicle dropdown's param5
          setTdhDriverTransporter(
              driverDetails?.driverTransporter
                  ? driverDetails.driverTransporter.toString()
                  : "",
          ); // ✅ optional: keeps driver field's own param5 in sync too
        }
      }

      setIsDriverVehicleDetailLoading(false);
    } catch (error) {
      console.error("Error fetching driver details:", error);
    }
  };

  console.log("tdh action date", tdhActionDate);

  return (
    <>
      {isBlurred && (
        <div className="blur-overlay">
          <LoadingSpinner message={editMode ? "Updating..." : "Saving..."} />
        </div>
      )}
      {isPrintLoading && (
        <div className="blur-overlay">
          <LoadingSpinner message={"Printing..."} />
        </div>
      )}
      <div
        className={isBlurred ? "blurred" : ""}
        style={{ width: "100%", zoom: "1" }}
      >
        <div style={{ width: "100%" }}>
          <div className="ui tabular menu top attached">
            <Tab
              Icon={Database}
              onClick={() => {
                setTab(1);
              }}
              active={tab === 1}
              label="Manage Info"
              authenticated={true}
              form={
                isDm ? FORMS.FLEET.INFO.form : FORMS.FLEET_INSPECTION.INFO.form
              }
              module={MODULES.Fleet}
            />
            <Tab
              Icon={Upload}
              onClick={() => {
                setTab(2);
              }}
              active={tab === 2}
              label="Manage Documents"
              authenticated={true}
              form={
                isDm
                  ? FORMS.FLEET.DOCUMENT.form
                  : FORMS.FLEET_INSPECTION.DOCUMENT.form
              }
              module={MODULES.Fleet}
            />
            {editMode && (
              <Tab
                Icon={Award}
                onClick={() => {
                  setTab(3);
                }}
                active={tab === 3}
                label="Cost Details"
                authenticated={true}
                form={
                  isDm
                    ? FORMS.FLEET_UPDATE.COST.form
                    : FORMS.FLEET_INSPECTION_UPDATE.COST.form
                }
                module={MODULES.Fleet}
              />
            )}
          </div>
          <div
            className="ui bottom attached active tab segment"
            style={{ display: tab === 1 ? "block" : "none", width: "100%" }}
          >
            {infoLoading || dropdownValuesLoading ? (
              <LoadingSpinner />
            ) : (
              <div className="ui form">
                <div
                  className="ui styled accordion"
                  style={{ width: "100%", marginBottom: "10px" }}
                >
                  <div
                    className={`title ${activeAccordionHeader ? "active" : ""}`}
                    onClick={() =>
                      setActiveAccordionHeader(!activeAccordionHeader)
                    }
                  >
                    <i className="dropdown icon"></i> Template / General Details
                  </div>
                  {activeAccordionHeader && (
                    <div className="content active" style={{}}>
                      <h4 className="ui dividing header">Template Filter</h4>
                      <div className="three fields">
                        <Dropdown
                          required={true}
                          clearable
                          search={true}
                          options={dropdownOptions.categoryOptions}
                          placeholder="Category"
                          label="Category"
                          value={tdhCategory}
                          onChange={(e, data) => {
                            setTdhCategory(data.value);
                          }}
                          error={currentErrors.tdhCategory}
                          resetError={() =>
                            setCurrentErrors((prevState) => {
                              const { tdhCategory: _, ...rest } = prevState;
                              return rest;
                            })
                          }
                          disabled={
                            editMode ||
                            (persistedTdhStatus === 2 && editMode) ||
                            (persistedTdhStatus === 3 && editMode)
                          }
                        />

                        <Dropdown
                          required={true}
                          clearable
                          search={true}
                          options={dropdownOptions.managementTypeOptions}
                          placeholder={"Management Type"}
                          label="Management Type"
                          value={tdhInspectionType}
                          onChange={(e, data) => {
                            setTdhInspectionType(data.value);
                          }}
                          error={currentErrors.tdhInspectionType}
                          resetError={() =>
                            setCurrentErrors((prevState) => {
                              const { tdhInspectionType: _, ...rest } =
                                prevState;
                              return rest;
                            })
                          }
                          disabled={
                            editMode ||
                            (persistedTdhStatus === 2 && editMode) ||
                            (persistedTdhStatus === 3 && editMode)
                          }
                        />
                        <Dropdown
                          required={true}
                          clearable
                          search={true}
                          options={templateOptions}
                          placeholder={
                            templateSetLoading
                              ? "Loading..."
                              : templateOptions?.length === 0
                                ? "No Templates"
                                : "Select Template"
                          }
                          label="Template"
                          value={tdhTemplate}
                          onChange={(e, data) => {
                            setTdhTemplate(data.value);
                          }}
                          disabled={
                            templateSetLoading ||
                            !tdhCategory ||
                            !tdhInspectionType ||
                            templateOptions?.length === 0 ||
                            editMode ||
                            (persistedTdhStatus === 2 && editMode) ||
                            (persistedTdhStatus === 3 && editMode)
                          }
                          error={currentErrors.tdhTemplate}
                          resetError={() =>
                            setCurrentErrors((prevState) => {
                              const { tdhTemplate: _, ...rest } = prevState;
                              return rest;
                            })
                          }
                        />
                      </div>
                      <h4 className="ui dividing header">General Details</h4>
                      <div className="two fields">
                        <SearchDropdown
                          required={true}
                          ref={searchDropdownRef}
                          key={1}
                          label={"Vehicle"}
                          clearable={true}
                          onClear={() => {
                            setTdhRefId("");

                            setTdhModelId("");
                            setTdhModel("");
                            setTdhTransporter("");
                            setTdhTransporterId("");
                            setTdhTyreSize("");
                            setTdhNumTyres("");
                            if (tdhBaseDriverId === tdhDriverId) {
                              setTdhDriverId("");
                              setTdhDriver("");
                              setTdhBaseDriverId("");
                              driverRef.current.reset();
                              setTdhDriverNic("");
                              setTdhDriverMobile("");
                              setTdhDriverNicImg("");
                              setTdhDriverGsImg("");
                              setTdhDriverDrImg("");
                              setTdhDriverPoliceImg("");
                            }
                            setTdhVehTypeSize("");
                            setTdhVehBodyType("");
                            setTdhVehInspectionGroup("");
                            setTdhVehOperationType("");
                            setTdhVehWidth("");
                            setTdhVehLength("");
                            setTdhVehHeight("");
                          }}
                          editMode={editMode}
                          reset={searchFieldReset}
                          setReset={setSearchFieldReset}
                          onResultSelect={(data) => {
                            setTdhRefId(data);
                            handleSelectVehicleId(data);
                          }}
                          // api={getOtherRefSearchDropdown}
                          threshold={1}
                          // apiDependency={
                          //   tdhCategory === 1
                          //     ? {
                          //         type: "vehicle",
                          //         value: "",
                          //       }
                          //     : {
                          //         type: "stakeholder_type",
                          //         value: "Transporter",
                          //       }
                          // }
                          api={getOtherRefDetails}
                          apiDependency={
                            tdhCategory === 1
                                ? {
                                  type: "external_user_vehicle",
                                  value: "",
                                  param3: user.username,
                                  param5: tdhTransporterId ? tdhTransporterId.toString() : "",
                                }
                                : {
                                  type: "stakeholder_type",
                                  value: "Transporter",
                                }
                          }
                          fieldInfo={
                            tdhCategory === 1
                              ? {
                                  tableName: "masterdata.tms_m_vehicle_details",
                                  primaryKey: "veh_id",
                                  fieldName: "veh_vehicleno",
                                  id: tdhRefId,
                                }
                              : {
                                  tableName: "masterdata.tms_m_stakeholder",
                                  primaryKey: "stk_id",
                                  fieldName: "stk_name",
                                  id: tdhRefId,
                                }
                          }
                          error={currentErrors.tdhRefId}
                          resetError={() =>
                            setCurrentErrors((prevState) => {
                              const { tdhRefId: _, ...rest } = prevState;
                              return rest;
                            })
                          }
                          disabled={
                            !tdhCategory ||
                            (persistedTdhStatus === 2 && editMode) ||
                            (persistedTdhStatus === 3 && editMode)
                          }
                        />
                        {tdhRefId ? (
                          <TooltipIcon
                            popupClassName="auto-fit-popup"
                            style={{ paddingTop: "30px" }}
                            position="bottom left"
                            content={
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns:
                                    "max-content max-content",
                                  columnGap: 16,
                                  rowGap: 8,
                                  alignItems: "center",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <div style={{ fontWeight: 600 }}>
                                  Transporter
                                </div>
                                <div>{tdhTransporter}</div>

                                <div style={{ fontWeight: 600 }}>Model</div>
                                <div>{tdhModel}</div>

                                <div style={{ fontWeight: 600 }}>
                                  No of Tyres
                                </div>
                                <div>{tdhNumTyres}</div>

                                {/* <div style={{ fontWeight: 600 }}>
                                    Tyre Size
                                  </div>
                                  <div>{tdhTyreSize}</div> */}

                                <div style={{ fontWeight: 600 }}>
                                  Vehicle Size
                                </div>
                                <div>{tdhVehTypeSize}</div>

                                <div style={{ fontWeight: 600 }}>Body Type</div>
                                <div>{tdhVehBodyType}</div>

                                <div style={{ fontWeight: 600 }}>
                                  Inspection Group
                                </div>
                                <div>{tdhVehInspectionGroup}</div>

                                <div style={{ fontWeight: 600 }}>
                                  Operation Type
                                </div>
                                <div>{tdhVehOperationType}</div>

                                <div style={{ fontWeight: 600 }}>
                                  Vehicle Width
                                </div>
                                <div>{tdhVehWidth}</div>

                                <div style={{ fontWeight: 600 }}>
                                  Vehicle Length
                                </div>
                                <div>{tdhVehLength}</div>

                                <div style={{ fontWeight: 600 }}>
                                  Vehicle Height
                                </div>
                                <div>{tdhVehHeight}</div>
                              </div>
                            }
                          >
                            <Info size={30} color="#919191" />
                          </TooltipIcon>
                        ) : (
                          ""
                        )}

                        <SearchDropdown
                          ref={driverRef}
                          key={1}
                          readOnly={persistedTdhStatus === 2 && editMode}
                          reset={searchFieldReset}
                          setReset={setSearchFieldReset}
                          clearable={true}
                          multiGrid={true}
                          multiGridCurrentValue={tdhDriver}
                          onClear={() => {
                            setTdhDriver("");
                            setTdhDriverId("");
                            setTdhDriverNic("");
                            setTdhDriverMobile("");
                            setTdhDriverNicImg("");
                            setTdhDriverGsImg("");
                            setTdhDriverDrImg("");
                            setTdhDriverPoliceImg("");

                            setTdhRefId("");
                            setTdhModelId("");
                            setTdhModel("");
                            setTdhTransporter("");
                            setTdhTransporterId("");
                            setTdhDriverTransporter("");
                            setTdhTyreSize("");
                            setTdhNumTyres("");
                            setTdhVehTypeSize("");
                            setTdhVehBodyType("");
                            setTdhVehInspectionGroup("");
                            setTdhVehOperationType("");
                            setTdhVehWidth("");
                            setTdhVehLength("");
                            setTdhVehHeight("");
                            searchDropdownRef.current?.reset();
                          }}
                          value={tdhDriverId}
                          onResultSelect={(data) => {
                            setTdhDriver("");
                            setTdhDriverId("");
                            setTdhDriverNic("");
                            setTdhDriverMobile("");
                            setTdhDriverNicImg("");
                            setTdhDriverGsImg("");
                            setTdhDriverDrImg("");
                            setTdhDriverPoliceImg("");
                            setTdhDriverId(data);
                            setTdhRefId("");
                            setTdhModelId("");
                            setTdhModel("");
                            setTdhTransporter("");
                            setTdhTransporterId("");
                            setTdhTyreSize("");
                            setTdhNumTyres("");
                            setTdhVehTypeSize("");
                            setTdhVehBodyType("");
                            setTdhVehInspectionGroup("");
                            setTdhVehOperationType("");
                            setTdhVehWidth("");
                            setTdhVehLength("");
                            setTdhVehHeight("");
                            searchDropdownRef.current?.reset();

                            handleSelectDriverId(data);
                          }}
                          // api={getOtherRefDetails}
                          // apiDependency={{
                          //   type: "employee",
                          //   value: "Driver",
                          // }}
                          api={getOtherRefDetails}
                          apiDependency={{
                            type: "external_user_employee",
                            value: "Driver",
                            param3: user.username,
                          }}
                          fieldInfo={{
                            tableName: "masterdata.tms_m_employee",
                            primaryKey: "emp_id",
                            fieldName: "emp_fullname",
                            id: tdhDriverId ? tdhDriverId.toString() : "",
                          }}
                          editMode={editMode}
                          label="Driver"
                          required={true}
                          error={currentErrors?.tdhDriverId}
                          resetError={() =>
                            setCurrentErrors((prevState) => {
                              const { tdhDriverId: _, ...rest } = prevState;
                              return rest;
                            })
                          }
                          disabled={
                            (persistedTdhStatus === 2 && editMode) ||
                            (persistedTdhStatus === 3 && editMode)
                          }
                        />
                        {tdhDriverId ? (
                          <TooltipIcon
                            popupClassName="auto-fit-popup"
                            style={{ paddingTop: "30px" }}
                            position="bottom left"
                            content={
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns:
                                    "max-content max-content",
                                  columnGap: 16,
                                  rowGap: 8,
                                  alignItems: "center",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <div style={{ fontWeight: 600 }}>
                                  Driver Nic No
                                </div>
                                <div>{tdhDriverNic}</div>

                                <div style={{ fontWeight: 600 }}>
                                  Driver Mobile
                                </div>
                                <div>{tdhDriverMobile}</div>

                                <div style={{ fontWeight: 600 }}>Nic</div>
                                <div>{tdhDriverNicImg}</div>

                                <div style={{ fontWeight: 600 }}>
                                  Driving License
                                </div>
                                <div>{tdhDriverDrImg}</div>

                                <div style={{ fontWeight: 600 }}>
                                  Gramasewaka Report
                                </div>
                                <div>{tdhDriverGsImg}</div>

                                <div style={{ fontWeight: 600 }}>
                                  Police Report
                                </div>
                                <div>{tdhDriverPoliceImg}</div>
                              </div>
                            }
                          >
                            <Info size={30} color={"#919191"} />
                          </TooltipIcon>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="two fields">
                        {tdhInspectionType === 1 ? (
                          <Input
                            label="Place of Inspected"
                            type="text"
                            blockPattern={/[#%]/g}
                            value={tdhInspectedPlace}
                            onChange={(e) =>
                              setTdhInspectedPlace(e.target.value)
                            }
                            disabled={
                              (persistedTdhStatus === 2 && editMode) ||
                              (persistedTdhStatus === 3 && editMode)
                            }
                          />
                        ) : (
                          ""
                        )}

                        {/* <Dropdown
                      label={"Cash/Credit"}
                      placeholder={"Cash/Credit"}
                      options={cashTypeOptions}
                      value={tdhCashCredit}
                      onChange={(e, data) => {
                        setTdhCashCredit(data.value);
                      }}
                      disabled={
                        (persistedTdhStatus === 2 && editMode) ||
                        (persistedTdhStatus === 3 && editMode)
                      }
                    /> */}

                        <SearchDropdown
                          key={1}
                          label={"Base Currency"}
                          defaultValue={userCurrencyCode || "Sri Lanka Rupee"}
                          reset={searchFieldReset}
                          setReset={setSearchFieldReset}
                          readOnly={true}
                        />
                        {/* <Dropdown
                      label={"Sub Action(Repair)"}
                      placeholder={"Sub Action"}
                      options={subActionOpt}
                      value={tdhSubAction}
                      onChange={(e, data) => {
                        setTdhSubAction(data.value);
                      }}
                      disabled={
                        (persistedTdhStatus === 2 && editMode) ||
                        (persistedTdhStatus === 3 && editMode)
                      }
                    /> */}

                        {/* <SearchDropdown
                      key={1}
                      editMode={editMode}
                      field="tdh_supplier"
                      label={"Supplier"}
                      placeholder={"Supplier"}
                      reset={searchFieldReset}
                      setReset={setSearchFieldReset}
                      clearable={true}
                      onClear={() => {
                        setTdhSupplier("");
                      }}
                      onResultSelect={(data) => {
                        setTdhSupplier(data);
                      }}
                      api={getOtherRefSearchDropdown}
                      apiDependency={{
                        type: "stakeholder_type",
                        value: "Supplier",
                      }}
                      fieldInfo={{
                        tableName: "masterdata.tms_m_stakeholder",
                        primaryKey: "stk_id",
                        fieldName: "stk_name",
                        id: tdhSupplier?.toString(),
                      }}
                      disabled={
                        (persistedTdhStatus === 2 && editMode) ||
                        (persistedTdhStatus === 3 && editMode)
                      }
                    /> */}
                      </div>
                    </div>
                  )}
                </div>
                <div
                  className="ui styled accordion"
                  style={{ width: "100%", marginBottom: "10px" }}
                >
                  <div
                    className={`title ${activeAccordionAlerts ? "active" : ""}`}
                    onClick={() =>
                      setActiveAccordionAlerts(!activeAccordionAlerts)
                    }
                  >
                    <i className="dropdown icon"></i> Alerts
                  </div>
                  {activeAccordionAlerts && (
                    <div className="content active">
                      <div className="two fields">
                        <Input
                          required={false}
                          label="Action Date"
                          type="date"
                          name="actionDate"
                          value={tdhActionDate}
                          onChange={(e) => setTdhActionDate(e.target.value)}
                          error={currentErrors.tdhActionDate}
                          resetError={() =>
                            setCurrentErrors((prevState) => {
                              const { tdhActionDate: _, ...rest } = prevState;
                              return rest;
                            })
                          }
                          disabled={
                            (persistedTdhStatus === 2 && editMode) ||
                            (persistedTdhStatus === 3 && editMode)
                          }
                        />
                        {tdhActionDate && tdhTemplate ? (
                          <TooltipIcon
                            popupClassName="auto-fit-popup"
                            style={{ paddingTop: "30px" }}
                            position="bottom left"
                            content={
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns:
                                    "max-content max-content",
                                  columnGap: 16,
                                  rowGap: 8,
                                  alignItems: "center",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <div style={{ fontWeight: 600 }}>
                                  Next Action Date
                                </div>
                                <div>{tdhNextDate}</div>

                                <div style={{ fontWeight: 600 }}>
                                  Next Inspection Value
                                </div>
                                <div>
                                  {tdhNextValue + " " + tdhNextUomValue}
                                </div>
                              </div>
                            }
                          >
                            <Info size={30} color={"#919191"} />
                          </TooltipIcon>
                        ) : (
                          ""
                        )}

                        <Input
                          required={false}
                          label="Milage"
                          type="number"
                          name="milage"
                          value={tdhMilage}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value < 0) {
                              toast.error("Please enter a valid number", {
                                autoClose: 5000,
                                containerId: "Main",
                              });
                              setTdhMilage("");
                            } else {
                              setTdhMilage(value || ""); // Ensure empty value doesn't break calculations
                            }
                          }}
                          error={currentErrors.tdhMillage}
                          resetError={() =>
                            setCurrentErrors((prevState) => {
                              const { tdhMillage: _, ...rest } = prevState;
                              return rest;
                            })
                          }
                          disabled={
                            (persistedTdhStatus === 2 && editMode) ||
                            (persistedTdhStatus === 3 && editMode)
                          }
                        />

                        {tdhMilage && tdhTemplate ? (
                          <TooltipIcon
                            popupClassName="auto-fit-popup"
                            style={{ paddingTop: "30px" }}
                            position="bottom left"
                            content={
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns:
                                    "max-content max-content",
                                  columnGap: 16,
                                  rowGap: 8,
                                  alignItems: "center",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <div style={{ fontWeight: 600 }}>
                                  Next Action Milage
                                </div>
                                <div>{nextActionKm}</div>

                                <div style={{ fontWeight: 600 }}>
                                  Next Milage
                                </div>
                                <div>{tdhNextMilage}</div>
                              </div>
                            }
                          >
                            <Info size={30} color={"#919191"} />
                          </TooltipIcon>
                        ) : (
                          ""
                        )}
                      </div>
                      {/* <div className="four fields">

                        <Input
                          required={false}
                          label="Next Action Date"
                          type="date"
                          name="nextActionDate"
                          value={tdhNextDate}
                          onChange={(e) => {
                            //user can not select past dates from action date
                            if (e.target.value < tdhActionDate) {
                              toast.error("Please select a valid date", {
                                autoClose: 5000,
                                containerId: "Main",
                              });
                              setTdhNextDate("");
                            } else {
                              setTdhNextDate(e.target.value);
                            }
                          }}
                          error={currentErrors.tdhNextDate}
                          resetError={() =>
                            setCurrentErrors((prevState) => {
                              const { tdhNextDate: _, ...rest } = prevState;
                              return rest;
                            })
                          }
                          min={tdhActionDate}
                          disabled={true}
                        />
                        <Input
                          required={false}
                          label="Next Inspection Value"
                          blockPattern={/[#%]/g}
                          type="text"
                          name="nextInspectionValue"
                          value={tdhNextValue}
                          onChange={(e) => setTdhNextValue(e.target.value)}
                          disabled={true}
                          error={currentErrors.tdhNextValue}
                          resetError={() =>
                            setCurrentErrors((prevState) => {
                              const { tdhNextValue: _, ...rest } = prevState;
                              return rest;
                            })
                          }
                        />
                        <Dropdown
                          required={false}
                          clearable
                          search={true}
                          options={uomOptions}
                          placeholder="UOM"
                          label="UOM"
                          value={tdhNextUom}
                          onChange={(e, data) => {
                            setTdhNextUom(data.value);
                          }}
                          disabled={true}
                          error={currentErrors.tdhNextUom}
                          resetError={() =>
                            setCurrentErrors((prevState) => {
                              const { tdhNextUom: _, ...rest } = prevState;
                              return rest;
                            })
                          }
                        />
                        <Input
                          required={false}
                          label="Next Action Milage"
                          type="number"
                          name="nextActionKm"
                          value={nextActionKm || 0}
                          error={currentErrors.nextActionKm}
                          resetError={() =>
                            setCurrentErrors((prevState) => {
                              const { tdhNextMillage: _, ...rest } = prevState;
                              return rest;
                            })
                          }
                          disabled={true}
                        />
                        <Input
                          required={false}
                          label="Next Milage"
                          type="number"
                          name="nextMilage"
                          value={tdhNextMilage}
                          error={currentErrors.tdhNextMillage}
                          resetError={() =>
                            setCurrentErrors((prevState) => {
                              const { tdhNextMillage: _, ...rest } = prevState;
                              return rest;
                            })
                          }
                          disabled={true}
                        />
                        <Dropdown
                          options={depreciationOptions?.current}
                          clearable={false}
                          placeholder="Yes/No"
                          label="Action taken"
                          value={tdhActionTaken}
                          onChange={(e, data) => {
                            setTdhActionTaken(data.value);
                          }}
                          error={currentErrors.tdhActionTaken}
                          resetError={() =>
                            setCurrentErrors((prevState) => {
                              const { tdhActionTaken: _, ...rest } = prevState;
                              return rest;
                            })
                          }
                          disabled={
                            (persistedTdhStatus === 2 && editMode) ||
                            (persistedTdhStatus === 3 && editMode)
                          }
                        />
                      </div> */}
                    </div>
                  )}
                </div>

                {/* <div
                  className="ui styled accordion"
                  style={{ width: "100%", marginBottom: "10px" }}
                >
                  <div
                    className={`title ${activeAccordionJobs ? "active" : ""}`}
                    onClick={() => setActiveAccordionJobs(!activeAccordionJobs)}
                  >
                    <i className="dropdown icon"></i> Jobs
                  </div>
                  {activeAccordionJobs && (
                    <div className="content active">
                      <div className="one field">
                        <SearchDropdown
                          key={1}
                          editMode={editMode}
                          reset={searchFieldReset}
                          setReset={setSearchFieldReset}
                          occupySpace={false}
                          multiple={true}
                          returnFullObject={true}
                          multiValueRemoveHandler={(key) => {
                            setSelectedJobs((prev) => {
                              const { [key]: _, ...rest } = prev;
                              return rest;
                            });
                          }}
                          onClear={() => setSelectedJobs([])}
                          onResultSelect={(data) => {
                            setSelectedJobs((prev) => ({
                              ...prev,
                              [data.key]: data.title,
                            }));
                            console.log("Selected Jobs: ", data);
                          }}
                          api={getJobSearchDropdown}
                          multiValueTwoWayBinding={true}
                          multiValues={selectedJobs}
                          disabled={
                            (editMode && persistedTdhStatus === 2) ||
                            (persistedTdhStatus === 3 && editMode)
                          }
                          label="Job"
                        />
                      </div>
                    </div>
                  )}
                </div> */}

                <div
                  className="ui styled accordion"
                  style={{ width: "100%", marginBottom: "10px" }}
                >
                  <div
                    className={`title ${activeAccordion1 ? "active" : ""}`}
                    onClick={() => handleAccordionClick1(!activeAccordion1)}
                  >
                    <div>
                      <i className="dropdown icon"></i>Dynamic Fields
                    </div>
                  </div>

                  <div
                    className={`content ${activeAccordion1 ? "active" : ""}`}
                  >
                    {dynamicFieldsLoading ? (
                      <LoadingSpinner />
                    ) : (
                      <div className="ui">
                        {/* Tab Menu (Fields & Items) */}
                        <div className="ui top attached tabular menu">
                          <div
                            className={`item ${activeTab === 1 ? "active" : ""} ${isItemListMissing ? "error-tab" : ""}`}
                            style={
                              isItemShown === false ? { display: "none" } : {}
                            }
                            onClick={() => setActiveTab(1)}
                          >
                            Items
                          </div>
                          <div
                            className={`item ${activeTab === 3 ? "active" : ""} ${isChargeListMissing ? "error-tab" : ""}`}
                            style={
                              isChargeShown === false ? { display: "none" } : {}
                            }
                            onClick={() => setActiveTab(3)}
                          >
                            Charges
                          </div>
                          <div
                            className={`item ${activeTab === 2 ? "active" : ""}`}
                            onClick={() => setActiveTab(2)}
                          >
                            Fields
                          </div>
                        </div>

                        {/* Tab Content */}
                        <div
                          className="ui bottom attached active tab segment"
                          style={
                            activeTab !== 1
                              ? { display: "none" }
                              : { minHeight: "300px" }
                          }
                        >
                          <>
                            {/* Additional Form for Items */}
                            <div className="two fields">
                              <SearchDropdown
                                key={1}
                                reset={searchDropdownItemListReset}
                                setReset={setSearchDropdownItemListReset}
                                clearable={true}
                                onClear={() => setItem(null)}
                                onResultSelect={(data) => {
                                  setItem({ id: data, name: "" }); // Set selected item
                                  addNewRowToGrid(data); // Call function to add row
                                }}
                                api={getOtherRefDetails}
                                apiDependency={{
                                  type: "item_type",
                                }}
                                label="Item"
                                disabled={
                                  (tdhStatus === 2 && editMode) ||
                                  isDm ||
                                  !isItemShown ||
                                  (tdhStatus === 3 && editMode)
                                }
                              />
                            </div>
                            <Grid
                              ref={dynamicGridRef}
                              searchable={false}
                              heading="Item List"
                              disabled={!hasItemField}
                              stopEditingWhenCellsLoseFocus={true}
                              onCellEditingStopped={onDynamicCellEditingStopped}
                              onCellDoubleClicked={cellDoubleClickHandler}
                              config={filteredGridConfig}
                              content={gridData} // Ensure gridData is passed here
                            />
                          </>
                        </div>
                        <div
                          className="ui bottom attached active tab segment"
                          style={
                            activeTab !== 3
                              ? { display: "none" }
                              : { minHeight: "300px" }
                          }
                        >
                          <>
                            {/* Additional Form for Charges */}
                            <div className="two fields">
                              <Dropdown
                                label="Charges"
                                options={chargesOptions}
                                search={true}
                                value={selectedCharge}
                                placeholder="Select Charge"
                                // onChange={(e, data) => {
                                //   setSelectedCharge(data.value);
                                //   chargeAddNewRowToGrid(data);
                                // }}
                                onChange={(e, data) => {
                                  setSelectedCharge(data.value);
                                  setSelectedChargeItem(null); // Reset item selection

                                  const selectedChargeData =
                                    chargesOptions.find(
                                      (c) => c.value === data.value,
                                    ) || {};

                                  if (
                                    selectedChargeData.items &&
                                    selectedChargeData.items.length === 0
                                  ) {
                                    // No items, directly add to grid
                                    chargeAddNewRowToGrid(selectedChargeData);
                                  } else if (
                                    selectedChargeData.items &&
                                    selectedChargeData.items.length > 0
                                  ) {
                                    // ⚡ Set charge items for item dropdown
                                    setChargeItemOptions(
                                      selectedChargeData.items,
                                    );
                                  }
                                }}
                                disabled={
                                  (tdhStatus === 2 && editMode) ||
                                  isDm ||
                                  !isChargeShown ||
                                  (tdhStatus === 3 && editMode)
                                }
                              />
                              {chargeItemOptions?.length > 0 && (
                                <Dropdown
                                  label="Charge Items"
                                  options={chargeItemOptions}
                                  search
                                  value={selectedChargeItem}
                                  placeholder="Select Charge Item"
                                  onChange={(e, data) => {
                                    setSelectedChargeItem(data.value);
                                    const item = chargeItemOptions?.find(
                                      (i) => i.value === data.value,
                                    );

                                    chargeItemAddNewRowToGrid(
                                      selectedCharge,
                                      item,
                                    );
                                  }}
                                  disabled={
                                    (persistedTdhStatus === 2 && editMode) ||
                                    (persistedTdhStatus === 3 && editMode)
                                  }
                                />
                              )}
                            </div>
                            <Grid
                              ref={dynamicGridRef}
                              searchable={false}
                              heading="Charge List"
                              disabled={!hasItemField}
                              stopEditingWhenCellsLoseFocus={true}
                              onCellEditingStopped={onDynamicCellEditingStopped}
                              onCellDoubleClicked={cellDoubleClickHandler}
                              config={filteredGridConfig}
                              content={chargeGridData} // Ensure gridData is passed here
                            />
                          </>
                        </div>

                        <div
                          className="ui bottom attached active tab segment"
                          style={
                            activeTab !== 2
                              ? { display: "none" }
                              : { minHeight: "300px" }
                          }
                        >
                          <>
                            <div className="ui dividing header">Field List</div>
                            {dynamicFields && dynamicFields.length > 0 ? (
                              dynamicFields.map((row, index) => (
                                <DynamicRow
                                  rowNo={index + 1}
                                  dyfId={row.dyfId}
                                  dyfField={row.dyfField}
                                  dyfFieldType={row.dyfFieldType}
                                  dyfRequired={row.dyfRequired}
                                  dfyAmount={row.dfyAmount}
                                  dfyDiscount={row.dfyDiscount}
                                  dfyAmountInfo={row.dfyAmountInfo}
                                  dfyDiscountInfo={row.dfyDiscountInfo}
                                  dynamicDropdowns={row.dynamicDropdowns}
                                  satisfyLevelOptions={satisfyLevelOptions}
                                  fieldStatusOptions={fieldStatusOptions}
                                  setDynamicFields={setDynamicFields}
                                  row={row}
                                  editMode={editMode}
                                  dynamicErrors={dynamicErrors}
                                  setDynamicErrors={setDynamicErrors}
                                  isDm={isDm}
                                  tdhStatus={persistedTdhStatus}
                                  dfyCommonDropdown={row.dfyCommonDropdown}
                                  tdhInspectionType={tdhInspectionType}
                                  showSatisfyLevel={row.showSatisfyLevel}
                                  showFieldStatus={row.showFieldStatus}
                                  showDescription={row.showDescription}
                                />
                              ))
                            ) : (
                              <center>No Dynamic Fields</center>
                            )}
                          </>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div
                  className="ui styled accordion"
                  style={{ width: "100%", marginBottom: "10px" }}
                >
                  <div
                    className={`title ${activeAccordionSummary ? "active" : ""}`}
                    onClick={() =>
                      setActiveAccordionSummary(!activeAccordionSummary)
                    }
                  >
                    <i className="dropdown icon"></i> Summary
                  </div>
                  {activeAccordionSummary && (
                    <div className="content active">
                      <h4 className="ui dividing header">Summary</h4>
                      <div className="fleet-summary-container">
                        <div className="fleet-description-summary">
                          {/*  description*/}
                          <TextArea
                            label="Description"
                            type="text"
                            name="description"
                            rows={12}
                            value={tdhDescription}
                            onChange={(e) =>
                              setTdhDescription(
                                e.target.value.replace(/#/g, ""),
                              )
                            }
                            // onChange={(e) => setTdhDescription(e.target.value)}
                            disabled={
                              isDm ||
                              (persistedTdhStatus === 2 && editMode) ||
                              (persistedTdhStatus === 3 && editMode)
                            }
                          />
                        </div>
                        <div className="fleet-amounts-summary">
                          {/* Currency Dropdown */}
                          <div className="fleet-field-css">
                            <label className="fleet-label">Currency</label>
                            <div className="wide twelve field">
                              <Dropdown
                                placeholder="Select Currency"
                                options={
                                  editMode
                                    ? exchangeRates
                                        .filter(
                                          (opt) =>
                                            opt.key === -1 ||
                                            opt.key === tdhExcId,
                                        )
                                        .map((opt) => ({
                                          key: opt.key,
                                          text:
                                            opt.key === -1
                                              ? opt.text
                                              : `${opt.text.split(":")[0].trim()} : Saved Rate: ${tdhExcRate}`,
                                          value: JSON.stringify({
                                            excId: opt.key,
                                            excRate:
                                              opt.key === -1 ? 1 : tdhExcRate,
                                            curCode: `${opt.text.split(":")[0].trim()} : Saved Rate: ${tdhExcRate}`,
                                          }),
                                          excId: opt.key,
                                          excRate:
                                            opt.key === -1 ? 1 : tdhExcRate,
                                          curCode: `${opt.text.split(":")[0].trim()} Saved Rate: ${tdhExcRate}`,
                                        }))
                                        .concat(
                                          // Add "Saved Currency" option if tdhExcId is set but not found
                                          tdhExcId !== -1 &&
                                            tdhExcId != null &&
                                            !exchangeRates.some(
                                              (ex) => ex.key === tdhExcId,
                                            )
                                            ? [
                                                {
                                                  key: "saved-currency",
                                                  value: JSON.stringify({
                                                    excId: tdhExcId,
                                                    excRate: tdhExcRate,
                                                    curCode: `Saved Currency: ${tdhExcRate}`,
                                                  }),
                                                  text: `Saved Currency: ${tdhExcRate}`,
                                                },
                                              ]
                                            : [],
                                        )
                                    : exchangeRates
                                }
                                clearable={false}
                                search={true}
                                value={selectedCurrency}
                                onChange={(e, data) => {
                                  setSelectedCurrency(data.value);
                                  const parsed = JSON.parse(data.value);
                                  setSelectedExchangeRate(parsed.excRate ?? "");
                                }}
                                disabled={
                                  (persistedTdhStatus === 2 && editMode) ||
                                  (persistedTdhStatus === 3 && editMode)
                                }
                              />
                            </div>
                          </div>
                          <div className="fleet-field-css">
                            <label className="fleet-label">
                              Amount<span style={{ color: "red" }}>*</span>
                            </label>
                            <div className="wide twelve field">
                              <Input
                                readOnly={true}
                                type="number"
                                step="0.01"
                                name="value"
                                value={previewAmount}
                                onChange={(e) => {
                                  let rawValue = e.target.value.replace(
                                    /[^0-9.]/g,
                                    "",
                                  ); // 🔥 Allow only numbers & decimals
                                  if (rawValue.split(".").length > 2) return; // ❌ Prevent multiple decimal points
                                  setTdhValue(rawValue); // ✅ Let user type freely
                                }}
                                onBlur={() => {
                                  if (!tdhValue || isNaN(tdhValue)) {
                                    setTdhValue("0.00"); // ❌ Prevent empty or NaN values
                                  } else {
                                    setTdhValue(
                                      parseFloat(tdhValue).toFixed(2),
                                    ); // ✅ Format to 2 decimal places on blur
                                  }
                                }}
                                error={currentErrors.tdhValue}
                                resetError={() =>
                                  setCurrentErrors((prevState) => {
                                    const { tdhValue: _, ...rest } = prevState;
                                    return rest;
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="fleet-field-css">
                            <label className="fleet-label">
                              Total Tax Amount
                            </label>
                            <div className="wide twelve field">
                              <Input
                                value={previewTax}
                                onChange={(e) =>
                                  setTdhTaxAmount(e.target.value)
                                }
                                type="text"
                                readOnly={true}
                              />
                            </div>
                          </div>

                          <div className="fleet-field-css">
                            <label className="fleet-label">Discount</label>
                            <div style={{ display: "flex", width: "75%" }}>
                              <div
                                className="wide sixteen field"
                                style={{ width: "100%" }}
                              >
                                <Input
                                  style={{ width: "100%" }}
                                  type="text"
                                  name="discount"
                                  step={0.01}
                                  value={previewDiscount}
                                  onChange={(e) =>
                                    setTdhDiscount(e.target.value)
                                  }
                                  error={currentErrors.tdhDiscount}
                                  resetError={() =>
                                    setCurrentErrors((prevState) => {
                                      const { tdhDiscount: _, ...rest } =
                                        prevState;
                                      return rest;
                                    })
                                  }
                                  readOnly={true}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="fleet-field-css">
                            <label className="fleet-label">Total</label>
                            <div className="wide twelve field">
                              <Input
                                readOnly={true}
                                type="text"
                                step={0.01}
                                name="total"
                                value={previewTotal}
                                onChange={(e) => setTdhTotal(e.target.value)}
                                error={currentErrors.tdhTotal}
                                onBlur={() => {
                                  if (!tdhTotal || isNaN(tdhTotal)) {
                                    setTdhTotal("0.00"); // ❌ Prevent empty or NaN values
                                  } else {
                                    setTdhTotal(
                                      parseFloat(tdhTotal).toFixed(2),
                                    ); // ✅ Format to 2 decimal places on blur
                                  }
                                }}
                                resetError={() =>
                                  setCurrentErrors((prevState) => {
                                    const { tdhTotal: _, ...rest } = prevState;
                                    return rest;
                                  })
                                }
                                disabled={
                                  (persistedTdhStatus === 2 && editMode) ||
                                  (persistedTdhStatus === 3 && editMode)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="four fields">
                        <Dropdown
                          required={!isDm}
                          label="Is depreciation enabled"
                          placeholder="Yes/No"
                          options={depreciationOptions?.current}
                          value={thdDepreciation}
                          onChange={(e, data) => {
                            setThdDepreciation(data.value);
                          }}
                          readOnly={isDm}
                          error={currentErrors.thdDepreciation}
                          resetError={() =>
                            setCurrentErrors((prevState) => {
                              const { thdDepreciation: _, ...rest } = prevState;
                              return rest;
                            })
                          }
                          disabled={
                            (persistedTdhStatus === 2 && editMode) ||
                            (persistedTdhStatus === 3 && editMode)
                          }
                        />
                        {!(!thdDepreciation || thdDepreciation !== 1) ? (
                          <Input
                            required={!isDm && thdDepreciation === 1}
                            label="Depreciation Value"
                            type="number"
                            step="0.01"
                            placeholder="Value"
                            value={thdDepreciationValue}
                            onChange={(e) =>
                              setThdDepreciationValue(e.target.value)
                            }
                            error={currentErrors.thdDepreciationValue}
                            resetError={() =>
                              setCurrentErrors((prevState) => {
                                const { thdDepreciationValue: _, ...rest } =
                                  prevState;
                                return rest;
                              })
                            }
                            disabled={
                              isDm ||
                              !thdDepreciation ||
                              thdDepreciation !== 1 ||
                              (persistedTdhStatus === 2 && editMode) ||
                              (persistedTdhStatus === 3 && editMode)
                            }
                          />
                        ) : null}

                        {!(!thdDepreciation || thdDepreciation !== 1) ? (
                          <Dropdown
                            required={!isDm && thdDepreciation === 1}
                            label="Depreciation UOM"
                            options={depUomOptions}
                            placeholder="Unit of Measurements"
                            value={thdDepreciationUom}
                            onChange={(e, data) => {
                              setThdDepreciationUom(data.value);
                            }}
                            error={currentErrors.thdDepreciationUom}
                            resetError={() =>
                              setCurrentErrors((prevState) => {
                                const { thdDepreciationUom: _, ...rest } =
                                  prevState;
                                return rest;
                              })
                            }
                            disabled={
                              isDm ||
                              !thdDepreciation ||
                              thdDepreciation !== 1 ||
                              (persistedTdhStatus === 2 && editMode) ||
                              (persistedTdhStatus === 3 && editMode)
                            }
                          />
                        ) : null}

                        {!(!thdDepreciation || thdDepreciation !== 1) ? (
                          <Input
                            required={!isDm && thdDepreciation === 1}
                            label="Depreciation execute date"
                            type="date"
                            value={thdDepreciationDate}
                            // onChange={(e) => setThdDepreciationDate(e.target.value)}
                            onChange={(e) => {
                              const newDate = e.target.value;
                              const minDate = editMode
                                ? createdDate
                                : new Date().toISOString().split("T")[0];

                              if (newDate < minDate) {
                                setThdDepreciationDate("");
                                // Set an error if newDate is before the allowed minimum
                                setCurrentErrors((prevState) => ({
                                  ...prevState,
                                  thdDepreciationDate: `Date must not be earlier than ${minDate}`,
                                }));
                              } else {
                                // Clear any previous error and set the new date
                                setThdDepreciationDate(newDate);
                                setCurrentErrors((prevState) => {
                                  const { thdDepreciationDate, ...rest } =
                                    prevState;
                                  return rest;
                                });
                              }
                            }}
                            error={currentErrors.thdDepreciationDate}
                            resetError={() =>
                              setCurrentErrors((prevState) => {
                                const { thdDepreciationDate: _, ...rest } =
                                  prevState;
                                return rest;
                              })
                            }
                            min={
                              !editMode
                                ? new Date().toISOString().split("T")[0]
                                : createdDate
                            }
                            disabled={
                              isDm ||
                              !thdDepreciation ||
                              thdDepreciation !== 1 ||
                              (persistedTdhStatus === 2 && editMode) ||
                              (persistedTdhStatus === 3 && editMode)
                            }
                          />
                        ) : null}
                      </div>
                    </div>
                  )}
                </div>

                <div
                  className="ui styled accordion"
                  style={{ width: "100%", marginBottom: "10px" }}
                >
                  <div
                    className={`title ${activeAccordionOverall ? "active" : ""}`}
                    onClick={() =>
                      setActiveAccordionOverall(!activeAccordionOverall)
                    }
                  >
                    <i className="dropdown icon"></i> Overall Status
                  </div>
                  {activeAccordionOverall && (
                    <div className="content active">
                      <h4 className="ui dividing header">Overall Status</h4>
                      <div className="two fields">
                        <Input
                          required={!isDm ? true : false}
                          label="Overall %"
                          type="number"
                          placeholder="0-100"
                          name="overall %"
                          value={tdhOverall}
                          onChange={(e) => {
                            //user can not type minus values and values greater than 100 and float values
                            if (
                              e.target.value < 0 ||
                              e.target.value > 100 ||
                              e.target.value.includes(".")
                            ) {
                              toast.error(
                                "Please enter a valid number between 0-100",
                                { autoClose: 5000, containerId: "Main" },
                              );
                              setTdhOverall(0);
                            } else {
                              setTdhOverall(e.target.value);
                            }
                          }}
                          error={currentErrors.tdhOverall}
                          resetError={() =>
                            setCurrentErrors((prevState) => {
                              const { tdhOverall: _, ...rest } = prevState;
                              return rest;
                            })
                          }
                          max={100}
                          min={0}
                          disabled={true}
                        />
                        <Dropdown
                          clearable
                          required={!isDm ? true : false}
                          search={true}
                          options={dropdownOptions.overallStatusOptions}
                          placeholder="Overall Status"
                          label="Overall Status"
                          value={tdhOverallStatus}
                          onChange={(e, data) => {
                            setTdhOverallStatus(data.value);
                          }}
                          error={currentErrors.tdhOverallStatus}
                          resetError={() =>
                            setCurrentErrors((prevState) => {
                              const { tdhOverallStatus: _, ...rest } =
                                prevState;
                              return rest;
                            })
                          }
                          disabled={
                            isDm ||
                            (persistedTdhStatus === 2 && editMode) ||
                            (persistedTdhStatus === 3 && editMode)
                          }
                        />
                      </div>
                      <div className="two fields">
                        <Dropdown
                          clearable
                          required={!isDm ? true : false}
                          search={true}
                          options={dropdownOptions?.inspectionStatusOptions}
                          placeholder="Status"
                          label="Status"
                          value={tdhStatus}
                          onChange={(e, data) => {
                            setTdhStatus(data.value);
                          }}
                          error={currentErrors.tdhStatus}
                          resetError={() =>
                            setCurrentErrors((prevState) => {
                              const { tdhStatus: _, ...rest } = prevState;
                              return rest;
                            })
                          }
                          disabled={
                            isDm || (persistedTdhStatus === 2 && editMode)
                          }
                        />

                        <Dropdown
                          clearable
                          required={!isDm ? true : false}
                          search={true}
                          options={activeOpt}
                          placeholder="Active"
                          label="Active"
                          value={tdhActive}
                          onChange={(e, data) => {
                            setTdhActive(data.value);
                          }}
                          error={currentErrors.tdhActive}
                          resetError={() =>
                            setCurrentErrors((prevState) => {
                              const { tdhActive: _, ...rest } = prevState;
                              return rest;
                            })
                          }
                          disabled={
                            isDm ||
                            (persistedTdhStatus === 2 && editMode) ||
                            (persistedTdhStatus === 3 && editMode)
                          }
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
          <div
            className="ui bottom attached tab segment"
            style={{ display: tab === 2 ? "block" : "none", width: "100%" }}
          >
            <DocumentUpload
              isLoading={dropdownValuesLoading}
              opeType={16}
              module={MODULES.Fleet}
              ref={documentRef}
              reference={tdhId}
              dropdown={{
                documentTypeOptions: documentTypeOptions,
                statusOptions: dropdownOptions.statusOpt,
                fileNameOptions: fileNameOptions,
                activeOptions: activeOpt,
              }}
              editMode={editMode}
              currentValues={editMode && documents !== null ? documents : null}
            />
          </div>
          <div
            className="ui bottom attached tab segment"
            style={{
              display: tab === 3 && editMode ? "block" : "none",
              width: "100%",
            }}
          >
            {infoLoading ? (
              <LoadingSpinner />
            ) : (
              <div className="ui form">
                <div className="ui segment">
                  <h4 className="ui dividing header">Cost Information</h4>

                  {infoLoading ? (
                    <LoadingSpinner />
                  ) : (
                    <Grid
                      searchable={false}
                      config={[
                        {
                          headerName: "Installment",
                          field: "fcdInstallment",
                        },
                        {
                          headerName: "Value",
                          field: "fcdValue",
                          valueFormatter: (params) => {
                            if (params.value == null) return "N/A";
                            return Number(params.value).toLocaleString(
                              "en-US",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            );
                          },
                        },
                        {
                          headerName: "Balance",
                          field: "fcdBalance",
                        },
                        {
                          headerName: "Description",
                          field: "fcdDescription",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },
                        {
                          headerName: "Payment Details",
                          field: "fcdPatymentDetails",
                          cellRenderer: ResizableScrollingTextRenderer,
                          minWidth: 300,
                          width: 300,
                        },
                        {
                          headerName: "Integrated Date",
                          field: "fcdIntigratedDate",
                        },
                        {
                          headerName: "Integrated Status",
                          field: "fcdIntigratedStatus",
                          cellStyle: { backgroundColor: "#D3BBDD" },
                        },
                        {
                          headerName: "Status",
                          field: "fcdStatusName",
                          cellStyle: { backgroundColor: "#fff9c4" },
                        },
                        {
                          headerName: "Active",
                          field: "fcdActiveName",
                          cellStyle: { backgroundColor: "#FF8A8A" },
                        },
                        {
                          headerName: "Created Date",
                          field: "createdDate",
                          minWidth: 250,
                          width: 250,
                        },
                        {
                          headerName: "Created By",
                          field: "createdBy",
                        },
                        {
                          field: "Delete",
                          cellRenderer: ButtonRenderer,
                          cellRendererParams: (params) => ({
                            clickHandler: () => {
                              if (params.data.fcdIntigrated !== 2 && !isDm) {
                                setDeletedList((prev) => [
                                  ...prev,
                                  params.data.fcdId,
                                ]);

                                // setFleetCharges((prev) =>
                                //   prev.filter(
                                //     (row) => row.fcdId !== params.data.fcdId
                                //   )
                                // );

                                setFleetCharges((prev) =>
                                  prev.map((row) => {
                                    if (row.fcdId === params.data.fcdId) {
                                      return {
                                        ...row,
                                        fcdActive: 2,
                                        fcdActiveName: "Deleted",
                                      };
                                    }
                                    return row;
                                  }),
                                );
                              } else if (params.data.fcdIntigrated === 2) {
                                toast.error(
                                  "Can not delete records whose Integration status is 'integrated'",
                                  { autoClose: 5000, containerId: "Main" },
                                );
                              } else if (isDm) {
                                toast.error("Can not delete in this screen.", {
                                  autoClose: 5000,
                                  containerId: "Main",
                                });
                              }
                            },
                            label: "Delete",
                            className: "ui red button",
                            authenticated: true,
                            form: isDm
                              ? FORMS.FLEET_UPDATE.COST.form
                              : FORMS.FLEET_INSPECTION_UPDATE.COST.form,
                            module: MODULES.Fleet,
                          }),
                        },
                      ]}
                      content={fleetCharges}
                      ref={gridRef}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: "1rem",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              padding: "1rem",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
              {tab > firstViableTab && tab < 2 && (
                <Button
                  template="back"
                  module={MODULES.Fleet}
                  section={isDm ? FORMS.FLEET : FORMS.FLEET_INSPECTION}
                  authenticated={true}
                  onClick={() => setTab(prev())}
                />
              )}

              {/* Green Print Button */}
              <Button
                type="button"
                template="custom"
                className="ui green button"
                isLoading={isPrintLoading}
                label="Print"
                Icon={Printer}
                onClick={() => onPrintClick()}
                disabled={
                  persistedTdhStatus !== 2 &&
                  persistedTdhStatus !== 3 &&
                  (isDm ? !documentPermissions : !inspectionPermissions)
                }
              />

              {tab < lastViableTab && (
                <Button
                  template="next"
                  module={MODULES.Fleet}
                  section={isDm ? FORMS.FLEET : FORMS.FLEET_INSPECTION}
                  authenticated={true}
                  onClick={nextButtonHandler}
                />
              )}

              {editMode ? (
                <Button
                  type="submit"
                  template="create"
                  isLoading={isSubmitLoading}
                  module={MODULES.Fleet}
                  form={
                    isDm
                      ? FORMS.FLEET.DOCUMENT_MANAGEMENT.form
                      : FORMS.FLEET_INSPECTION.INSPECTION_PROCESS.form
                  }
                  authenticated={true}
                  create={!editMode}
                  editMode={editMode}
                  onClick={() =>
                    isDm
                      ? documentCreationHandler()
                      : inspectionCreationHandler(false)
                  }
                />
              ) : tab === lastViableTab ? (
                <Button
                  type="submit"
                  template="create"
                  isLoading={isSubmitLoading}
                  module={MODULES.Fleet}
                  form={
                    isDm
                      ? FORMS.FLEET.DOCUMENT_MANAGEMENT.form
                      : FORMS.FLEET_INSPECTION.INSPECTION_PROCESS.form
                  }
                  authenticated={true}
                  create={!editMode}
                  editMode={editMode}
                  onClick={isDm ? documentCreationHandler : openModal}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>

      <Modal
        ref={currencyModalRef}
        closeButton={false}
        minWidth={"50vw"}
        minHeight={"50vh"}
      >
        <div
          className="ui form segment"
          style={{ height: "50vh", margin: "20px" }}
        >
          <Dropdown
            label="Currency"
            clearable={false}
            search={true}
            placeholder="Select Currency"
            options={exchangeRates}
            value={JSON.stringify(rowData?.exchangeData ?? "")}
            onChange={(e, data) => setExchangeRate(data)}
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingTop: "5px",
            paddingBottom: "5px",
            gap: "5px",
          }}
        >
          <Button
            Icon={X}
            label={"Cancel"}
            onClick={closeCurrencyModal}
            color="red"
          />
          <Button
            Icon={Check}
            label={"Ok"}
            onClick={() => {
              onCurrencyHandler(exchangeRate || {}, selectedRowIndex);

              if (isItemShown) {
                setGridData((prevState) =>
                  prevState.map((item) => {
                    const discount = item.tdfDiscount;

                    const { baseAmount, totalAmount } = calculateTotalAmount(
                      item.tdfQty,
                      item.unitPrice,
                      item.exchangeData?.excRate,
                      item.tdfTaxAmount,
                      discount,
                    );

                    return {
                      ...item,
                      tdfAmount: baseAmount,
                      tdfTotalAmount: totalAmount,
                    };
                  }),
                );
              } else if (isChargeShown) {
                setChargeGridData((prevState) =>
                  prevState.map((item) => {
                    const discount = item.tdfDiscount;

                    const { baseAmount, totalAmount } = calculateTotalAmount(
                      item.tdfQty,
                      item.unitPrice,
                      item.exchangeData?.excRate,
                      item.tdfTaxAmount,
                      discount,
                    );

                    return {
                      ...item,
                      tdfAmount: baseAmount,
                      tdfTotalAmount: totalAmount,
                    };
                  }),
                );
              }
            }}
          />
        </div>
      </Modal>

      <Modal ref={modalRef3} minWidth={"90vw"}>
        <h4 className="ui dividing header">More Columns</h4>
        <div>
          {selectedRow && (
            <Grid
              ref={dynamicGridRef}
              config={filteredModalGridConfig}
              content={[selectedRow]} // Pass selected row as data
              editable={true}
              onCellEditingStopped={handleModalGridEdit} // Update main gridData on edit
            />
          )}
        </div>
        <div className="extra content">
          <Button
            color="red"
            onClick={() => modalRef3.current.close()}
            label={"Close"}
          />
        </div>
      </Modal>

      <Modal
        ref={taxModalRef}
        onClose={closeTaxModal}
        style={{ height: "auto", minHeight: "300px" }}
      >
        <div style={{ height: "auto", minHeight: "300px" }}>
          <h4 className="ui dividing header">Add Tax</h4>
          <Dropdown
            label="Tax"
            search={true}
            options={taxOptions}
            onChange={(e, data) => {
              const selected = taxOptions.find(
                (opt) => opt.value === data.value,
              );
              if (selected) {
                handleAddTax({
                  taxId: selected.value,
                  taxName: selected.text,
                });
              }
            }}
          />

          <Grid
            heading="Tax Per Item"
            data={filteredTaxGridData}
            config={[
              { headerName: "Tax", field: "taxName" },
              { headerName: "Tax Rate", field: "taxRate" },
              {
                headerName: "Action",
                field: "action",
                cellRenderer: ButtonRenderer,
                cellRendererParams: (params) => ({
                  clickHandler: () => handleDeleteTax(params),
                  label: "Delete",
                }),
              },
            ]}
            content={filteredTaxGridData}
          />
          <Button
            label={"Close"}
            style={{ margin: "5px" }}
            onClick={closeTaxModal}
          />
        </div>
      </Modal>

      <Modal ref={baseCurrencyModalRef}>
        <h3 className="ui dividing header">Select Currency</h3>
        {isPrintLoading ? (
          <LoadingSpinner />
        ) : (
          <div className="ui card" style={{ width: "100%", padding: "20px" }}>
            <div className="ui form" style={{ minHeight: "350px" }}>
              <div className="fleet-field-css">
                <label className="fleet-label">Currency</label>
                <div className="wide twelve field">
                  <Dropdown
                    placeholder="Select Currency"
                    options={
                      editMode
                        ? exchangeRates
                            .filter(
                              (opt) => opt.key === -1 || opt.key === tdhExcId,
                            )
                            .map((opt) => ({
                              key: opt.key,
                              text:
                                opt.key === -1
                                  ? opt.text
                                  : `${opt.text.split(":")[0].trim()} : Saved Rate: ${tdhExcRate}`,
                              value: JSON.stringify({
                                excId: opt.key,
                                excRate: opt.key === -1 ? 1 : tdhExcRate,
                                curCode: `${opt.text.split(":")[0].trim()} : Saved Rate: ${tdhExcRate}`,
                              }),
                              excId: opt.key,
                              excRate: opt.key === -1 ? 1 : tdhExcRate,
                              curCode: `${opt.text.split(":")[0].trim()} : Saved Rate: ${tdhExcRate}`,
                            }))
                            .concat(
                              // Add "Saved Currency" option if tdhExcId is set but not found
                              tdhExcId !== -1 &&
                                tdhExcId != null &&
                                !exchangeRates.some((ex) => ex.key === tdhExcId)
                                ? [
                                    {
                                      key: "saved-currency",
                                      value: JSON.stringify({
                                        excId: tdhExcId,
                                        excRate: tdhExcRate,
                                        curCode: `Saved Currency: ${tdhExcRate}`,
                                      }),
                                      text: `Saved Currency: ${tdhExcRate}`,
                                    },
                                  ]
                                : [],
                            )
                        : exchangeRates
                    }
                    clearable={false}
                    search
                    value={printCurrency}
                    onChange={(e, data) => {
                      setPrintCurrency(data.value);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        <div
          className={"ui extra content"}
          style={{
            marginTop: "20px",
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
          }}
        >
          <button
            className="ui primary button"
            onClick={() => {
              handlePrintGeneralReport({
                tdhCode,
                tdhReferance,
                tdhCategory,
                tdhInspectionType,
                tdhTemplate,
                tdhRefId,
                tdhActionDate,
                tdhNextDate,
                tdhNextValue,
                tdhNextUom,
                tdhDescription,
                tdhOverall,
                tdhOverallStatus,
                tdhStatus,
                tdhActive,
                tdhTotal,
                tdhPercentage,
                tdhDiscount,
                tdhValue,
                thdDepreciation,
                thdDepreciationValue,
                thdDepreciationUom,
                thdDepreciationDate,
                dynamicFields,
                fleetCharges,
                createdBy,
                tdhApprovedBy,
              });
            }}
          >
            Continue
          </button>
          <button className="ui button" onClick={closeCurrencyModal}>
            Cancel
          </button>
        </div>
      </Modal>

      <Modal ref={modalRef} closeButton={false} minWidth={"100px"}>
        {!isDm ? (
          !editMode ? (
            tdhStatus !== 2 ? (
              notApprovedContent
            ) : (
              approvedContent
            )
          ) : (
            <></>
          )
        ) : !editMode ? (
          tdhStatus !== 1 ? (
            dmPendingContent
          ) : (
            <></>
          )
        ) : (
          <></>
        )}
      </Modal>

      <Modal ref={modalRef2} closeButton={false} minWidth={"100px"}>
        <div style={{ padding: "20px" }}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <h3 style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <AlertCircle color="red" size="25" />
              <p>Warning</p>{" "}
            </h3>
            <h3>
              {errorMessage ? errorMessage : "An inspection already exists."}
            </h3>
            <p>Are you sure you want to proceed?</p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingTop: "5px",
                paddingBottom: "5px",
                gap: "5px",
              }}
            >
              <Button Icon={X} label={"No"} onClick={closeModal2} color="red" />
              <Button
                Icon={Check}
                label={"Yes"}
                onClick={() => {
                  inspectionCreationHandler(true);
                }}
              />
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AddDocument;

const styles = `
  .blur-overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    z-index: 9999; /* Ensure it's on top of everything */
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .blurred {
    filter: blur(5px); /* Blur effect on content */
    pointer-events: none; /* Prevent interaction with blurred content */
  }
`;

document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);
